// Generated from .\Source\worker\app-workers\shared\models\grammar-with-annotation\DataflowParser.g4 by ANTLR 4.8
// jshint ignore: start
var antlr4 = require('antlr4/index');
var DataflowParserListener = require('../DataflowParserListener').DataflowParserListener;
var DataflowParserVisitor = require('../DataflowParserVisitor').DataflowParserVisitor;

var grammarFileName = "DataflowParser.g4";


var serializedATN = ["\u0003\u608b\ua72a\u8133\ub9ed\u417c\u3be7\u7786\u5964",
    "\u0003_\u02bc\u0004\u0002\t\u0002\u0004\u0003\t\u0003\u0004\u0004\t",
    "\u0004\u0004\u0005\t\u0005\u0004\u0006\t\u0006\u0004\u0007\t\u0007\u0004",
    "\b\t\b\u0004\t\t\t\u0004\n\t\n\u0004\u000b\t\u000b\u0004\f\t\f\u0004",
    "\r\t\r\u0004\u000e\t\u000e\u0004\u000f\t\u000f\u0004\u0010\t\u0010\u0004",
    "\u0011\t\u0011\u0004\u0012\t\u0012\u0004\u0013\t\u0013\u0004\u0014\t",
    "\u0014\u0004\u0015\t\u0015\u0004\u0016\t\u0016\u0004\u0017\t\u0017\u0004",
    "\u0018\t\u0018\u0004\u0019\t\u0019\u0004\u001a\t\u001a\u0004\u001b\t",
    "\u001b\u0004\u001c\t\u001c\u0004\u001d\t\u001d\u0004\u001e\t\u001e\u0004",
    "\u001f\t\u001f\u0004 \t \u0004!\t!\u0004\"\t\"\u0004#\t#\u0004$\t$\u0004",
    "%\t%\u0004&\t&\u0004\'\t\'\u0004(\t(\u0004)\t)\u0004*\t*\u0004+\t+\u0004",
    ",\t,\u0004-\t-\u0004.\t.\u0004/\t/\u00040\t0\u00041\t1\u00042\t2\u0004",
    "3\t3\u00044\t4\u00045\t5\u00046\t6\u00047\t7\u00048\t8\u00049\t9\u0004",
    ":\t:\u0004;\t;\u0004<\t<\u0004=\t=\u0003\u0002\u0003\u0002\u0003\u0002",
    "\u0003\u0002\u0005\u0002\u007f\n\u0002\u0003\u0003\u0003\u0003\u0003",
    "\u0004\u0003\u0004\u0003\u0005\u0003\u0005\u0003\u0006\u0003\u0006\u0003",
    "\u0007\u0003\u0007\u0003\b\u0003\b\u0003\t\u0003\t\u0003\t\u0003\t\u0003",
    "\t\u0003\t\u0003\t\u0003\t\u0005\t\u0095\n\t\u0003\n\u0003\n\u0005\n",
    "\u0099\n\n\u0003\u000b\u0003\u000b\u0005\u000b\u009d\n\u000b\u0003\f",
    "\u0003\f\u0003\r\u0003\r\u0005\r\u00a3\n\r\u0003\u000e\u0003\u000e\u0003",
    "\u000e\u0003\u000f\u0003\u000f\u0003\u0010\u0003\u0010\u0003\u0011\u0003",
    "\u0011\u0003\u0012\u0003\u0012\u0003\u0012\u0003\u0013\u0003\u0013\u0003",
    "\u0014\u0003\u0014\u0003\u0015\u0003\u0015\u0005\u0015\u00b7\n\u0015",
    "\u0003\u0016\u0003\u0016\u0003\u0016\u0003\u0016\u0003\u0016\u0007\u0016",
    "\u00be\n\u0016\f\u0016\u000e\u0016\u00c1\u000b\u0016\u0005\u0016\u00c3",
    "\n\u0016\u0003\u0016\u0003\u0016\u0003\u0017\u0003\u0017\u0003\u0017",
    "\u0003\u0017\u0003\u0017\u0005\u0017\u00cc\n\u0017\u0003\u0017\u0003",
    "\u0017\u0003\u0017\u0003\u0017\u0005\u0017\u00d2\n\u0017\u0007\u0017",
    "\u00d4\n\u0017\f\u0017\u000e\u0017\u00d7\u000b\u0017\u0005\u0017\u00d9",
    "\n\u0017\u0003\u0017\u0003\u0017\u0003\u0018\u0003\u0018\u0005\u0018",
    "\u00df\n\u0018\u0003\u0019\u0003\u0019\u0003\u0019\u0003\u0019\u0003",
    "\u0019\u0005\u0019\u00e6\n\u0019\u0003\u0019\u0003\u0019\u0005\u0019",
    "\u00ea\n\u0019\u0003\u0019\u0003\u0019\u0003\u001a\u0003\u001a\u0003",
    "\u001a\u0003\u001a\u0003\u001a\u0003\u001a\u0005\u001a\u00f4\n\u001a",
    "\u0003\u001a\u0003\u001a\u0003\u001a\u0003\u001a\u0003\u001a\u0003\u001a",
    "\u0007\u001a\u00fc\n\u001a\f\u001a\u000e\u001a\u00ff\u000b\u001a\u0005",
    "\u001a\u0101\n\u001a\u0003\u001a\u0003\u001a\u0003\u001b\u0003\u001b",
    "\u0003\u001b\u0003\u001c\u0003\u001c\u0003\u001c\u0003\u001d\u0003\u001d",
    "\u0003\u001d\u0003\u001d\u0003\u001d\u0005\u001d\u0110\n\u001d\u0003",
    "\u001e\u0003\u001e\u0003\u001e\u0003\u001e\u0003\u001e\u0003\u001e\u0003",
    "\u001e\u0003\u001e\u0003\u001e\u0003\u001e\u0003\u001e\u0003\u001e\u0005",
    "\u001e\u011e\n\u001e\u0003\u001e\u0003\u001e\u0003\u001e\u0005\u001e",
    "\u0123\n\u001e\u0007\u001e\u0125\n\u001e\f\u001e\u000e\u001e\u0128\u000b",
    "\u001e\u0003\u001e\u0003\u001e\u0003\u001e\u0003\u001e\u0003\u001e\u0003",
    "\u001e\u0003\u001e\u0003\u001e\u0003\u001e\u0003\u001e\u0003\u001e\u0003",
    "\u001e\u0003\u001e\u0003\u001e\u0003\u001e\u0003\u001e\u0003\u001e\u0003",
    "\u001e\u0003\u001e\u0007\u001e\u013d\n\u001e\f\u001e\u000e\u001e\u0140",
    "\u000b\u001e\u0003\u001e\u0003\u001e\u0003\u001e\u0003\u001e\u0003\u001e",
    "\u0003\u001e\u0003\u001e\u0003\u001e\u0003\u001e\u0003\u001e\u0003\u001e",
    "\u0003\u001e\u0007\u001e\u014e\n\u001e\f\u001e\u000e\u001e\u0151\u000b",
    "\u001e\u0003\u001e\u0003\u001e\u0003\u001e\u0003\u001e\u0003\u001e\u0007",
    "\u001e\u0158\n\u001e\f\u001e\u000e\u001e\u015b\u000b\u001e\u0003\u001e",
    "\u0003\u001e\u0003\u001e\u0005\u001e\u0160\n\u001e\u0003\u001e\u0003",
    "\u001e\u0003\u001e\u0003\u001e\u0003\u001e\u0003\u001e\u0003\u001e\u0003",
    "\u001e\u0003\u001e\u0003\u001e\u0003\u001e\u0003\u001e\u0003\u001e\u0003",
    "\u001e\u0003\u001e\u0003\u001e\u0003\u001e\u0003\u001e\u0003\u001e\u0003",
    "\u001e\u0003\u001e\u0003\u001e\u0003\u001e\u0003\u001e\u0003\u001e\u0003",
    "\u001e\u0003\u001e\u0003\u001e\u0003\u001e\u0003\u001e\u0003\u001e\u0003",
    "\u001e\u0003\u001e\u0003\u001e\u0007\u001e\u0184\n\u001e\f\u001e\u000e",
    "\u001e\u0187\u000b\u001e\u0003\u001f\u0003\u001f\u0005\u001f\u018b\n",
    "\u001f\u0003\u001f\u0003\u001f\u0003\u001f\u0003 \u0003 \u0003 \u0003",
    " \u0003!\u0003!\u0003!\u0003!\u0003\"\u0006\"\u0199\n\"\r\"\u000e\"",
    "\u019a\u0003#\u0003#\u0003#\u0003#\u0005#\u01a1\n#\u0003#\u0003#\u0007",
    "#\u01a5\n#\f#\u000e#\u01a8\u000b#\u0003$\u0003$\u0003%\u0003%\u0003",
    "%\u0003%\u0003%\u0005%\u01b1\n%\u0003&\u0003&\u0003\'\u0003\'\u0003",
    "\'\u0003\'\u0003(\u0005(\u01ba\n(\u0003(\u0003(\u0003(\u0003(\u0003",
    "(\u0003(\u0003(\u0003(\u0003(\u0003(\u0005(\u01c6\n(\u0003(\u0003(\u0003",
    "(\u0003(\u0003(\u0003(\u0003(\u0003(\u0003(\u0005(\u01d1\n(\u0007(\u01d3",
    "\n(\f(\u000e(\u01d6\u000b(\u0005(\u01d8\n(\u0003(\u0003(\u0003)\u0003",
    ")\u0003*\u0003*\u0003+\u0003+\u0003,\u0003,\u0003,\u0003,\u0003-\u0003",
    "-\u0003-\u0005-\u01e9\n-\u0003-\u0003-\u0003-\u0003-\u0005-\u01ef\n",
    "-\u0007-\u01f1\n-\f-\u000e-\u01f4\u000b-\u0003.\u0003.\u0003.\u0003",
    ".\u0003.\u0005.\u01fb\n.\u0003.\u0003.\u0003.\u0007.\u0200\n.\f.\u000e",
    ".\u0203\u000b.\u0003.\u0003.\u0003/\u0003/\u0003/\u0003/\u0003/\u0005",
    "/\u020c\n/\u0003/\u0003/\u0003/\u0007/\u0211\n/\f/\u000e/\u0214\u000b",
    "/\u0003/\u0003/\u00030\u00030\u00030\u00030\u00030\u00070\u021d\n0\f",
    "0\u000e0\u0220\u000b0\u00030\u00030\u00050\u0224\n0\u00031\u00051\u0227",
    "\n1\u00031\u00031\u00031\u00031\u00032\u00032\u00032\u00032\u00032\u0003",
    "2\u00032\u00032\u00032\u00032\u00032\u00032\u00032\u00032\u00032\u0003",
    "2\u00032\u00032\u00032\u00032\u00032\u00032\u00052\u0243\n2\u00033\u0003",
    "3\u00033\u00033\u00073\u0249\n3\f3\u000e3\u024c\u000b3\u00033\u0003",
    "3\u00034\u00034\u00034\u00034\u00034\u00034\u00034\u00034\u00034\u0005",
    "4\u0259\n4\u00034\u00034\u00074\u025d\n4\f4\u000e4\u0260\u000b4\u0003",
    "5\u00035\u00035\u00035\u00055\u0266\n5\u00036\u00036\u00036\u00036\u0003",
    "6\u00076\u026d\n6\f6\u000e6\u0270\u000b6\u00036\u00036\u00056\u0274",
    "\n6\u00037\u00037\u00057\u0278\n7\u00038\u00038\u00038\u00038\u0003",
    "9\u00039\u00039\u00039\u00059\u0282\n9\u0003:\u0003:\u0003:\u0003:\u0003",
    ":\u0007:\u0289\n:\f:\u000e:\u028c\u000b:\u0003:\u0003:\u0003;\u0003",
    ";\u0003;\u0003;\u0003;\u0007;\u0295\n;\f;\u000e;\u0298\u000b;\u0005",
    ";\u029a\n;\u0003;\u0003;\u0003;\u0003;\u0003;\u0003;\u0005;\u02a2\n",
    ";\u0003<\u0003<\u0003<\u0003<\u0003<\u0007<\u02a9\n<\f<\u000e<\u02ac",
    "\u000b<\u0003<\u0003<\u0003=\u0005=\u02b1\n=\u0003=\u0005=\u02b4\n=",
    "\u0003=\u0007=\u02b7\n=\f=\u000e=\u02ba\u000b=\u0003=\u0002\u0004:f",
    ">\u0002\u0004\u0006\b\n\f\u000e\u0010\u0012\u0014\u0016\u0018\u001a",
    "\u001c\u001e \"$&(*,.02468:<>@BDFHJLNPRTVXZ\\^`bdfhjlnprtvx\u0002\t",
    "\u0003\u0002\u0004\u0007\u0003\u000223\u0004\u0002=CEL\u0004\u0002\n",
    "\u000b**\u0003\u0002\b\t\u0003\u0002\u0011\u0014\u0003\u0002\u0018\u001b",
    "\u0002\u02fe\u0002~\u0003\u0002\u0002\u0002\u0004\u0080\u0003\u0002",
    "\u0002\u0002\u0006\u0082\u0003\u0002\u0002\u0002\b\u0084\u0003\u0002",
    "\u0002\u0002\n\u0086\u0003\u0002\u0002\u0002\f\u0088\u0003\u0002\u0002",
    "\u0002\u000e\u008a\u0003\u0002\u0002\u0002\u0010\u0094\u0003\u0002\u0002",
    "\u0002\u0012\u0098\u0003\u0002\u0002\u0002\u0014\u009c\u0003\u0002\u0002",
    "\u0002\u0016\u009e\u0003\u0002\u0002\u0002\u0018\u00a2\u0003\u0002\u0002",
    "\u0002\u001a\u00a4\u0003\u0002\u0002\u0002\u001c\u00a7\u0003\u0002\u0002",
    "\u0002\u001e\u00a9\u0003\u0002\u0002\u0002 \u00ab\u0003\u0002\u0002",
    "\u0002\"\u00ad\u0003\u0002\u0002\u0002$\u00b0\u0003\u0002\u0002\u0002",
    "&\u00b2\u0003\u0002\u0002\u0002(\u00b6\u0003\u0002\u0002\u0002*\u00b8",
    "\u0003\u0002\u0002\u0002,\u00c6\u0003\u0002\u0002\u0002.\u00de\u0003",
    "\u0002\u0002\u00020\u00e9\u0003\u0002\u0002\u00022\u00f3\u0003\u0002",
    "\u0002\u00024\u0104\u0003\u0002\u0002\u00026\u0107\u0003\u0002\u0002",
    "\u00028\u010f\u0003\u0002\u0002\u0002:\u015f\u0003\u0002\u0002\u0002",
    "<\u018a\u0003\u0002\u0002\u0002>\u018f\u0003\u0002\u0002\u0002@\u0193",
    "\u0003\u0002\u0002\u0002B\u0198\u0003\u0002\u0002\u0002D\u019c\u0003",
    "\u0002\u0002\u0002F\u01a9\u0003\u0002\u0002\u0002H\u01ab\u0003\u0002",
    "\u0002\u0002J\u01b2\u0003\u0002\u0002\u0002L\u01b4\u0003\u0002\u0002",
    "\u0002N\u01b9\u0003\u0002\u0002\u0002P\u01db\u0003\u0002\u0002\u0002",
    "R\u01dd\u0003\u0002\u0002\u0002T\u01df\u0003\u0002\u0002\u0002V\u01e1",
    "\u0003\u0002\u0002\u0002X\u01e8\u0003\u0002\u0002\u0002Z\u01f5\u0003",
    "\u0002\u0002\u0002\\\u0206\u0003\u0002\u0002\u0002^\u0217\u0003\u0002",
    "\u0002\u0002`\u0226\u0003\u0002\u0002\u0002b\u0242\u0003\u0002\u0002",
    "\u0002d\u0244\u0003\u0002\u0002\u0002f\u0258\u0003\u0002\u0002\u0002",
    "h\u0261\u0003\u0002\u0002\u0002j\u0273\u0003\u0002\u0002\u0002l\u0275",
    "\u0003\u0002\u0002\u0002n\u0279\u0003\u0002\u0002\u0002p\u027d\u0003",
    "\u0002\u0002\u0002r\u0283\u0003\u0002\u0002\u0002t\u028f\u0003\u0002",
    "\u0002\u0002v\u02a3\u0003\u0002\u0002\u0002x\u02b0\u0003\u0002\u0002",
    "\u0002z\u007f\u0005\u0004\u0003\u0002{\u007f\u0005\f\u0007\u0002|\u007f",
    "\u00074\u0002\u0002}\u007f\u00075\u0002\u0002~z\u0003\u0002\u0002\u0002",
    "~{\u0003\u0002\u0002\u0002~|\u0003\u0002\u0002\u0002~}\u0003\u0002\u0002",
    "\u0002\u007f\u0003\u0003\u0002\u0002\u0002\u0080\u0081\t\u0002\u0002",
    "\u0002\u0081\u0005\u0003\u0002\u0002\u0002\u0082\u0083\u0007\u0004\u0002",
    "\u0002\u0083\u0007\u0003\u0002\u0002\u0002\u0084\u0085\u00074\u0002",
    "\u0002\u0085\t\u0003\u0002\u0002\u0002\u0086\u0087\u00074\u0002\u0002",
    "\u0087\u000b\u0003\u0002\u0002\u0002\u0088\u0089\t\u0003\u0002\u0002",
    "\u0089\r\u0003\u0002\u0002\u0002\u008a\u008b\t\u0004\u0002\u0002\u008b",
    "\u000f\u0003\u0002\u0002\u0002\u008c\u0095\u00076\u0002\u0002\u008d",
    "\u0095\u00077\u0002\u0002\u008e\u0095\u00078\u0002\u0002\u008f\u0095",
    "\u00079\u0002\u0002\u0090\u0095\u0007:\u0002\u0002\u0091\u0095\u0007",
    ";\u0002\u0002\u0092\u0095\u0007<\u0002\u0002\u0093\u0095\u0005\u000e",
    "\b\u0002\u0094\u008c\u0003\u0002\u0002\u0002\u0094\u008d\u0003\u0002",
    "\u0002\u0002\u0094\u008e\u0003\u0002\u0002\u0002\u0094\u008f\u0003\u0002",
    "\u0002\u0002\u0094\u0090\u0003\u0002\u0002\u0002\u0094\u0091\u0003\u0002",
    "\u0002\u0002\u0094\u0092\u0003\u0002\u0002\u0002\u0094\u0093\u0003\u0002",
    "\u0002\u0002\u0095\u0011\u0003\u0002\u0002\u0002\u0096\u0099\u0007M",
    "\u0002\u0002\u0097\u0099\u0005\u0010\t\u0002\u0098\u0096\u0003\u0002",
    "\u0002\u0002\u0098\u0097\u0003\u0002\u0002\u0002\u0099\u0013\u0003\u0002",
    "\u0002\u0002\u009a\u009d\u0007O\u0002\u0002\u009b\u009d\u0005\u0010",
    "\t\u0002\u009c\u009a\u0003\u0002\u0002\u0002\u009c\u009b\u0003\u0002",
    "\u0002\u0002\u009d\u0015\u0003\u0002\u0002\u0002\u009e\u009f\u0005\u0012",
    "\n\u0002\u009f\u0017\u0003\u0002\u0002\u0002\u00a0\u00a3\u0005\u0012",
    "\n\u0002\u00a1\u00a3\u0005\u0014\u000b\u0002\u00a2\u00a0\u0003\u0002",
    "\u0002\u0002\u00a2\u00a1\u0003\u0002\u0002\u0002\u00a3\u0019\u0003\u0002",
    "\u0002\u0002\u00a4\u00a5\u0007\u000f\u0002\u0002\u00a5\u00a6\u0005\u0012",
    "\n\u0002\u00a6\u001b\u0003\u0002\u0002\u0002\u00a7\u00a8\u0007Q\u0002",
    "\u0002\u00a8\u001d\u0003\u0002\u0002\u0002\u00a9\u00aa\u0007R\u0002",
    "\u0002\u00aa\u001f\u0003\u0002\u0002\u0002\u00ab\u00ac\u0007P\u0002",
    "\u0002\u00ac!\u0003\u0002\u0002\u0002\u00ad\u00ae\u0007#\u0002\u0002",
    "\u00ae\u00af\u0005\u0012\n\u0002\u00af#\u0003\u0002\u0002\u0002\u00b0",
    "\u00b1\u0005\u0012\n\u0002\u00b1%\u0003\u0002\u0002\u0002\u00b2\u00b3",
    "\u0005\u0012\n\u0002\u00b3\'\u0003\u0002\u0002\u0002\u00b4\u00b7\u0007",
    "M\u0002\u0002\u00b5\u00b7\u0005\u0010\t\u0002\u00b6\u00b4\u0003\u0002",
    "\u0002\u0002\u00b6\u00b5\u0003\u0002\u0002\u0002\u00b7)\u0003\u0002",
    "\u0002\u0002\u00b8\u00b9\u0005\u0012\n\u0002\u00b9\u00c2\u0007!\u0002",
    "\u0002\u00ba\u00bf\u0005:\u001e\u0002\u00bb\u00bc\u0007$\u0002\u0002",
    "\u00bc\u00be\u0005:\u001e\u0002\u00bd\u00bb\u0003\u0002\u0002\u0002",
    "\u00be\u00c1\u0003\u0002\u0002\u0002\u00bf\u00bd\u0003\u0002\u0002\u0002",
    "\u00bf\u00c0\u0003\u0002\u0002\u0002\u00c0\u00c3\u0003\u0002\u0002\u0002",
    "\u00c1\u00bf\u0003\u0002\u0002\u0002\u00c2\u00ba\u0003\u0002\u0002\u0002",
    "\u00c2\u00c3\u0003\u0002\u0002\u0002\u00c3\u00c4\u0003\u0002\u0002\u0002",
    "\u00c4\u00c5\u0007\"\u0002\u0002\u00c5+\u0003\u0002\u0002\u0002\u00c6",
    "\u00c7\u0005\u0012\n\u0002\u00c7\u00d8\u0007!\u0002\u0002\u00c8\u00cc",
    "\u0005:\u001e\u0002\u00c9\u00cc\u0005<\u001f\u0002\u00ca\u00cc\u0005",
    "@!\u0002\u00cb\u00c8\u0003\u0002\u0002\u0002\u00cb\u00c9\u0003\u0002",
    "\u0002\u0002\u00cb\u00ca\u0003\u0002\u0002\u0002\u00cc\u00d5\u0003\u0002",
    "\u0002\u0002\u00cd\u00d1\u0007$\u0002\u0002\u00ce\u00d2\u0005:\u001e",
    "\u0002\u00cf\u00d2\u0005<\u001f\u0002\u00d0\u00d2\u0005@!\u0002\u00d1",
    "\u00ce\u0003\u0002\u0002\u0002\u00d1\u00cf\u0003\u0002\u0002\u0002\u00d1",
    "\u00d0\u0003\u0002\u0002\u0002\u00d2\u00d4\u0003\u0002\u0002\u0002\u00d3",
    "\u00cd\u0003\u0002\u0002\u0002\u00d4\u00d7\u0003\u0002\u0002\u0002\u00d5",
    "\u00d3\u0003\u0002\u0002\u0002\u00d5\u00d6\u0003\u0002\u0002\u0002\u00d6",
    "\u00d9\u0003\u0002\u0002\u0002\u00d7\u00d5\u0003\u0002\u0002\u0002\u00d8",
    "\u00cb\u0003\u0002\u0002\u0002\u00d8\u00d9\u0003\u0002\u0002\u0002\u00d9",
    "\u00da\u0003\u0002\u0002\u0002\u00da\u00db\u0007\"\u0002\u0002\u00db",
    "-\u0003\u0002\u0002\u0002\u00dc\u00df\u0005\u0012\n\u0002\u00dd\u00df",
    "\u0005\u0014\u000b\u0002\u00de\u00dc\u0003\u0002\u0002\u0002\u00de\u00dd",
    "\u0003\u0002\u0002\u0002\u00df/\u0003\u0002\u0002\u0002\u00e0\u00e1",
    "\u0007\\\u0002\u0002\u00e1\u00e5\u0005P)\u0002\u00e2\u00e3\u0007\u000e",
    "\u0002\u0002\u00e3\u00e4\u0007\\\u0002\u0002\u00e4\u00e6\u0005T+\u0002",
    "\u00e5\u00e2\u0003\u0002\u0002\u0002\u00e5\u00e6\u0003\u0002\u0002\u0002",
    "\u00e6\u00e7\u0003\u0002\u0002\u0002\u00e7\u00e8\u0007\u000e\u0002\u0002",
    "\u00e8\u00ea\u0003\u0002\u0002\u0002\u00e9\u00e0\u0003\u0002\u0002\u0002",
    "\u00e9\u00ea\u0003\u0002\u0002\u0002\u00ea\u00eb\u0003\u0002\u0002\u0002",
    "\u00eb\u00ec\u0005.\u0018\u0002\u00ec1\u0003\u0002\u0002\u0002\u00ed",
    "\u00f4\u0005P)\u0002\u00ee\u00ef\u0007\\\u0002\u0002\u00ef\u00f0\u0005",
    "P)\u0002\u00f0\u00f1\u0007\u000e\u0002\u0002\u00f1\u00f2\u0005T+\u0002",
    "\u00f2\u00f4\u0003\u0002\u0002\u0002\u00f3\u00ed\u0003\u0002\u0002\u0002",
    "\u00f3\u00ee\u0003\u0002\u0002\u0002\u00f4\u00f5\u0003\u0002\u0002\u0002",
    "\u00f5\u00f6\u0007#\u0002\u0002\u00f6\u00f7\u0005\u0012\n\u0002\u00f7",
    "\u0100\u0007!\u0002\u0002\u00f8\u00fd\u0005:\u001e\u0002\u00f9\u00fa",
    "\u0007$\u0002\u0002\u00fa\u00fc\u0005:\u001e\u0002\u00fb\u00f9\u0003",
    "\u0002\u0002\u0002\u00fc\u00ff\u0003\u0002\u0002\u0002\u00fd\u00fb\u0003",
    "\u0002\u0002\u0002\u00fd\u00fe\u0003\u0002\u0002\u0002\u00fe\u0101\u0003",
    "\u0002\u0002\u0002\u00ff\u00fd\u0003\u0002\u0002\u0002\u0100\u00f8\u0003",
    "\u0002\u0002\u0002\u0100\u0101\u0003\u0002\u0002\u0002\u0101\u0102\u0003",
    "\u0002\u0002\u0002\u0102\u0103\u0007\"\u0002\u0002\u01033\u0003\u0002",
    "\u0002\u0002\u0104\u0105\u0007\u001f\u0002\u0002\u0105\u0106\u0005.",
    "\u0018\u0002\u01065\u0003\u0002\u0002\u0002\u0107\u0108\u0007\r\u0002",
    "\u0002\u0108\u0109\u0005\u0012\n\u0002\u01097\u0003\u0002\u0002\u0002",
    "\u010a\u0110\u0007V\u0002\u0002\u010b\u010c\u0007W\u0002\u0002\u010c",
    "\u010d\u0005:\u001e\u0002\u010d\u010e\u0007\'\u0002\u0002\u010e\u0110",
    "\u0003\u0002\u0002\u0002\u010f\u010a\u0003\u0002\u0002\u0002\u010f\u010b",
    "\u0003\u0002\u0002\u0002\u01109\u0003\u0002\u0002\u0002\u0111\u0112",
    "\b\u001e\u0001\u0002\u0112\u0113\u0007!\u0002\u0002\u0113\u0114\u0005",
    ":\u001e\u0002\u0114\u0115\u0007\"\u0002\u0002\u0115\u0160\u0003\u0002",
    "\u0002\u0002\u0116\u0117\u0007\t\u0002\u0002\u0117\u0160\u0005:\u001e",
    "\u001f\u0118\u0119\u0007\f\u0002\u0002\u0119\u0160\u0005:\u001e\u001e",
    "\u011a\u011d\u0007,\u0002\u0002\u011b\u011e\u0005:\u001e\u0002\u011c",
    "\u011e\u0005<\u001f\u0002\u011d\u011b\u0003\u0002\u0002\u0002\u011d",
    "\u011c\u0003\u0002\u0002\u0002\u011e\u0126\u0003\u0002\u0002\u0002\u011f",
    "\u0122\u0007$\u0002\u0002\u0120\u0123\u0005:\u001e\u0002\u0121\u0123",
    "\u0005<\u001f\u0002\u0122\u0120\u0003\u0002\u0002\u0002\u0122\u0121",
    "\u0003\u0002\u0002\u0002\u0123\u0125\u0003\u0002\u0002\u0002\u0124\u011f",
    "\u0003\u0002\u0002\u0002\u0125\u0128\u0003\u0002\u0002\u0002\u0126\u0124",
    "\u0003\u0002\u0002\u0002\u0126\u0127\u0003\u0002\u0002\u0002\u0127\u0129",
    "\u0003\u0002\u0002\u0002\u0128\u0126\u0003\u0002\u0002\u0002\u0129\u012a",
    "\u0007\"\u0002\u0002\u012a\u0160\u0003\u0002\u0002\u0002\u012b\u0160",
    "\u00050\u0019\u0002\u012c\u0160\u00056\u001c\u0002\u012d\u0160\u0005",
    "\u001a\u000e\u0002\u012e\u0160\u00054\u001b\u0002\u012f\u0160\u0005",
    "*\u0016\u0002\u0130\u0131\u0007[\u0002\u0002\u0131\u0160\u0005,\u0017",
    "\u0002\u0132\u0160\u0005\u001c\u000f\u0002\u0133\u0160\u0005\u001e\u0010",
    "\u0002\u0134\u0160\u0005 \u0011\u0002\u0135\u0160\u0005\"\u0012\u0002",
    "\u0136\u0160\u00052\u001a\u0002\u0137\u0160\u0005\u0002\u0002\u0002",
    "\u0138\u0139\u0007(\u0002\u0002\u0139\u013e\u0005:\u001e\u0002\u013a",
    "\u013b\u0007$\u0002\u0002\u013b\u013d\u0005:\u001e\u0002\u013c\u013a",
    "\u0003\u0002\u0002\u0002\u013d\u0140\u0003\u0002\u0002\u0002\u013e\u013c",
    "\u0003\u0002\u0002\u0002\u013e\u013f\u0003\u0002\u0002\u0002\u013f\u0141",
    "\u0003\u0002\u0002\u0002\u0140\u013e\u0003\u0002\u0002\u0002\u0141\u0142",
    "\u0007)\u0002\u0002\u0142\u0160\u0003\u0002\u0002\u0002\u0143\u0144",
    "\u0007(\u0002\u0002\u0144\u0145\u0005:\u001e\u0002\u0145\u0146\u0007",
    "%\u0002\u0002\u0146\u0147\u0005:\u001e\u0002\u0147\u014f\u0003\u0002",
    "\u0002\u0002\u0148\u0149\u0007$\u0002\u0002\u0149\u014a\u0005:\u001e",
    "\u0002\u014a\u014b\u0007%\u0002\u0002\u014b\u014c\u0005:\u001e\u0002",
    "\u014c\u014e\u0003\u0002\u0002\u0002\u014d\u0148\u0003\u0002\u0002\u0002",
    "\u014e\u0151\u0003\u0002\u0002\u0002\u014f\u014d\u0003\u0002\u0002\u0002",
    "\u014f\u0150\u0003\u0002\u0002\u0002\u0150\u0152\u0003\u0002\u0002\u0002",
    "\u0151\u014f\u0003\u0002\u0002\u0002\u0152\u0153\u0007)\u0002\u0002",
    "\u0153\u0160\u0003\u0002\u0002\u0002\u0154\u0160\u0007-\u0002\u0002",
    "\u0155\u0159\u0007U\u0002\u0002\u0156\u0158\u00058\u001d\u0002\u0157",
    "\u0156\u0003\u0002\u0002\u0002\u0158\u015b\u0003\u0002\u0002\u0002\u0159",
    "\u0157\u0003\u0002\u0002\u0002\u0159\u015a\u0003\u0002\u0002\u0002\u015a",
    "\u015c\u0003\u0002\u0002\u0002\u015b\u0159\u0003\u0002\u0002\u0002\u015c",
    "\u0160\u0007U\u0002\u0002\u015d\u015e\u0007X\u0002\u0002\u015e\u0160",
    "\u0005:\u001e\u0004\u015f\u0111\u0003\u0002\u0002\u0002\u015f\u0116",
    "\u0003\u0002\u0002\u0002\u015f\u0118\u0003\u0002\u0002\u0002\u015f\u011a",
    "\u0003\u0002\u0002\u0002\u015f\u012b\u0003\u0002\u0002\u0002\u015f\u012c",
    "\u0003\u0002\u0002\u0002\u015f\u012d\u0003\u0002\u0002\u0002\u015f\u012e",
    "\u0003\u0002\u0002\u0002\u015f\u012f\u0003\u0002\u0002\u0002\u015f\u0130",
    "\u0003\u0002\u0002\u0002\u015f\u0132\u0003\u0002\u0002\u0002\u015f\u0133",
    "\u0003\u0002\u0002\u0002\u015f\u0134\u0003\u0002\u0002\u0002\u015f\u0135",
    "\u0003\u0002\u0002\u0002\u015f\u0136\u0003\u0002\u0002\u0002\u015f\u0137",
    "\u0003\u0002\u0002\u0002\u015f\u0138\u0003\u0002\u0002\u0002\u015f\u0143",
    "\u0003\u0002\u0002\u0002\u015f\u0154\u0003\u0002\u0002\u0002\u015f\u0155",
    "\u0003\u0002\u0002\u0002\u015f\u015d\u0003\u0002\u0002\u0002\u0160\u0185",
    "\u0003\u0002\u0002\u0002\u0161\u0162\f\u001c\u0002\u0002\u0162\u0163",
    "\t\u0005\u0002\u0002\u0163\u0184\u0005:\u001e\u001d\u0164\u0165\f\u001b",
    "\u0002\u0002\u0165\u0166\t\u0006\u0002\u0002\u0166\u0184\u0005:\u001e",
    "\u001c\u0167\u0168\f\u001a\u0002\u0002\u0168\u0169\t\u0007\u0002\u0002",
    "\u0169\u0184\u0005:\u001e\u001b\u016a\u016b\f\u0019\u0002\u0002\u016b",
    "\u016c\t\b\u0002\u0002\u016c\u0184\u0005:\u001e\u001a\u016d\u016e\f",
    "\u0018\u0002\u0002\u016e\u016f\u0007\u001c\u0002\u0002\u016f\u0184\u0005",
    ":\u001e\u0019\u0170\u0171\f\u0017\u0002\u0002\u0171\u0172\u0007\u001e",
    "\u0002\u0002\u0172\u0184\u0005:\u001e\u0018\u0173\u0174\f\u0016\u0002",
    "\u0002\u0174\u0175\u0007\u001d\u0002\u0002\u0175\u0184\u0005:\u001e",
    "\u0017\u0176\u0177\f!\u0002\u0002\u0177\u0178\u0007 \u0002\u0002\u0178",
    "\u0184\u0005.\u0018\u0002\u0179\u017a\f \u0002\u0002\u017a\u017b\u0007",
    "(\u0002\u0002\u017b\u017c\u0005:\u001e\u0002\u017c\u017d\u0007)\u0002",
    "\u0002\u017d\u0184\u0003\u0002\u0002\u0002\u017e\u017f\f\u001d\u0002",
    "\u0002\u017f\u0180\u0007\u0010\u0002\u0002\u0180\u0184\u0005l7\u0002",
    "\u0181\u0182\f\u0003\u0002\u0002\u0182\u0184\u0007X\u0002\u0002\u0183",
    "\u0161\u0003\u0002\u0002\u0002\u0183\u0164\u0003\u0002\u0002\u0002\u0183",
    "\u0167\u0003\u0002\u0002\u0002\u0183\u016a\u0003\u0002\u0002\u0002\u0183",
    "\u016d\u0003\u0002\u0002\u0002\u0183\u0170\u0003\u0002\u0002\u0002\u0183",
    "\u0173\u0003\u0002\u0002\u0002\u0183\u0176\u0003\u0002\u0002\u0002\u0183",
    "\u0179\u0003\u0002\u0002\u0002\u0183\u017e\u0003\u0002\u0002\u0002\u0183",
    "\u0181\u0003\u0002\u0002\u0002\u0184\u0187\u0003\u0002\u0002\u0002\u0185",
    "\u0183\u0003\u0002\u0002\u0002\u0185\u0186\u0003\u0002\u0002\u0002\u0186",
    ";\u0003\u0002\u0002\u0002\u0187\u0185\u0003\u0002\u0002\u0002\u0188",
    "\u018b\u0005\u0018\r\u0002\u0189\u018b\u00056\u001c\u0002\u018a\u0188",
    "\u0003\u0002\u0002\u0002\u018a\u0189\u0003\u0002\u0002\u0002\u018b\u018c",
    "\u0003\u0002\u0002\u0002\u018c\u018d\u0007\u0016\u0002\u0002\u018d\u018e",
    "\u0005:\u001e\u0002\u018e=\u0003\u0002\u0002\u0002\u018f\u0190\u0005",
    "\u0018\r\u0002\u0190\u0191\u0007\u0017\u0002\u0002\u0191\u0192\u0005",
    ":\u001e\u0002\u0192?\u0003\u0002\u0002\u0002\u0193\u0194\u0005:\u001e",
    "\u0002\u0194\u0195\u0007\u0016\u0002\u0002\u0195\u0196\u0005:\u001e",
    "\u0002\u0196A\u0003\u0002\u0002\u0002\u0197\u0199\u0005D#\u0002\u0198",
    "\u0197\u0003\u0002\u0002\u0002\u0199\u019a\u0003\u0002\u0002\u0002\u019a",
    "\u0198\u0003\u0002\u0002\u0002\u019a\u019b\u0003\u0002\u0002\u0002\u019b",
    "C\u0003\u0002\u0002\u0002\u019c\u019d\u0007/\u0002\u0002\u019d\u01a0",
    "\u0005(\u0015\u0002\u019e\u019f\u0007*\u0002\u0002\u019f\u01a1\u0005",
    "(\u0015\u0002\u01a0\u019e\u0003\u0002\u0002\u0002\u01a0\u01a1\u0003",
    "\u0002\u0002\u0002\u01a1\u01a2\u0003\u0002\u0002\u0002\u01a2\u01a6\u0007",
    "0\u0002\u0002\u01a3\u01a5\u0005H%\u0002\u01a4\u01a3\u0003\u0002\u0002",
    "\u0002\u01a5\u01a8\u0003\u0002\u0002\u0002\u01a6\u01a4\u0003\u0002\u0002",
    "\u0002\u01a6\u01a7\u0003\u0002\u0002\u0002\u01a7E\u0003\u0002\u0002",
    "\u0002\u01a8\u01a6\u0003\u0002\u0002\u0002\u01a9\u01aa\u0005.\u0018",
    "\u0002\u01aaG\u0003\u0002\u0002\u0002\u01ab\u01ac\u0005F$\u0002\u01ac",
    "\u01b0\u0007\u0016\u0002\u0002\u01ad\u01b1\u0005:\u001e\u0002\u01ae",
    "\u01b1\u0005\\/\u0002\u01af\u01b1\u0005Z.\u0002\u01b0\u01ad\u0003\u0002",
    "\u0002\u0002\u01b0\u01ae\u0003\u0002\u0002\u0002\u01b0\u01af\u0003\u0002",
    "\u0002\u0002\u01b1I\u0003\u0002\u0002\u0002\u01b2\u01b3\u0005\u0012",
    "\n\u0002\u01b3K\u0003\u0002\u0002\u0002\u01b4\u01b5\u0005J&\u0002\u01b5",
    "\u01b6\u0007\u001f\u0002\u0002\u01b6\u01b7\u0005:\u001e\u0002\u01b7",
    "M\u0003\u0002\u0002\u0002\u01b8\u01ba\u0007[\u0002\u0002\u01b9\u01b8",
    "\u0003\u0002\u0002\u0002\u01b9\u01ba\u0003\u0002\u0002\u0002\u01ba\u01bb",
    "\u0003\u0002\u0002\u0002\u01bb\u01bc\u0005P)\u0002\u01bc\u01d7\u0007",
    "!\u0002\u0002\u01bd\u01c6\u0005:\u001e\u0002\u01be\u01c6\u0005<\u001f",
    "\u0002\u01bf\u01c0\u0007]\u0002\u0002\u01c0\u01c6\u0005> \u0002\u01c1",
    "\u01c2\u0007^\u0002\u0002\u01c2\u01c6\u0005L\'\u0002\u01c3\u01c6\u0005",
    "Z.\u0002\u01c4\u01c6\u0005\\/\u0002\u01c5\u01bd\u0003\u0002\u0002\u0002",
    "\u01c5\u01be\u0003\u0002\u0002\u0002\u01c5\u01bf\u0003\u0002\u0002\u0002",
    "\u01c5\u01c1\u0003\u0002\u0002\u0002\u01c5\u01c3\u0003\u0002\u0002\u0002",
    "\u01c5\u01c4\u0003\u0002\u0002\u0002\u01c6\u01d4\u0003\u0002\u0002\u0002",
    "\u01c7\u01d0\u0007$\u0002\u0002\u01c8\u01d1\u0005:\u001e\u0002\u01c9",
    "\u01d1\u0005<\u001f\u0002\u01ca\u01cb\u0007]\u0002\u0002\u01cb\u01d1",
    "\u0005> \u0002\u01cc\u01cd\u0007^\u0002\u0002\u01cd\u01d1\u0005L\'\u0002",
    "\u01ce\u01d1\u0005Z.\u0002\u01cf\u01d1\u0005\\/\u0002\u01d0\u01c8\u0003",
    "\u0002\u0002\u0002\u01d0\u01c9\u0003\u0002\u0002\u0002\u01d0\u01ca\u0003",
    "\u0002\u0002\u0002\u01d0\u01cc\u0003\u0002\u0002\u0002\u01d0\u01ce\u0003",
    "\u0002\u0002\u0002\u01d0\u01cf\u0003\u0002\u0002\u0002\u01d1\u01d3\u0003",
    "\u0002\u0002\u0002\u01d2\u01c7\u0003\u0002\u0002\u0002\u01d3\u01d6\u0003",
    "\u0002\u0002\u0002\u01d4\u01d2\u0003\u0002\u0002\u0002\u01d4\u01d5\u0003",
    "\u0002\u0002\u0002\u01d5\u01d8\u0003\u0002\u0002\u0002\u01d6\u01d4\u0003",
    "\u0002\u0002\u0002\u01d7\u01c5\u0003\u0002\u0002\u0002\u01d7\u01d8\u0003",
    "\u0002\u0002\u0002\u01d8\u01d9\u0003\u0002\u0002\u0002\u01d9\u01da\u0007",
    "\"\u0002\u0002\u01daO\u0003\u0002\u0002\u0002\u01db\u01dc\u0005\u0012",
    "\n\u0002\u01dcQ\u0003\u0002\u0002\u0002\u01dd\u01de\u0005\u0012\n\u0002",
    "\u01deS\u0003\u0002\u0002\u0002\u01df\u01e0\u0005\u0012\n\u0002\u01e0",
    "U\u0003\u0002\u0002\u0002\u01e1\u01e2\u0005P)\u0002\u01e2\u01e3\u0007",
    "\u000e\u0002\u0002\u01e3\u01e4\u0005T+\u0002\u01e4W\u0003\u0002\u0002",
    "\u0002\u01e5\u01e9\u0005R*\u0002\u01e6\u01e7\u0007\\\u0002\u0002\u01e7",
    "\u01e9\u0005V,\u0002\u01e8\u01e5\u0003\u0002\u0002\u0002\u01e8\u01e6",
    "\u0003\u0002\u0002\u0002\u01e9\u01f2\u0003\u0002\u0002\u0002\u01ea\u01ee",
    "\u0007$\u0002\u0002\u01eb\u01ef\u0005R*\u0002\u01ec\u01ed\u0007\\\u0002",
    "\u0002\u01ed\u01ef\u0005V,\u0002\u01ee\u01eb\u0003\u0002\u0002\u0002",
    "\u01ee\u01ec\u0003\u0002\u0002\u0002\u01ef\u01f1\u0003\u0002\u0002\u0002",
    "\u01f0\u01ea\u0003\u0002\u0002\u0002\u01f1\u01f4\u0003\u0002\u0002\u0002",
    "\u01f2\u01f0\u0003\u0002\u0002\u0002\u01f2\u01f3\u0003\u0002\u0002\u0002",
    "\u01f3Y\u0003\u0002\u0002\u0002\u01f4\u01f2\u0003\u0002\u0002\u0002",
    "\u01f5\u01f6\u00079\u0002\u0002\u01f6\u01fa\u0007!\u0002\u0002\u01f7",
    "\u01f8\u0005T+\u0002\u01f8\u01f9\u0007$\u0002\u0002\u01f9\u01fb\u0003",
    "\u0002\u0002\u0002\u01fa\u01f7\u0003\u0002\u0002\u0002\u01fa\u01fb\u0003",
    "\u0002\u0002\u0002\u01fb\u01fc\u0003\u0002\u0002\u0002\u01fc\u0201\u0005",
    "p9\u0002\u01fd\u01fe\u0007$\u0002\u0002\u01fe\u0200\u0005p9\u0002\u01ff",
    "\u01fd\u0003\u0002\u0002\u0002\u0200\u0203\u0003\u0002\u0002\u0002\u0201",
    "\u01ff\u0003\u0002\u0002\u0002\u0201\u0202\u0003\u0002\u0002\u0002\u0202",
    "\u0204\u0003\u0002\u0002\u0002\u0203\u0201\u0003\u0002\u0002\u0002\u0204",
    "\u0205\u0007\"\u0002\u0002\u0205[\u0003\u0002\u0002\u0002\u0206\u0207",
    "\u0007:\u0002\u0002\u0207\u020b\u0007!\u0002\u0002\u0208\u0209\u0005",
    "T+\u0002\u0209\u020a\u0007$\u0002\u0002\u020a\u020c\u0003\u0002\u0002",
    "\u0002\u020b\u0208\u0003\u0002\u0002\u0002\u020b\u020c\u0003\u0002\u0002",
    "\u0002\u020c\u020d\u0003\u0002\u0002\u0002\u020d\u0212\u0005p9\u0002",
    "\u020e\u020f\u0007$\u0002\u0002\u020f\u0211\u0005p9\u0002\u0210\u020e",
    "\u0003\u0002\u0002\u0002\u0211\u0214\u0003\u0002\u0002\u0002\u0212\u0210",
    "\u0003\u0002\u0002\u0002\u0212\u0213\u0003\u0002\u0002\u0002\u0213\u0215",
    "\u0003\u0002\u0002\u0002\u0214\u0212\u0003\u0002\u0002\u0002\u0215\u0216",
    "\u0007\"\u0002\u0002\u0216]\u0003\u0002\u0002\u0002\u0217\u0223\u0005",
    "R*\u0002\u0218\u0219\u0007,\u0002\u0002\u0219\u021e\u0005T+\u0002\u021a",
    "\u021b\u0007$\u0002\u0002\u021b\u021d\u0005T+\u0002\u021c\u021a\u0003",
    "\u0002\u0002\u0002\u021d\u0220\u0003\u0002\u0002\u0002\u021e\u021c\u0003",
    "\u0002\u0002\u0002\u021e\u021f\u0003\u0002\u0002\u0002\u021f\u0221\u0003",
    "\u0002\u0002\u0002\u0220\u021e\u0003\u0002\u0002\u0002\u0221\u0222\u0007",
    "\"\u0002\u0002\u0222\u0224\u0003\u0002\u0002\u0002\u0223\u0218\u0003",
    "\u0002\u0002\u0002\u0223\u0224\u0003\u0002\u0002\u0002\u0224_\u0003",
    "\u0002\u0002\u0002\u0225\u0227\u0005X-\u0002\u0226\u0225\u0003\u0002",
    "\u0002\u0002\u0226\u0227\u0003\u0002\u0002\u0002\u0227\u0228\u0003\u0002",
    "\u0002\u0002\u0228\u0229\u0005N(\u0002\u0229\u022a\u0007\u0015\u0002",
    "\u0002\u022a\u022b\u0005^0\u0002\u022ba\u0003\u0002\u0002\u0002\u022c",
    "\u0243\u0007=\u0002\u0002\u022d\u0243\u0007>\u0002\u0002\u022e\u0243",
    "\u0007?\u0002\u0002\u022f\u0243\u0007@\u0002\u0002\u0230\u0243\u0007",
    "A\u0002\u0002\u0231\u0243\u0007C\u0002\u0002\u0232\u0243\u0007D\u0002",
    "\u0002\u0233\u0243\u0007F\u0002\u0002\u0234\u0243\u0007G\u0002\u0002",
    "\u0235\u0243\u0007H\u0002\u0002\u0236\u0243\u0007E\u0002\u0002\u0237",
    "\u0238\u0007B\u0002\u0002\u0238\u0239\u0007!\u0002\u0002\u0239\u023a",
    "\u0005\u0006\u0004\u0002\u023a\u023b\u0007$\u0002\u0002\u023b\u023c",
    "\u0005\u0006\u0004\u0002\u023c\u023d\u0007\"\u0002\u0002\u023d\u0243",
    "\u0003\u0002\u0002\u0002\u023e\u0243\u0007I\u0002\u0002\u023f\u0243",
    "\u0007K\u0002\u0002\u0240\u0243\u0007J\u0002\u0002\u0241\u0243\u0007",
    "L\u0002\u0002\u0242\u022c\u0003\u0002\u0002\u0002\u0242\u022d\u0003",
    "\u0002\u0002\u0002\u0242\u022e\u0003\u0002\u0002\u0002\u0242\u022f\u0003",
    "\u0002\u0002\u0002\u0242\u0230\u0003\u0002\u0002\u0002\u0242\u0231\u0003",
    "\u0002\u0002\u0002\u0242\u0232\u0003\u0002\u0002\u0002\u0242\u0233\u0003",
    "\u0002\u0002\u0002\u0242\u0234\u0003\u0002\u0002\u0002\u0242\u0235\u0003",
    "\u0002\u0002\u0002\u0242\u0236\u0003\u0002\u0002\u0002\u0242\u0237\u0003",
    "\u0002\u0002\u0002\u0242\u023e\u0003\u0002\u0002\u0002\u0242\u023f\u0003",
    "\u0002\u0002\u0002\u0242\u0240\u0003\u0002\u0002\u0002\u0242\u0241\u0003",
    "\u0002\u0002\u0002\u0243c\u0003\u0002\u0002\u0002\u0244\u0245\u0007",
    "!\u0002\u0002\u0245\u024a\u0005p9\u0002\u0246\u0247\u0007$\u0002\u0002",
    "\u0247\u0249\u0005p9\u0002\u0248\u0246\u0003\u0002\u0002\u0002\u0249",
    "\u024c\u0003\u0002\u0002\u0002\u024a\u0248\u0003\u0002\u0002\u0002\u024a",
    "\u024b\u0003\u0002\u0002\u0002\u024b\u024d\u0003\u0002\u0002\u0002\u024c",
    "\u024a\u0003\u0002\u0002\u0002\u024d\u024e\u0007\"\u0002\u0002\u024e",
    "e\u0003\u0002\u0002\u0002\u024f\u0250\b4\u0001\u0002\u0250\u0251\u0007",
    "(\u0002\u0002\u0251\u0252\u0005f4\u0002\u0252\u0253\u0007$\u0002\u0002",
    "\u0253\u0254\u0005f4\u0002\u0254\u0255\u0007)\u0002\u0002\u0255\u0259",
    "\u0003\u0002\u0002\u0002\u0256\u0259\u0005b2\u0002\u0257\u0259\u0005",
    "d3\u0002\u0258\u024f\u0003\u0002\u0002\u0002\u0258\u0256\u0003\u0002",
    "\u0002\u0002\u0258\u0257\u0003\u0002\u0002\u0002\u0259\u025e\u0003\u0002",
    "\u0002\u0002\u025a\u025b\f\u0006\u0002\u0002\u025b\u025d\u0007-\u0002",
    "\u0002\u025c\u025a\u0003\u0002\u0002\u0002\u025d\u0260\u0003\u0002\u0002",
    "\u0002\u025e\u025c\u0003\u0002\u0002\u0002\u025e\u025f\u0003\u0002\u0002",
    "\u0002\u025fg\u0003\u0002\u0002\u0002\u0260\u025e\u0003\u0002\u0002",
    "\u0002\u0261\u0262\u0005$\u0013\u0002\u0262\u0263\u00078\u0002\u0002",
    "\u0263\u0265\u0005f4\u0002\u0264\u0266\u0005:\u001e\u0002\u0265\u0264",
    "\u0003\u0002\u0002\u0002\u0265\u0266\u0003\u0002\u0002\u0002\u0266i",
    "\u0003\u0002\u0002\u0002\u0267\u0274\u0005\b\u0005\u0002\u0268\u0269",
    "\u0007(\u0002\u0002\u0269\u026e\u0005\b\u0005\u0002\u026a\u026b\u0007",
    "$\u0002\u0002\u026b\u026d\u0005\b\u0005\u0002\u026c\u026a\u0003\u0002",
    "\u0002\u0002\u026d\u0270\u0003\u0002\u0002\u0002\u026e\u026c\u0003\u0002",
    "\u0002\u0002\u026e\u026f\u0003\u0002\u0002\u0002\u026f\u0271\u0003\u0002",
    "\u0002\u0002\u0270\u026e\u0003\u0002\u0002\u0002\u0271\u0272\u0007)",
    "\u0002\u0002\u0272\u0274\u0003\u0002\u0002\u0002\u0273\u0267\u0003\u0002",
    "\u0002\u0002\u0273\u0268\u0003\u0002\u0002\u0002\u0274k\u0003\u0002",
    "\u0002\u0002\u0275\u0277\u0005f4\u0002\u0276\u0278\u0005j6\u0002\u0277",
    "\u0276\u0003\u0002\u0002\u0002\u0277\u0278\u0003\u0002\u0002\u0002\u0278",
    "m\u0003\u0002\u0002\u0002\u0279\u027a\u00071\u0002\u0002\u027a\u027b",
    "\u0005:\u001e\u0002\u027b\u027c\u0007\"\u0002\u0002\u027co\u0003\u0002",
    "\u0002\u0002\u027d\u027e\u0005\u0018\r\u0002\u027e\u0281\u00078\u0002",
    "\u0002\u027f\u0282\u0005l7\u0002\u0280\u0282\u0005n8\u0002\u0281\u027f",
    "\u0003\u0002\u0002\u0002\u0281\u0280\u0003\u0002\u0002\u0002\u0282q",
    "\u0003\u0002\u0002\u0002\u0283\u0284\u00076\u0002\u0002\u0284\u0285",
    "\u0007&\u0002\u0002\u0285\u028a\u0005h5\u0002\u0286\u0287\u0007$\u0002",
    "\u0002\u0287\u0289\u0005h5\u0002\u0288\u0286\u0003\u0002\u0002\u0002",
    "\u0289\u028c\u0003\u0002\u0002\u0002\u028a\u0288\u0003\u0002\u0002\u0002",
    "\u028a\u028b\u0003\u0002\u0002\u0002\u028b\u028d\u0003\u0002\u0002\u0002",
    "\u028c\u028a\u0003\u0002\u0002\u0002\u028d\u028e\u0007\'\u0002\u0002",
    "\u028es\u0003\u0002\u0002\u0002\u028f\u0290\u0005\u0012\n\u0002\u0290",
    "\u0299\u0007!\u0002\u0002\u0291\u0296\u0005f4\u0002\u0292\u0293\u0007",
    "$\u0002\u0002\u0293\u0295\u0005f4\u0002\u0294\u0292\u0003\u0002\u0002",
    "\u0002\u0295\u0298\u0003\u0002\u0002\u0002\u0296\u0294\u0003\u0002\u0002",
    "\u0002\u0296\u0297\u0003\u0002\u0002\u0002\u0297\u029a\u0003\u0002\u0002",
    "\u0002\u0298\u0296\u0003\u0002\u0002\u0002\u0299\u0291\u0003\u0002\u0002",
    "\u0002\u0299\u029a\u0003\u0002\u0002\u0002\u029a\u029b\u0003\u0002\u0002",
    "\u0002\u029b\u029c\u0007\"\u0002\u0002\u029c\u029d\u00078\u0002\u0002",
    "\u029d\u02a1\u0005f4\u0002\u029e\u029f\u0007\u0016\u0002\u0002\u029f",
    "\u02a2\u0005:\u001e\u0002\u02a0\u02a2\u0005\n\u0006\u0002\u02a1\u029e",
    "\u0003\u0002\u0002\u0002\u02a1\u02a0\u0003\u0002\u0002\u0002\u02a2u",
    "\u0003\u0002\u0002\u0002\u02a3\u02a4\u00077\u0002\u0002\u02a4\u02a5",
    "\u0007&\u0002\u0002\u02a5\u02aa\u0005t;\u0002\u02a6\u02a7\u0007$\u0002",
    "\u0002\u02a7\u02a9\u0005t;\u0002\u02a8\u02a6\u0003\u0002\u0002\u0002",
    "\u02a9\u02ac\u0003\u0002\u0002\u0002\u02aa\u02a8\u0003\u0002\u0002\u0002",
    "\u02aa\u02ab\u0003\u0002\u0002\u0002\u02ab\u02ad\u0003\u0002\u0002\u0002",
    "\u02ac\u02aa\u0003\u0002\u0002\u0002\u02ad\u02ae\u0007\'\u0002\u0002",
    "\u02aew\u0003\u0002\u0002\u0002\u02af\u02b1\u0005v<\u0002\u02b0\u02af",
    "\u0003\u0002\u0002\u0002\u02b0\u02b1\u0003\u0002\u0002\u0002\u02b1\u02b3",
    "\u0003\u0002\u0002\u0002\u02b2\u02b4\u0005r:\u0002\u02b3\u02b2\u0003",
    "\u0002\u0002\u0002\u02b3\u02b4\u0003\u0002\u0002\u0002\u02b4\u02b8\u0003",
    "\u0002\u0002\u0002\u02b5\u02b7\u0005`1\u0002\u02b6\u02b5\u0003\u0002",
    "\u0002\u0002\u02b7\u02ba\u0003\u0002\u0002\u0002\u02b8\u02b6\u0003\u0002",
    "\u0002\u0002\u02b8\u02b9\u0003\u0002\u0002\u0002\u02b9y\u0003\u0002",
    "\u0002\u0002\u02ba\u02b8\u0003\u0002\u0002\u0002C~\u0094\u0098\u009c",
    "\u00a2\u00b6\u00bf\u00c2\u00cb\u00d1\u00d5\u00d8\u00de\u00e5\u00e9\u00f3",
    "\u00fd\u0100\u010f\u011d\u0122\u0126\u013e\u014f\u0159\u015f\u0183\u0185",
    "\u018a\u019a\u01a0\u01a6\u01b0\u01b9\u01c5\u01d0\u01d4\u01d7\u01e8\u01ee",
    "\u01f2\u01fa\u0201\u020b\u0212\u021e\u0223\u0226\u0242\u024a\u0258\u025e",
    "\u0265\u026e\u0273\u0277\u0281\u028a\u0296\u0299\u02a1\u02aa\u02b0\u02b3",
    "\u02b8"].join("");


var atn = new antlr4.atn.ATNDeserializer().deserialize(serializedATN);

var decisionsToDFA = atn.decisionToState.map( function(ds, index) { return new antlr4.dfa.DFA(ds, index); });

var sharedContextCache = new antlr4.PredictionContextCache();

var literalNames = [ null, "'/*'", null, null, null, null, "'+'", "'-'", 
                     "'*'", "'%'", "'!'", "'$'", "'@'", "'~'", "'?'", "'=='", 
                     "'==='", "'<=>'", "'!='", "'~>'", "'='", "':='", "'>'", 
                     "'<'", "'>='", "'<='", "'&&'", "'||'", "'^'", "':'", 
                     "'.'", "'('", "')'", "'#'", "','", "'->'", null, "'}'", 
                     "'['", "']'", "'/'", "'\\{'", "'@('", "'[]'", "'''", 
                     "'[<'", "'>]'", "'typeOf('", null, null, null, null, 
                     "'parameters'", "'functions'", "'as'", "'input'", "'output'", 
                     "'constant'", "'expression'", "'integer'", "'short'", 
                     "'long'", "'double'", "'float'", "'decimal'", "'boolean'", 
                     "'string'", "'timestamp'", "'date'", "'byte'", "'binary'", 
                     "'integral'", "'number'", "'fractional'", "'any'", 
                     null, null, null, null, "'$$'", "'$#'", null, null, 
                     null, null, null, null, null, "'Annotation'", "'MetaHead'", 
                     "'GroupHead'", "'TransientAssignmentHead'", "'ConfigurationHead'", 
                     "'*/'" ];

var symbolicNames = [ null, "OPEN_ANNOTATION", "DECIMAL_LITERAL", "HEX_LITERAL", 
                      "OCT_LITERAL", "BINARY_LITERAL", "PLUS", "MINUS", 
                      "MUL", "MOD", "NOT", "DOLLAR", "AT", "TILDA", "QUESTION", 
                      "EQ", "EQ_NULL", "EQ_NOCASE", "NOT_EQ", "FLOW", "ASSIGN", 
                      "TRANSIENT_ASSIGN", "GT", "LT", "GT_EQ", "LT_EQ", 
                      "AND", "OR", "XOR", "COLON", "DOT", "OPEN_PAREN", 
                      "CLOSE_PAREN", "HASH", "COMMA", "MAP", "OPEN_CURLY", 
                      "CLOSE_CURLY", "OPEN_SQ", "CLOSE_SQ", "SLASH", "ESCAPE_CURLY", 
                      "OPEN_STRUCT", "OPEN_CLOSE_SQ", "SINGLE_QUOTE", "OPEN_SECTION", 
                      "CLOSE_SECTION", "OPEN_TYPEOF", "FLOAT_LITERAL", "HEX_FLOAT_LITERAL", 
                      "STRING_LITERAL", "REGEX_LITERAL", "PARAMETERS", "FUNCTIONS", 
                      "AS", "INPUT", "OUTPUT", "CONSTANT", "EXPRESSION", 
                      "INTEGER", "SHORT", "LONG", "DOUBLE", "FLOAT", "DECIMAL", 
                      "BOOLEAN", "STRING", "TIMESTAMP", "DATE", "BYTE", 
                      "BINARY", "INTEGRAL", "NUMBER", "FRACTIONAL", "ANY_SIMPLE", 
                      "IDENTIFIER", "ALPHA_IDENTIFIER", "ANY_IDENTIFIER", 
                      "META_MATCH", "META_VARIABLE", "META_POS", "INDEX", 
                      "WS", "OPEN_INTERPOLATE", "INTERPOLATE_TEXT", "INTERPOLATE_OPEN_CURLY", 
                      "COMMENT", "ANNOTATION_WS", "ANNOTATION_ENABLED", 
                      "ANNOTATION_META_HEAD", "ANNOTATION_GROUP", "ANNOTATION_TRANSIENT_ASSIGNMENT", 
                      "ANNOTATION_CONFIGURATION", "CLOSE_ANNOTATION" ];

var ruleNames =  [ "literal", "integer_literal", "index_literal", "format_literal", 
                   "extension_literal", "float_literal", "typeNames", "keyword", 
                   "basicName", "anyName", "memberIdentifier", "columnIdentifier", 
                   "variableReference", "metaVariableReference", "metaPosReference", 
                   "metaMatchReference", "metaArgumentReference", "parameter", 
                   "variable", "sectionName", "basicFunction", "metafunction", 
                   "name", "columnOperand", "transformFunction", "transientOperand", 
                   "parameterOperand", "interpolateParts", "expression", 
                   "assignment", "transientAssignment", "metaAssignment", 
                   "sections", "section", "key", "keyExpression", "configName", 
                   "configuration", "transformation", "transformName", "transformed", 
                   "groupName", "transformedGroup", "inputTransformedList", 
                   "inputDefinition", "outputDefinition", "outputTransformed", 
                   "flowStatement", "simple", "complex", "datatype", "parameterDefinition", 
                   "dataFormat", "inlineDatatype", "externalDatatype", "columnDefinition", 
                   "parameters", "functionDefinition", "functions", "dataflow" ];

function DataflowParser (input) {
	antlr4.Parser.call(this, input);
    this._interp = new antlr4.atn.ParserATNSimulator(this, atn, decisionsToDFA, sharedContextCache);
    this.ruleNames = ruleNames;
    this.literalNames = literalNames;
    this.symbolicNames = symbolicNames;
    return this;
}

DataflowParser.prototype = Object.create(antlr4.Parser.prototype);
DataflowParser.prototype.constructor = DataflowParser;

Object.defineProperty(DataflowParser.prototype, "atn", {
	get : function() {
		return atn;
	}
});

DataflowParser.EOF = antlr4.Token.EOF;
DataflowParser.OPEN_ANNOTATION = 1;
DataflowParser.DECIMAL_LITERAL = 2;
DataflowParser.HEX_LITERAL = 3;
DataflowParser.OCT_LITERAL = 4;
DataflowParser.BINARY_LITERAL = 5;
DataflowParser.PLUS = 6;
DataflowParser.MINUS = 7;
DataflowParser.MUL = 8;
DataflowParser.MOD = 9;
DataflowParser.NOT = 10;
DataflowParser.DOLLAR = 11;
DataflowParser.AT = 12;
DataflowParser.TILDA = 13;
DataflowParser.QUESTION = 14;
DataflowParser.EQ = 15;
DataflowParser.EQ_NULL = 16;
DataflowParser.EQ_NOCASE = 17;
DataflowParser.NOT_EQ = 18;
DataflowParser.FLOW = 19;
DataflowParser.ASSIGN = 20;
DataflowParser.TRANSIENT_ASSIGN = 21;
DataflowParser.GT = 22;
DataflowParser.LT = 23;
DataflowParser.GT_EQ = 24;
DataflowParser.LT_EQ = 25;
DataflowParser.AND = 26;
DataflowParser.OR = 27;
DataflowParser.XOR = 28;
DataflowParser.COLON = 29;
DataflowParser.DOT = 30;
DataflowParser.OPEN_PAREN = 31;
DataflowParser.CLOSE_PAREN = 32;
DataflowParser.HASH = 33;
DataflowParser.COMMA = 34;
DataflowParser.MAP = 35;
DataflowParser.OPEN_CURLY = 36;
DataflowParser.CLOSE_CURLY = 37;
DataflowParser.OPEN_SQ = 38;
DataflowParser.CLOSE_SQ = 39;
DataflowParser.SLASH = 40;
DataflowParser.ESCAPE_CURLY = 41;
DataflowParser.OPEN_STRUCT = 42;
DataflowParser.OPEN_CLOSE_SQ = 43;
DataflowParser.SINGLE_QUOTE = 44;
DataflowParser.OPEN_SECTION = 45;
DataflowParser.CLOSE_SECTION = 46;
DataflowParser.OPEN_TYPEOF = 47;
DataflowParser.FLOAT_LITERAL = 48;
DataflowParser.HEX_FLOAT_LITERAL = 49;
DataflowParser.STRING_LITERAL = 50;
DataflowParser.REGEX_LITERAL = 51;
DataflowParser.PARAMETERS = 52;
DataflowParser.FUNCTIONS = 53;
DataflowParser.AS = 54;
DataflowParser.INPUT = 55;
DataflowParser.OUTPUT = 56;
DataflowParser.CONSTANT = 57;
DataflowParser.EXPRESSION = 58;
DataflowParser.INTEGER = 59;
DataflowParser.SHORT = 60;
DataflowParser.LONG = 61;
DataflowParser.DOUBLE = 62;
DataflowParser.FLOAT = 63;
DataflowParser.DECIMAL = 64;
DataflowParser.BOOLEAN = 65;
DataflowParser.STRING = 66;
DataflowParser.TIMESTAMP = 67;
DataflowParser.DATE = 68;
DataflowParser.BYTE = 69;
DataflowParser.BINARY = 70;
DataflowParser.INTEGRAL = 71;
DataflowParser.NUMBER = 72;
DataflowParser.FRACTIONAL = 73;
DataflowParser.ANY_SIMPLE = 74;
DataflowParser.IDENTIFIER = 75;
DataflowParser.ALPHA_IDENTIFIER = 76;
DataflowParser.ANY_IDENTIFIER = 77;
DataflowParser.META_MATCH = 78;
DataflowParser.META_VARIABLE = 79;
DataflowParser.META_POS = 80;
DataflowParser.INDEX = 81;
DataflowParser.WS = 82;
DataflowParser.OPEN_INTERPOLATE = 83;
DataflowParser.INTERPOLATE_TEXT = 84;
DataflowParser.INTERPOLATE_OPEN_CURLY = 85;
DataflowParser.COMMENT = 86;
DataflowParser.ANNOTATION_WS = 87;
DataflowParser.ANNOTATION_ENABLED = 88;
DataflowParser.ANNOTATION_META_HEAD = 89;
DataflowParser.ANNOTATION_GROUP = 90;
DataflowParser.ANNOTATION_TRANSIENT_ASSIGNMENT = 91;
DataflowParser.ANNOTATION_CONFIGURATION = 92;
DataflowParser.CLOSE_ANNOTATION = 93;

DataflowParser.RULE_literal = 0;
DataflowParser.RULE_integer_literal = 1;
DataflowParser.RULE_index_literal = 2;
DataflowParser.RULE_format_literal = 3;
DataflowParser.RULE_extension_literal = 4;
DataflowParser.RULE_float_literal = 5;
DataflowParser.RULE_typeNames = 6;
DataflowParser.RULE_keyword = 7;
DataflowParser.RULE_basicName = 8;
DataflowParser.RULE_anyName = 9;
DataflowParser.RULE_memberIdentifier = 10;
DataflowParser.RULE_columnIdentifier = 11;
DataflowParser.RULE_variableReference = 12;
DataflowParser.RULE_metaVariableReference = 13;
DataflowParser.RULE_metaPosReference = 14;
DataflowParser.RULE_metaMatchReference = 15;
DataflowParser.RULE_metaArgumentReference = 16;
DataflowParser.RULE_parameter = 17;
DataflowParser.RULE_variable = 18;
DataflowParser.RULE_sectionName = 19;
DataflowParser.RULE_basicFunction = 20;
DataflowParser.RULE_metafunction = 21;
DataflowParser.RULE_name = 22;
DataflowParser.RULE_columnOperand = 23;
DataflowParser.RULE_transformFunction = 24;
DataflowParser.RULE_transientOperand = 25;
DataflowParser.RULE_parameterOperand = 26;
DataflowParser.RULE_interpolateParts = 27;
DataflowParser.RULE_expression = 28;
DataflowParser.RULE_assignment = 29;
DataflowParser.RULE_transientAssignment = 30;
DataflowParser.RULE_metaAssignment = 31;
DataflowParser.RULE_sections = 32;
DataflowParser.RULE_section = 33;
DataflowParser.RULE_key = 34;
DataflowParser.RULE_keyExpression = 35;
DataflowParser.RULE_configName = 36;
DataflowParser.RULE_configuration = 37;
DataflowParser.RULE_transformation = 38;
DataflowParser.RULE_transformName = 39;
DataflowParser.RULE_transformed = 40;
DataflowParser.RULE_groupName = 41;
DataflowParser.RULE_transformedGroup = 42;
DataflowParser.RULE_inputTransformedList = 43;
DataflowParser.RULE_inputDefinition = 44;
DataflowParser.RULE_outputDefinition = 45;
DataflowParser.RULE_outputTransformed = 46;
DataflowParser.RULE_flowStatement = 47;
DataflowParser.RULE_simple = 48;
DataflowParser.RULE_complex = 49;
DataflowParser.RULE_datatype = 50;
DataflowParser.RULE_parameterDefinition = 51;
DataflowParser.RULE_dataFormat = 52;
DataflowParser.RULE_inlineDatatype = 53;
DataflowParser.RULE_externalDatatype = 54;
DataflowParser.RULE_columnDefinition = 55;
DataflowParser.RULE_parameters = 56;
DataflowParser.RULE_functionDefinition = 57;
DataflowParser.RULE_functions = 58;
DataflowParser.RULE_dataflow = 59;


function LiteralContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = DataflowParser.RULE_literal;
    return this;
}

LiteralContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
LiteralContext.prototype.constructor = LiteralContext;


 
LiteralContext.prototype.copyFrom = function(ctx) {
    antlr4.ParserRuleContext.prototype.copyFrom.call(this, ctx);
};


function StringLiteralContext(parser, ctx) {
	LiteralContext.call(this, parser);
    LiteralContext.prototype.copyFrom.call(this, ctx);
    return this;
}

StringLiteralContext.prototype = Object.create(LiteralContext.prototype);
StringLiteralContext.prototype.constructor = StringLiteralContext;

DataflowParser.StringLiteralContext = StringLiteralContext;

StringLiteralContext.prototype.STRING_LITERAL = function() {
    return this.getToken(DataflowParser.STRING_LITERAL, 0);
};
StringLiteralContext.prototype.enterRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.enterStringLiteral(this);
	}
};

StringLiteralContext.prototype.exitRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.exitStringLiteral(this);
	}
};

StringLiteralContext.prototype.accept = function(visitor) {
    if ( visitor instanceof DataflowParserVisitor ) {
        return visitor.visitStringLiteral(this);
    } else {
        return visitor.visitChildren(this);
    }
};


function FloatLiteralContext(parser, ctx) {
	LiteralContext.call(this, parser);
    LiteralContext.prototype.copyFrom.call(this, ctx);
    return this;
}

FloatLiteralContext.prototype = Object.create(LiteralContext.prototype);
FloatLiteralContext.prototype.constructor = FloatLiteralContext;

DataflowParser.FloatLiteralContext = FloatLiteralContext;

FloatLiteralContext.prototype.float_literal = function() {
    return this.getTypedRuleContext(Float_literalContext,0);
};
FloatLiteralContext.prototype.enterRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.enterFloatLiteral(this);
	}
};

FloatLiteralContext.prototype.exitRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.exitFloatLiteral(this);
	}
};

FloatLiteralContext.prototype.accept = function(visitor) {
    if ( visitor instanceof DataflowParserVisitor ) {
        return visitor.visitFloatLiteral(this);
    } else {
        return visitor.visitChildren(this);
    }
};


function RegexLiteralContext(parser, ctx) {
	LiteralContext.call(this, parser);
    LiteralContext.prototype.copyFrom.call(this, ctx);
    return this;
}

RegexLiteralContext.prototype = Object.create(LiteralContext.prototype);
RegexLiteralContext.prototype.constructor = RegexLiteralContext;

DataflowParser.RegexLiteralContext = RegexLiteralContext;

RegexLiteralContext.prototype.REGEX_LITERAL = function() {
    return this.getToken(DataflowParser.REGEX_LITERAL, 0);
};
RegexLiteralContext.prototype.enterRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.enterRegexLiteral(this);
	}
};

RegexLiteralContext.prototype.exitRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.exitRegexLiteral(this);
	}
};

RegexLiteralContext.prototype.accept = function(visitor) {
    if ( visitor instanceof DataflowParserVisitor ) {
        return visitor.visitRegexLiteral(this);
    } else {
        return visitor.visitChildren(this);
    }
};


function IntegerLiteralContext(parser, ctx) {
	LiteralContext.call(this, parser);
    LiteralContext.prototype.copyFrom.call(this, ctx);
    return this;
}

IntegerLiteralContext.prototype = Object.create(LiteralContext.prototype);
IntegerLiteralContext.prototype.constructor = IntegerLiteralContext;

DataflowParser.IntegerLiteralContext = IntegerLiteralContext;

IntegerLiteralContext.prototype.integer_literal = function() {
    return this.getTypedRuleContext(Integer_literalContext,0);
};
IntegerLiteralContext.prototype.enterRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.enterIntegerLiteral(this);
	}
};

IntegerLiteralContext.prototype.exitRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.exitIntegerLiteral(this);
	}
};

IntegerLiteralContext.prototype.accept = function(visitor) {
    if ( visitor instanceof DataflowParserVisitor ) {
        return visitor.visitIntegerLiteral(this);
    } else {
        return visitor.visitChildren(this);
    }
};



DataflowParser.LiteralContext = LiteralContext;

DataflowParser.prototype.literal = function() {

    var localctx = new LiteralContext(this, this._ctx, this.state);
    this.enterRule(localctx, 0, DataflowParser.RULE_literal);
    try {
        this.state = 124;
        this._errHandler.sync(this);
        switch(this._input.LA(1)) {
        case DataflowParser.DECIMAL_LITERAL:
        case DataflowParser.HEX_LITERAL:
        case DataflowParser.OCT_LITERAL:
        case DataflowParser.BINARY_LITERAL:
            localctx = new IntegerLiteralContext(this, localctx);
            this.enterOuterAlt(localctx, 1);
            this.state = 120;
            this.integer_literal();
            break;
        case DataflowParser.FLOAT_LITERAL:
        case DataflowParser.HEX_FLOAT_LITERAL:
            localctx = new FloatLiteralContext(this, localctx);
            this.enterOuterAlt(localctx, 2);
            this.state = 121;
            this.float_literal();
            break;
        case DataflowParser.STRING_LITERAL:
            localctx = new StringLiteralContext(this, localctx);
            this.enterOuterAlt(localctx, 3);
            this.state = 122;
            this.match(DataflowParser.STRING_LITERAL);
            break;
        case DataflowParser.REGEX_LITERAL:
            localctx = new RegexLiteralContext(this, localctx);
            this.enterOuterAlt(localctx, 4);
            this.state = 123;
            this.match(DataflowParser.REGEX_LITERAL);
            break;
        default:
            throw new antlr4.error.NoViableAltException(this);
        }
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};


function Integer_literalContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = DataflowParser.RULE_integer_literal;
    return this;
}

Integer_literalContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
Integer_literalContext.prototype.constructor = Integer_literalContext;

Integer_literalContext.prototype.DECIMAL_LITERAL = function() {
    return this.getToken(DataflowParser.DECIMAL_LITERAL, 0);
};

Integer_literalContext.prototype.HEX_LITERAL = function() {
    return this.getToken(DataflowParser.HEX_LITERAL, 0);
};

Integer_literalContext.prototype.OCT_LITERAL = function() {
    return this.getToken(DataflowParser.OCT_LITERAL, 0);
};

Integer_literalContext.prototype.BINARY_LITERAL = function() {
    return this.getToken(DataflowParser.BINARY_LITERAL, 0);
};

Integer_literalContext.prototype.enterRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.enterInteger_literal(this);
	}
};

Integer_literalContext.prototype.exitRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.exitInteger_literal(this);
	}
};

Integer_literalContext.prototype.accept = function(visitor) {
    if ( visitor instanceof DataflowParserVisitor ) {
        return visitor.visitInteger_literal(this);
    } else {
        return visitor.visitChildren(this);
    }
};




DataflowParser.Integer_literalContext = Integer_literalContext;

DataflowParser.prototype.integer_literal = function() {

    var localctx = new Integer_literalContext(this, this._ctx, this.state);
    this.enterRule(localctx, 2, DataflowParser.RULE_integer_literal);
    var _la = 0; // Token type
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 126;
        _la = this._input.LA(1);
        if(!((((_la) & ~0x1f) == 0 && ((1 << _la) & ((1 << DataflowParser.DECIMAL_LITERAL) | (1 << DataflowParser.HEX_LITERAL) | (1 << DataflowParser.OCT_LITERAL) | (1 << DataflowParser.BINARY_LITERAL))) !== 0))) {
        this._errHandler.recoverInline(this);
        }
        else {
        	this._errHandler.reportMatch(this);
            this.consume();
        }
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};


function Index_literalContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = DataflowParser.RULE_index_literal;
    return this;
}

Index_literalContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
Index_literalContext.prototype.constructor = Index_literalContext;

Index_literalContext.prototype.DECIMAL_LITERAL = function() {
    return this.getToken(DataflowParser.DECIMAL_LITERAL, 0);
};

Index_literalContext.prototype.enterRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.enterIndex_literal(this);
	}
};

Index_literalContext.prototype.exitRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.exitIndex_literal(this);
	}
};

Index_literalContext.prototype.accept = function(visitor) {
    if ( visitor instanceof DataflowParserVisitor ) {
        return visitor.visitIndex_literal(this);
    } else {
        return visitor.visitChildren(this);
    }
};




DataflowParser.Index_literalContext = Index_literalContext;

DataflowParser.prototype.index_literal = function() {

    var localctx = new Index_literalContext(this, this._ctx, this.state);
    this.enterRule(localctx, 4, DataflowParser.RULE_index_literal);
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 128;
        this.match(DataflowParser.DECIMAL_LITERAL);
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};


function Format_literalContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = DataflowParser.RULE_format_literal;
    return this;
}

Format_literalContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
Format_literalContext.prototype.constructor = Format_literalContext;

Format_literalContext.prototype.STRING_LITERAL = function() {
    return this.getToken(DataflowParser.STRING_LITERAL, 0);
};

Format_literalContext.prototype.enterRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.enterFormat_literal(this);
	}
};

Format_literalContext.prototype.exitRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.exitFormat_literal(this);
	}
};

Format_literalContext.prototype.accept = function(visitor) {
    if ( visitor instanceof DataflowParserVisitor ) {
        return visitor.visitFormat_literal(this);
    } else {
        return visitor.visitChildren(this);
    }
};




DataflowParser.Format_literalContext = Format_literalContext;

DataflowParser.prototype.format_literal = function() {

    var localctx = new Format_literalContext(this, this._ctx, this.state);
    this.enterRule(localctx, 6, DataflowParser.RULE_format_literal);
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 130;
        this.match(DataflowParser.STRING_LITERAL);
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};


function Extension_literalContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = DataflowParser.RULE_extension_literal;
    return this;
}

Extension_literalContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
Extension_literalContext.prototype.constructor = Extension_literalContext;

Extension_literalContext.prototype.STRING_LITERAL = function() {
    return this.getToken(DataflowParser.STRING_LITERAL, 0);
};

Extension_literalContext.prototype.enterRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.enterExtension_literal(this);
	}
};

Extension_literalContext.prototype.exitRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.exitExtension_literal(this);
	}
};

Extension_literalContext.prototype.accept = function(visitor) {
    if ( visitor instanceof DataflowParserVisitor ) {
        return visitor.visitExtension_literal(this);
    } else {
        return visitor.visitChildren(this);
    }
};




DataflowParser.Extension_literalContext = Extension_literalContext;

DataflowParser.prototype.extension_literal = function() {

    var localctx = new Extension_literalContext(this, this._ctx, this.state);
    this.enterRule(localctx, 8, DataflowParser.RULE_extension_literal);
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 132;
        this.match(DataflowParser.STRING_LITERAL);
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};


function Float_literalContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = DataflowParser.RULE_float_literal;
    return this;
}

Float_literalContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
Float_literalContext.prototype.constructor = Float_literalContext;

Float_literalContext.prototype.FLOAT_LITERAL = function() {
    return this.getToken(DataflowParser.FLOAT_LITERAL, 0);
};

Float_literalContext.prototype.HEX_FLOAT_LITERAL = function() {
    return this.getToken(DataflowParser.HEX_FLOAT_LITERAL, 0);
};

Float_literalContext.prototype.enterRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.enterFloat_literal(this);
	}
};

Float_literalContext.prototype.exitRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.exitFloat_literal(this);
	}
};

Float_literalContext.prototype.accept = function(visitor) {
    if ( visitor instanceof DataflowParserVisitor ) {
        return visitor.visitFloat_literal(this);
    } else {
        return visitor.visitChildren(this);
    }
};




DataflowParser.Float_literalContext = Float_literalContext;

DataflowParser.prototype.float_literal = function() {

    var localctx = new Float_literalContext(this, this._ctx, this.state);
    this.enterRule(localctx, 10, DataflowParser.RULE_float_literal);
    var _la = 0; // Token type
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 134;
        _la = this._input.LA(1);
        if(!(_la===DataflowParser.FLOAT_LITERAL || _la===DataflowParser.HEX_FLOAT_LITERAL)) {
        this._errHandler.recoverInline(this);
        }
        else {
        	this._errHandler.reportMatch(this);
            this.consume();
        }
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};


function TypeNamesContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = DataflowParser.RULE_typeNames;
    return this;
}

TypeNamesContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
TypeNamesContext.prototype.constructor = TypeNamesContext;

TypeNamesContext.prototype.INTEGER = function() {
    return this.getToken(DataflowParser.INTEGER, 0);
};

TypeNamesContext.prototype.SHORT = function() {
    return this.getToken(DataflowParser.SHORT, 0);
};

TypeNamesContext.prototype.LONG = function() {
    return this.getToken(DataflowParser.LONG, 0);
};

TypeNamesContext.prototype.FLOAT = function() {
    return this.getToken(DataflowParser.FLOAT, 0);
};

TypeNamesContext.prototype.DOUBLE = function() {
    return this.getToken(DataflowParser.DOUBLE, 0);
};

TypeNamesContext.prototype.DECIMAL = function() {
    return this.getToken(DataflowParser.DECIMAL, 0);
};

TypeNamesContext.prototype.BYTE = function() {
    return this.getToken(DataflowParser.BYTE, 0);
};

TypeNamesContext.prototype.BINARY = function() {
    return this.getToken(DataflowParser.BINARY, 0);
};

TypeNamesContext.prototype.DATE = function() {
    return this.getToken(DataflowParser.DATE, 0);
};

TypeNamesContext.prototype.BOOLEAN = function() {
    return this.getToken(DataflowParser.BOOLEAN, 0);
};

TypeNamesContext.prototype.TIMESTAMP = function() {
    return this.getToken(DataflowParser.TIMESTAMP, 0);
};

TypeNamesContext.prototype.INTEGRAL = function() {
    return this.getToken(DataflowParser.INTEGRAL, 0);
};

TypeNamesContext.prototype.FRACTIONAL = function() {
    return this.getToken(DataflowParser.FRACTIONAL, 0);
};

TypeNamesContext.prototype.NUMBER = function() {
    return this.getToken(DataflowParser.NUMBER, 0);
};

TypeNamesContext.prototype.ANY_SIMPLE = function() {
    return this.getToken(DataflowParser.ANY_SIMPLE, 0);
};

TypeNamesContext.prototype.enterRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.enterTypeNames(this);
	}
};

TypeNamesContext.prototype.exitRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.exitTypeNames(this);
	}
};

TypeNamesContext.prototype.accept = function(visitor) {
    if ( visitor instanceof DataflowParserVisitor ) {
        return visitor.visitTypeNames(this);
    } else {
        return visitor.visitChildren(this);
    }
};




DataflowParser.TypeNamesContext = TypeNamesContext;

DataflowParser.prototype.typeNames = function() {

    var localctx = new TypeNamesContext(this, this._ctx, this.state);
    this.enterRule(localctx, 12, DataflowParser.RULE_typeNames);
    var _la = 0; // Token type
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 136;
        _la = this._input.LA(1);
        if(!(((((_la - 59)) & ~0x1f) == 0 && ((1 << (_la - 59)) & ((1 << (DataflowParser.INTEGER - 59)) | (1 << (DataflowParser.SHORT - 59)) | (1 << (DataflowParser.LONG - 59)) | (1 << (DataflowParser.DOUBLE - 59)) | (1 << (DataflowParser.FLOAT - 59)) | (1 << (DataflowParser.DECIMAL - 59)) | (1 << (DataflowParser.BOOLEAN - 59)) | (1 << (DataflowParser.TIMESTAMP - 59)) | (1 << (DataflowParser.DATE - 59)) | (1 << (DataflowParser.BYTE - 59)) | (1 << (DataflowParser.BINARY - 59)) | (1 << (DataflowParser.INTEGRAL - 59)) | (1 << (DataflowParser.NUMBER - 59)) | (1 << (DataflowParser.FRACTIONAL - 59)) | (1 << (DataflowParser.ANY_SIMPLE - 59)))) !== 0))) {
        this._errHandler.recoverInline(this);
        }
        else {
        	this._errHandler.reportMatch(this);
            this.consume();
        }
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};


function KeywordContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = DataflowParser.RULE_keyword;
    return this;
}

KeywordContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
KeywordContext.prototype.constructor = KeywordContext;

KeywordContext.prototype.PARAMETERS = function() {
    return this.getToken(DataflowParser.PARAMETERS, 0);
};

KeywordContext.prototype.FUNCTIONS = function() {
    return this.getToken(DataflowParser.FUNCTIONS, 0);
};

KeywordContext.prototype.AS = function() {
    return this.getToken(DataflowParser.AS, 0);
};

KeywordContext.prototype.INPUT = function() {
    return this.getToken(DataflowParser.INPUT, 0);
};

KeywordContext.prototype.OUTPUT = function() {
    return this.getToken(DataflowParser.OUTPUT, 0);
};

KeywordContext.prototype.CONSTANT = function() {
    return this.getToken(DataflowParser.CONSTANT, 0);
};

KeywordContext.prototype.EXPRESSION = function() {
    return this.getToken(DataflowParser.EXPRESSION, 0);
};

KeywordContext.prototype.typeNames = function() {
    return this.getTypedRuleContext(TypeNamesContext,0);
};

KeywordContext.prototype.enterRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.enterKeyword(this);
	}
};

KeywordContext.prototype.exitRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.exitKeyword(this);
	}
};

KeywordContext.prototype.accept = function(visitor) {
    if ( visitor instanceof DataflowParserVisitor ) {
        return visitor.visitKeyword(this);
    } else {
        return visitor.visitChildren(this);
    }
};




DataflowParser.KeywordContext = KeywordContext;

DataflowParser.prototype.keyword = function() {

    var localctx = new KeywordContext(this, this._ctx, this.state);
    this.enterRule(localctx, 14, DataflowParser.RULE_keyword);
    try {
        this.state = 146;
        this._errHandler.sync(this);
        switch(this._input.LA(1)) {
        case DataflowParser.PARAMETERS:
            this.enterOuterAlt(localctx, 1);
            this.state = 138;
            this.match(DataflowParser.PARAMETERS);
            break;
        case DataflowParser.FUNCTIONS:
            this.enterOuterAlt(localctx, 2);
            this.state = 139;
            this.match(DataflowParser.FUNCTIONS);
            break;
        case DataflowParser.AS:
            this.enterOuterAlt(localctx, 3);
            this.state = 140;
            this.match(DataflowParser.AS);
            break;
        case DataflowParser.INPUT:
            this.enterOuterAlt(localctx, 4);
            this.state = 141;
            this.match(DataflowParser.INPUT);
            break;
        case DataflowParser.OUTPUT:
            this.enterOuterAlt(localctx, 5);
            this.state = 142;
            this.match(DataflowParser.OUTPUT);
            break;
        case DataflowParser.CONSTANT:
            this.enterOuterAlt(localctx, 6);
            this.state = 143;
            this.match(DataflowParser.CONSTANT);
            break;
        case DataflowParser.EXPRESSION:
            this.enterOuterAlt(localctx, 7);
            this.state = 144;
            this.match(DataflowParser.EXPRESSION);
            break;
        case DataflowParser.INTEGER:
        case DataflowParser.SHORT:
        case DataflowParser.LONG:
        case DataflowParser.DOUBLE:
        case DataflowParser.FLOAT:
        case DataflowParser.DECIMAL:
        case DataflowParser.BOOLEAN:
        case DataflowParser.TIMESTAMP:
        case DataflowParser.DATE:
        case DataflowParser.BYTE:
        case DataflowParser.BINARY:
        case DataflowParser.INTEGRAL:
        case DataflowParser.NUMBER:
        case DataflowParser.FRACTIONAL:
        case DataflowParser.ANY_SIMPLE:
            this.enterOuterAlt(localctx, 8);
            this.state = 145;
            this.typeNames();
            break;
        default:
            throw new antlr4.error.NoViableAltException(this);
        }
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};


function BasicNameContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = DataflowParser.RULE_basicName;
    return this;
}

BasicNameContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
BasicNameContext.prototype.constructor = BasicNameContext;

BasicNameContext.prototype.IDENTIFIER = function() {
    return this.getToken(DataflowParser.IDENTIFIER, 0);
};

BasicNameContext.prototype.keyword = function() {
    return this.getTypedRuleContext(KeywordContext,0);
};

BasicNameContext.prototype.enterRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.enterBasicName(this);
	}
};

BasicNameContext.prototype.exitRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.exitBasicName(this);
	}
};

BasicNameContext.prototype.accept = function(visitor) {
    if ( visitor instanceof DataflowParserVisitor ) {
        return visitor.visitBasicName(this);
    } else {
        return visitor.visitChildren(this);
    }
};




DataflowParser.BasicNameContext = BasicNameContext;

DataflowParser.prototype.basicName = function() {

    var localctx = new BasicNameContext(this, this._ctx, this.state);
    this.enterRule(localctx, 16, DataflowParser.RULE_basicName);
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 150;
        this._errHandler.sync(this);
        switch(this._input.LA(1)) {
        case DataflowParser.IDENTIFIER:
            this.state = 148;
            this.match(DataflowParser.IDENTIFIER);
            break;
        case DataflowParser.PARAMETERS:
        case DataflowParser.FUNCTIONS:
        case DataflowParser.AS:
        case DataflowParser.INPUT:
        case DataflowParser.OUTPUT:
        case DataflowParser.CONSTANT:
        case DataflowParser.EXPRESSION:
        case DataflowParser.INTEGER:
        case DataflowParser.SHORT:
        case DataflowParser.LONG:
        case DataflowParser.DOUBLE:
        case DataflowParser.FLOAT:
        case DataflowParser.DECIMAL:
        case DataflowParser.BOOLEAN:
        case DataflowParser.TIMESTAMP:
        case DataflowParser.DATE:
        case DataflowParser.BYTE:
        case DataflowParser.BINARY:
        case DataflowParser.INTEGRAL:
        case DataflowParser.NUMBER:
        case DataflowParser.FRACTIONAL:
        case DataflowParser.ANY_SIMPLE:
            this.state = 149;
            this.keyword();
            break;
        default:
            throw new antlr4.error.NoViableAltException(this);
        }
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};


function AnyNameContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = DataflowParser.RULE_anyName;
    return this;
}

AnyNameContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
AnyNameContext.prototype.constructor = AnyNameContext;

AnyNameContext.prototype.ANY_IDENTIFIER = function() {
    return this.getToken(DataflowParser.ANY_IDENTIFIER, 0);
};

AnyNameContext.prototype.keyword = function() {
    return this.getTypedRuleContext(KeywordContext,0);
};

AnyNameContext.prototype.enterRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.enterAnyName(this);
	}
};

AnyNameContext.prototype.exitRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.exitAnyName(this);
	}
};

AnyNameContext.prototype.accept = function(visitor) {
    if ( visitor instanceof DataflowParserVisitor ) {
        return visitor.visitAnyName(this);
    } else {
        return visitor.visitChildren(this);
    }
};




DataflowParser.AnyNameContext = AnyNameContext;

DataflowParser.prototype.anyName = function() {

    var localctx = new AnyNameContext(this, this._ctx, this.state);
    this.enterRule(localctx, 18, DataflowParser.RULE_anyName);
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 154;
        this._errHandler.sync(this);
        switch(this._input.LA(1)) {
        case DataflowParser.ANY_IDENTIFIER:
            this.state = 152;
            this.match(DataflowParser.ANY_IDENTIFIER);
            break;
        case DataflowParser.PARAMETERS:
        case DataflowParser.FUNCTIONS:
        case DataflowParser.AS:
        case DataflowParser.INPUT:
        case DataflowParser.OUTPUT:
        case DataflowParser.CONSTANT:
        case DataflowParser.EXPRESSION:
        case DataflowParser.INTEGER:
        case DataflowParser.SHORT:
        case DataflowParser.LONG:
        case DataflowParser.DOUBLE:
        case DataflowParser.FLOAT:
        case DataflowParser.DECIMAL:
        case DataflowParser.BOOLEAN:
        case DataflowParser.TIMESTAMP:
        case DataflowParser.DATE:
        case DataflowParser.BYTE:
        case DataflowParser.BINARY:
        case DataflowParser.INTEGRAL:
        case DataflowParser.NUMBER:
        case DataflowParser.FRACTIONAL:
        case DataflowParser.ANY_SIMPLE:
            this.state = 153;
            this.keyword();
            break;
        default:
            throw new antlr4.error.NoViableAltException(this);
        }
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};


function MemberIdentifierContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = DataflowParser.RULE_memberIdentifier;
    return this;
}

MemberIdentifierContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
MemberIdentifierContext.prototype.constructor = MemberIdentifierContext;

MemberIdentifierContext.prototype.basicName = function() {
    return this.getTypedRuleContext(BasicNameContext,0);
};

MemberIdentifierContext.prototype.enterRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.enterMemberIdentifier(this);
	}
};

MemberIdentifierContext.prototype.exitRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.exitMemberIdentifier(this);
	}
};

MemberIdentifierContext.prototype.accept = function(visitor) {
    if ( visitor instanceof DataflowParserVisitor ) {
        return visitor.visitMemberIdentifier(this);
    } else {
        return visitor.visitChildren(this);
    }
};




DataflowParser.MemberIdentifierContext = MemberIdentifierContext;

DataflowParser.prototype.memberIdentifier = function() {

    var localctx = new MemberIdentifierContext(this, this._ctx, this.state);
    this.enterRule(localctx, 20, DataflowParser.RULE_memberIdentifier);
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 156;
        this.basicName();
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};


function ColumnIdentifierContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = DataflowParser.RULE_columnIdentifier;
    return this;
}

ColumnIdentifierContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
ColumnIdentifierContext.prototype.constructor = ColumnIdentifierContext;

ColumnIdentifierContext.prototype.basicName = function() {
    return this.getTypedRuleContext(BasicNameContext,0);
};

ColumnIdentifierContext.prototype.anyName = function() {
    return this.getTypedRuleContext(AnyNameContext,0);
};

ColumnIdentifierContext.prototype.enterRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.enterColumnIdentifier(this);
	}
};

ColumnIdentifierContext.prototype.exitRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.exitColumnIdentifier(this);
	}
};

ColumnIdentifierContext.prototype.accept = function(visitor) {
    if ( visitor instanceof DataflowParserVisitor ) {
        return visitor.visitColumnIdentifier(this);
    } else {
        return visitor.visitChildren(this);
    }
};




DataflowParser.ColumnIdentifierContext = ColumnIdentifierContext;

DataflowParser.prototype.columnIdentifier = function() {

    var localctx = new ColumnIdentifierContext(this, this._ctx, this.state);
    this.enterRule(localctx, 22, DataflowParser.RULE_columnIdentifier);
    try {
        this.state = 160;
        this._errHandler.sync(this);
        var la_ = this._interp.adaptivePredict(this._input,4,this._ctx);
        switch(la_) {
        case 1:
            this.enterOuterAlt(localctx, 1);
            this.state = 158;
            this.basicName();
            break;

        case 2:
            this.enterOuterAlt(localctx, 2);
            this.state = 159;
            this.anyName();
            break;

        }
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};


function VariableReferenceContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = DataflowParser.RULE_variableReference;
    return this;
}

VariableReferenceContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
VariableReferenceContext.prototype.constructor = VariableReferenceContext;

VariableReferenceContext.prototype.TILDA = function() {
    return this.getToken(DataflowParser.TILDA, 0);
};

VariableReferenceContext.prototype.basicName = function() {
    return this.getTypedRuleContext(BasicNameContext,0);
};

VariableReferenceContext.prototype.enterRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.enterVariableReference(this);
	}
};

VariableReferenceContext.prototype.exitRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.exitVariableReference(this);
	}
};

VariableReferenceContext.prototype.accept = function(visitor) {
    if ( visitor instanceof DataflowParserVisitor ) {
        return visitor.visitVariableReference(this);
    } else {
        return visitor.visitChildren(this);
    }
};




DataflowParser.VariableReferenceContext = VariableReferenceContext;

DataflowParser.prototype.variableReference = function() {

    var localctx = new VariableReferenceContext(this, this._ctx, this.state);
    this.enterRule(localctx, 24, DataflowParser.RULE_variableReference);
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 162;
        this.match(DataflowParser.TILDA);
        this.state = 163;
        this.basicName();
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};


function MetaVariableReferenceContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = DataflowParser.RULE_metaVariableReference;
    return this;
}

MetaVariableReferenceContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
MetaVariableReferenceContext.prototype.constructor = MetaVariableReferenceContext;

MetaVariableReferenceContext.prototype.META_VARIABLE = function() {
    return this.getToken(DataflowParser.META_VARIABLE, 0);
};

MetaVariableReferenceContext.prototype.enterRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.enterMetaVariableReference(this);
	}
};

MetaVariableReferenceContext.prototype.exitRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.exitMetaVariableReference(this);
	}
};

MetaVariableReferenceContext.prototype.accept = function(visitor) {
    if ( visitor instanceof DataflowParserVisitor ) {
        return visitor.visitMetaVariableReference(this);
    } else {
        return visitor.visitChildren(this);
    }
};




DataflowParser.MetaVariableReferenceContext = MetaVariableReferenceContext;

DataflowParser.prototype.metaVariableReference = function() {

    var localctx = new MetaVariableReferenceContext(this, this._ctx, this.state);
    this.enterRule(localctx, 26, DataflowParser.RULE_metaVariableReference);
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 165;
        this.match(DataflowParser.META_VARIABLE);
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};


function MetaPosReferenceContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = DataflowParser.RULE_metaPosReference;
    return this;
}

MetaPosReferenceContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
MetaPosReferenceContext.prototype.constructor = MetaPosReferenceContext;

MetaPosReferenceContext.prototype.META_POS = function() {
    return this.getToken(DataflowParser.META_POS, 0);
};

MetaPosReferenceContext.prototype.enterRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.enterMetaPosReference(this);
	}
};

MetaPosReferenceContext.prototype.exitRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.exitMetaPosReference(this);
	}
};

MetaPosReferenceContext.prototype.accept = function(visitor) {
    if ( visitor instanceof DataflowParserVisitor ) {
        return visitor.visitMetaPosReference(this);
    } else {
        return visitor.visitChildren(this);
    }
};




DataflowParser.MetaPosReferenceContext = MetaPosReferenceContext;

DataflowParser.prototype.metaPosReference = function() {

    var localctx = new MetaPosReferenceContext(this, this._ctx, this.state);
    this.enterRule(localctx, 28, DataflowParser.RULE_metaPosReference);
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 167;
        this.match(DataflowParser.META_POS);
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};


function MetaMatchReferenceContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = DataflowParser.RULE_metaMatchReference;
    return this;
}

MetaMatchReferenceContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
MetaMatchReferenceContext.prototype.constructor = MetaMatchReferenceContext;

MetaMatchReferenceContext.prototype.META_MATCH = function() {
    return this.getToken(DataflowParser.META_MATCH, 0);
};

MetaMatchReferenceContext.prototype.enterRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.enterMetaMatchReference(this);
	}
};

MetaMatchReferenceContext.prototype.exitRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.exitMetaMatchReference(this);
	}
};

MetaMatchReferenceContext.prototype.accept = function(visitor) {
    if ( visitor instanceof DataflowParserVisitor ) {
        return visitor.visitMetaMatchReference(this);
    } else {
        return visitor.visitChildren(this);
    }
};




DataflowParser.MetaMatchReferenceContext = MetaMatchReferenceContext;

DataflowParser.prototype.metaMatchReference = function() {

    var localctx = new MetaMatchReferenceContext(this, this._ctx, this.state);
    this.enterRule(localctx, 30, DataflowParser.RULE_metaMatchReference);
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 169;
        this.match(DataflowParser.META_MATCH);
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};


function MetaArgumentReferenceContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = DataflowParser.RULE_metaArgumentReference;
    return this;
}

MetaArgumentReferenceContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
MetaArgumentReferenceContext.prototype.constructor = MetaArgumentReferenceContext;

MetaArgumentReferenceContext.prototype.HASH = function() {
    return this.getToken(DataflowParser.HASH, 0);
};

MetaArgumentReferenceContext.prototype.basicName = function() {
    return this.getTypedRuleContext(BasicNameContext,0);
};

MetaArgumentReferenceContext.prototype.enterRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.enterMetaArgumentReference(this);
	}
};

MetaArgumentReferenceContext.prototype.exitRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.exitMetaArgumentReference(this);
	}
};

MetaArgumentReferenceContext.prototype.accept = function(visitor) {
    if ( visitor instanceof DataflowParserVisitor ) {
        return visitor.visitMetaArgumentReference(this);
    } else {
        return visitor.visitChildren(this);
    }
};




DataflowParser.MetaArgumentReferenceContext = MetaArgumentReferenceContext;

DataflowParser.prototype.metaArgumentReference = function() {

    var localctx = new MetaArgumentReferenceContext(this, this._ctx, this.state);
    this.enterRule(localctx, 32, DataflowParser.RULE_metaArgumentReference);
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 171;
        this.match(DataflowParser.HASH);
        this.state = 172;
        this.basicName();
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};


function ParameterContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = DataflowParser.RULE_parameter;
    return this;
}

ParameterContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
ParameterContext.prototype.constructor = ParameterContext;

ParameterContext.prototype.basicName = function() {
    return this.getTypedRuleContext(BasicNameContext,0);
};

ParameterContext.prototype.enterRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.enterParameter(this);
	}
};

ParameterContext.prototype.exitRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.exitParameter(this);
	}
};

ParameterContext.prototype.accept = function(visitor) {
    if ( visitor instanceof DataflowParserVisitor ) {
        return visitor.visitParameter(this);
    } else {
        return visitor.visitChildren(this);
    }
};




DataflowParser.ParameterContext = ParameterContext;

DataflowParser.prototype.parameter = function() {

    var localctx = new ParameterContext(this, this._ctx, this.state);
    this.enterRule(localctx, 34, DataflowParser.RULE_parameter);
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 174;
        this.basicName();
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};


function VariableContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = DataflowParser.RULE_variable;
    return this;
}

VariableContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
VariableContext.prototype.constructor = VariableContext;

VariableContext.prototype.basicName = function() {
    return this.getTypedRuleContext(BasicNameContext,0);
};

VariableContext.prototype.enterRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.enterVariable(this);
	}
};

VariableContext.prototype.exitRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.exitVariable(this);
	}
};

VariableContext.prototype.accept = function(visitor) {
    if ( visitor instanceof DataflowParserVisitor ) {
        return visitor.visitVariable(this);
    } else {
        return visitor.visitChildren(this);
    }
};




DataflowParser.VariableContext = VariableContext;

DataflowParser.prototype.variable = function() {

    var localctx = new VariableContext(this, this._ctx, this.state);
    this.enterRule(localctx, 36, DataflowParser.RULE_variable);
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 176;
        this.basicName();
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};


function SectionNameContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = DataflowParser.RULE_sectionName;
    return this;
}

SectionNameContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
SectionNameContext.prototype.constructor = SectionNameContext;

SectionNameContext.prototype.IDENTIFIER = function() {
    return this.getToken(DataflowParser.IDENTIFIER, 0);
};

SectionNameContext.prototype.keyword = function() {
    return this.getTypedRuleContext(KeywordContext,0);
};

SectionNameContext.prototype.enterRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.enterSectionName(this);
	}
};

SectionNameContext.prototype.exitRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.exitSectionName(this);
	}
};

SectionNameContext.prototype.accept = function(visitor) {
    if ( visitor instanceof DataflowParserVisitor ) {
        return visitor.visitSectionName(this);
    } else {
        return visitor.visitChildren(this);
    }
};




DataflowParser.SectionNameContext = SectionNameContext;

DataflowParser.prototype.sectionName = function() {

    var localctx = new SectionNameContext(this, this._ctx, this.state);
    this.enterRule(localctx, 38, DataflowParser.RULE_sectionName);
    try {
        this.state = 180;
        this._errHandler.sync(this);
        switch(this._input.LA(1)) {
        case DataflowParser.IDENTIFIER:
            this.enterOuterAlt(localctx, 1);
            this.state = 178;
            this.match(DataflowParser.IDENTIFIER);
            break;
        case DataflowParser.PARAMETERS:
        case DataflowParser.FUNCTIONS:
        case DataflowParser.AS:
        case DataflowParser.INPUT:
        case DataflowParser.OUTPUT:
        case DataflowParser.CONSTANT:
        case DataflowParser.EXPRESSION:
        case DataflowParser.INTEGER:
        case DataflowParser.SHORT:
        case DataflowParser.LONG:
        case DataflowParser.DOUBLE:
        case DataflowParser.FLOAT:
        case DataflowParser.DECIMAL:
        case DataflowParser.BOOLEAN:
        case DataflowParser.TIMESTAMP:
        case DataflowParser.DATE:
        case DataflowParser.BYTE:
        case DataflowParser.BINARY:
        case DataflowParser.INTEGRAL:
        case DataflowParser.NUMBER:
        case DataflowParser.FRACTIONAL:
        case DataflowParser.ANY_SIMPLE:
            this.enterOuterAlt(localctx, 2);
            this.state = 179;
            this.keyword();
            break;
        default:
            throw new antlr4.error.NoViableAltException(this);
        }
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};


function BasicFunctionContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = DataflowParser.RULE_basicFunction;
    return this;
}

BasicFunctionContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
BasicFunctionContext.prototype.constructor = BasicFunctionContext;

BasicFunctionContext.prototype.basicName = function() {
    return this.getTypedRuleContext(BasicNameContext,0);
};

BasicFunctionContext.prototype.OPEN_PAREN = function() {
    return this.getToken(DataflowParser.OPEN_PAREN, 0);
};

BasicFunctionContext.prototype.CLOSE_PAREN = function() {
    return this.getToken(DataflowParser.CLOSE_PAREN, 0);
};

BasicFunctionContext.prototype.expression = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(ExpressionContext);
    } else {
        return this.getTypedRuleContext(ExpressionContext,i);
    }
};

BasicFunctionContext.prototype.COMMA = function(i) {
	if(i===undefined) {
		i = null;
	}
    if(i===null) {
        return this.getTokens(DataflowParser.COMMA);
    } else {
        return this.getToken(DataflowParser.COMMA, i);
    }
};


BasicFunctionContext.prototype.enterRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.enterBasicFunction(this);
	}
};

BasicFunctionContext.prototype.exitRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.exitBasicFunction(this);
	}
};

BasicFunctionContext.prototype.accept = function(visitor) {
    if ( visitor instanceof DataflowParserVisitor ) {
        return visitor.visitBasicFunction(this);
    } else {
        return visitor.visitChildren(this);
    }
};




DataflowParser.BasicFunctionContext = BasicFunctionContext;

DataflowParser.prototype.basicFunction = function() {

    var localctx = new BasicFunctionContext(this, this._ctx, this.state);
    this.enterRule(localctx, 40, DataflowParser.RULE_basicFunction);
    var _la = 0; // Token type
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 182;
        this.basicName();
        this.state = 183;
        this.match(DataflowParser.OPEN_PAREN);
        this.state = 192;
        this._errHandler.sync(this);
        _la = this._input.LA(1);
        if((((_la) & ~0x1f) == 0 && ((1 << _la) & ((1 << DataflowParser.DECIMAL_LITERAL) | (1 << DataflowParser.HEX_LITERAL) | (1 << DataflowParser.OCT_LITERAL) | (1 << DataflowParser.BINARY_LITERAL) | (1 << DataflowParser.MINUS) | (1 << DataflowParser.NOT) | (1 << DataflowParser.DOLLAR) | (1 << DataflowParser.TILDA) | (1 << DataflowParser.COLON) | (1 << DataflowParser.OPEN_PAREN))) !== 0) || ((((_la - 33)) & ~0x1f) == 0 && ((1 << (_la - 33)) & ((1 << (DataflowParser.HASH - 33)) | (1 << (DataflowParser.OPEN_SQ - 33)) | (1 << (DataflowParser.OPEN_STRUCT - 33)) | (1 << (DataflowParser.OPEN_CLOSE_SQ - 33)) | (1 << (DataflowParser.FLOAT_LITERAL - 33)) | (1 << (DataflowParser.HEX_FLOAT_LITERAL - 33)) | (1 << (DataflowParser.STRING_LITERAL - 33)) | (1 << (DataflowParser.REGEX_LITERAL - 33)) | (1 << (DataflowParser.PARAMETERS - 33)) | (1 << (DataflowParser.FUNCTIONS - 33)) | (1 << (DataflowParser.AS - 33)) | (1 << (DataflowParser.INPUT - 33)) | (1 << (DataflowParser.OUTPUT - 33)) | (1 << (DataflowParser.CONSTANT - 33)) | (1 << (DataflowParser.EXPRESSION - 33)) | (1 << (DataflowParser.INTEGER - 33)) | (1 << (DataflowParser.SHORT - 33)) | (1 << (DataflowParser.LONG - 33)) | (1 << (DataflowParser.DOUBLE - 33)) | (1 << (DataflowParser.FLOAT - 33)) | (1 << (DataflowParser.DECIMAL - 33)))) !== 0) || ((((_la - 65)) & ~0x1f) == 0 && ((1 << (_la - 65)) & ((1 << (DataflowParser.BOOLEAN - 65)) | (1 << (DataflowParser.TIMESTAMP - 65)) | (1 << (DataflowParser.DATE - 65)) | (1 << (DataflowParser.BYTE - 65)) | (1 << (DataflowParser.BINARY - 65)) | (1 << (DataflowParser.INTEGRAL - 65)) | (1 << (DataflowParser.NUMBER - 65)) | (1 << (DataflowParser.FRACTIONAL - 65)) | (1 << (DataflowParser.ANY_SIMPLE - 65)) | (1 << (DataflowParser.IDENTIFIER - 65)) | (1 << (DataflowParser.ANY_IDENTIFIER - 65)) | (1 << (DataflowParser.META_MATCH - 65)) | (1 << (DataflowParser.META_VARIABLE - 65)) | (1 << (DataflowParser.META_POS - 65)) | (1 << (DataflowParser.OPEN_INTERPOLATE - 65)) | (1 << (DataflowParser.COMMENT - 65)) | (1 << (DataflowParser.ANNOTATION_META_HEAD - 65)) | (1 << (DataflowParser.ANNOTATION_GROUP - 65)))) !== 0)) {
            this.state = 184;
            this.expression(0);
            this.state = 189;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            while(_la===DataflowParser.COMMA) {
                this.state = 185;
                this.match(DataflowParser.COMMA);
                this.state = 186;
                this.expression(0);
                this.state = 191;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
            }
        }

        this.state = 194;
        this.match(DataflowParser.CLOSE_PAREN);
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};


function MetafunctionContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = DataflowParser.RULE_metafunction;
    return this;
}

MetafunctionContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
MetafunctionContext.prototype.constructor = MetafunctionContext;

MetafunctionContext.prototype.basicName = function() {
    return this.getTypedRuleContext(BasicNameContext,0);
};

MetafunctionContext.prototype.OPEN_PAREN = function() {
    return this.getToken(DataflowParser.OPEN_PAREN, 0);
};

MetafunctionContext.prototype.CLOSE_PAREN = function() {
    return this.getToken(DataflowParser.CLOSE_PAREN, 0);
};

MetafunctionContext.prototype.expression = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(ExpressionContext);
    } else {
        return this.getTypedRuleContext(ExpressionContext,i);
    }
};

MetafunctionContext.prototype.assignment = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(AssignmentContext);
    } else {
        return this.getTypedRuleContext(AssignmentContext,i);
    }
};

MetafunctionContext.prototype.metaAssignment = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(MetaAssignmentContext);
    } else {
        return this.getTypedRuleContext(MetaAssignmentContext,i);
    }
};

MetafunctionContext.prototype.COMMA = function(i) {
	if(i===undefined) {
		i = null;
	}
    if(i===null) {
        return this.getTokens(DataflowParser.COMMA);
    } else {
        return this.getToken(DataflowParser.COMMA, i);
    }
};


MetafunctionContext.prototype.enterRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.enterMetafunction(this);
	}
};

MetafunctionContext.prototype.exitRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.exitMetafunction(this);
	}
};

MetafunctionContext.prototype.accept = function(visitor) {
    if ( visitor instanceof DataflowParserVisitor ) {
        return visitor.visitMetafunction(this);
    } else {
        return visitor.visitChildren(this);
    }
};




DataflowParser.MetafunctionContext = MetafunctionContext;

DataflowParser.prototype.metafunction = function() {

    var localctx = new MetafunctionContext(this, this._ctx, this.state);
    this.enterRule(localctx, 42, DataflowParser.RULE_metafunction);
    var _la = 0; // Token type
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 196;
        this.basicName();
        this.state = 197;
        this.match(DataflowParser.OPEN_PAREN);
        this.state = 214;
        this._errHandler.sync(this);
        _la = this._input.LA(1);
        if((((_la) & ~0x1f) == 0 && ((1 << _la) & ((1 << DataflowParser.DECIMAL_LITERAL) | (1 << DataflowParser.HEX_LITERAL) | (1 << DataflowParser.OCT_LITERAL) | (1 << DataflowParser.BINARY_LITERAL) | (1 << DataflowParser.MINUS) | (1 << DataflowParser.NOT) | (1 << DataflowParser.DOLLAR) | (1 << DataflowParser.TILDA) | (1 << DataflowParser.COLON) | (1 << DataflowParser.OPEN_PAREN))) !== 0) || ((((_la - 33)) & ~0x1f) == 0 && ((1 << (_la - 33)) & ((1 << (DataflowParser.HASH - 33)) | (1 << (DataflowParser.OPEN_SQ - 33)) | (1 << (DataflowParser.OPEN_STRUCT - 33)) | (1 << (DataflowParser.OPEN_CLOSE_SQ - 33)) | (1 << (DataflowParser.FLOAT_LITERAL - 33)) | (1 << (DataflowParser.HEX_FLOAT_LITERAL - 33)) | (1 << (DataflowParser.STRING_LITERAL - 33)) | (1 << (DataflowParser.REGEX_LITERAL - 33)) | (1 << (DataflowParser.PARAMETERS - 33)) | (1 << (DataflowParser.FUNCTIONS - 33)) | (1 << (DataflowParser.AS - 33)) | (1 << (DataflowParser.INPUT - 33)) | (1 << (DataflowParser.OUTPUT - 33)) | (1 << (DataflowParser.CONSTANT - 33)) | (1 << (DataflowParser.EXPRESSION - 33)) | (1 << (DataflowParser.INTEGER - 33)) | (1 << (DataflowParser.SHORT - 33)) | (1 << (DataflowParser.LONG - 33)) | (1 << (DataflowParser.DOUBLE - 33)) | (1 << (DataflowParser.FLOAT - 33)) | (1 << (DataflowParser.DECIMAL - 33)))) !== 0) || ((((_la - 65)) & ~0x1f) == 0 && ((1 << (_la - 65)) & ((1 << (DataflowParser.BOOLEAN - 65)) | (1 << (DataflowParser.TIMESTAMP - 65)) | (1 << (DataflowParser.DATE - 65)) | (1 << (DataflowParser.BYTE - 65)) | (1 << (DataflowParser.BINARY - 65)) | (1 << (DataflowParser.INTEGRAL - 65)) | (1 << (DataflowParser.NUMBER - 65)) | (1 << (DataflowParser.FRACTIONAL - 65)) | (1 << (DataflowParser.ANY_SIMPLE - 65)) | (1 << (DataflowParser.IDENTIFIER - 65)) | (1 << (DataflowParser.ANY_IDENTIFIER - 65)) | (1 << (DataflowParser.META_MATCH - 65)) | (1 << (DataflowParser.META_VARIABLE - 65)) | (1 << (DataflowParser.META_POS - 65)) | (1 << (DataflowParser.OPEN_INTERPOLATE - 65)) | (1 << (DataflowParser.COMMENT - 65)) | (1 << (DataflowParser.ANNOTATION_META_HEAD - 65)) | (1 << (DataflowParser.ANNOTATION_GROUP - 65)))) !== 0)) {
            this.state = 201;
            this._errHandler.sync(this);
            var la_ = this._interp.adaptivePredict(this._input,8,this._ctx);
            switch(la_) {
            case 1:
                this.state = 198;
                this.expression(0);
                break;

            case 2:
                this.state = 199;
                this.assignment();
                break;

            case 3:
                this.state = 200;
                this.metaAssignment();
                break;

            }
            this.state = 211;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            while(_la===DataflowParser.COMMA) {
                this.state = 203;
                this.match(DataflowParser.COMMA);
                this.state = 207;
                this._errHandler.sync(this);
                var la_ = this._interp.adaptivePredict(this._input,9,this._ctx);
                switch(la_) {
                case 1:
                    this.state = 204;
                    this.expression(0);
                    break;

                case 2:
                    this.state = 205;
                    this.assignment();
                    break;

                case 3:
                    this.state = 206;
                    this.metaAssignment();
                    break;

                }
                this.state = 213;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
            }
        }

        this.state = 216;
        this.match(DataflowParser.CLOSE_PAREN);
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};


function NameContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = DataflowParser.RULE_name;
    return this;
}

NameContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
NameContext.prototype.constructor = NameContext;


 
NameContext.prototype.copyFrom = function(ctx) {
    antlr4.ParserRuleContext.prototype.copyFrom.call(this, ctx);
};


function AnySelectorContext(parser, ctx) {
	NameContext.call(this, parser);
    NameContext.prototype.copyFrom.call(this, ctx);
    return this;
}

AnySelectorContext.prototype = Object.create(NameContext.prototype);
AnySelectorContext.prototype.constructor = AnySelectorContext;

DataflowParser.AnySelectorContext = AnySelectorContext;

AnySelectorContext.prototype.anyName = function() {
    return this.getTypedRuleContext(AnyNameContext,0);
};
AnySelectorContext.prototype.enterRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.enterAnySelector(this);
	}
};

AnySelectorContext.prototype.exitRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.exitAnySelector(this);
	}
};

AnySelectorContext.prototype.accept = function(visitor) {
    if ( visitor instanceof DataflowParserVisitor ) {
        return visitor.visitAnySelector(this);
    } else {
        return visitor.visitChildren(this);
    }
};


function BasicSelectorContext(parser, ctx) {
	NameContext.call(this, parser);
    NameContext.prototype.copyFrom.call(this, ctx);
    return this;
}

BasicSelectorContext.prototype = Object.create(NameContext.prototype);
BasicSelectorContext.prototype.constructor = BasicSelectorContext;

DataflowParser.BasicSelectorContext = BasicSelectorContext;

BasicSelectorContext.prototype.basicName = function() {
    return this.getTypedRuleContext(BasicNameContext,0);
};
BasicSelectorContext.prototype.enterRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.enterBasicSelector(this);
	}
};

BasicSelectorContext.prototype.exitRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.exitBasicSelector(this);
	}
};

BasicSelectorContext.prototype.accept = function(visitor) {
    if ( visitor instanceof DataflowParserVisitor ) {
        return visitor.visitBasicSelector(this);
    } else {
        return visitor.visitChildren(this);
    }
};



DataflowParser.NameContext = NameContext;

DataflowParser.prototype.name = function() {

    var localctx = new NameContext(this, this._ctx, this.state);
    this.enterRule(localctx, 44, DataflowParser.RULE_name);
    try {
        this.state = 220;
        this._errHandler.sync(this);
        var la_ = this._interp.adaptivePredict(this._input,12,this._ctx);
        switch(la_) {
        case 1:
            localctx = new BasicSelectorContext(this, localctx);
            this.enterOuterAlt(localctx, 1);
            this.state = 218;
            this.basicName();
            break;

        case 2:
            localctx = new AnySelectorContext(this, localctx);
            this.enterOuterAlt(localctx, 2);
            this.state = 219;
            this.anyName();
            break;

        }
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};


function ColumnOperandContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = DataflowParser.RULE_columnOperand;
    return this;
}

ColumnOperandContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
ColumnOperandContext.prototype.constructor = ColumnOperandContext;

ColumnOperandContext.prototype.name = function() {
    return this.getTypedRuleContext(NameContext,0);
};

ColumnOperandContext.prototype.ANNOTATION_GROUP = function(i) {
	if(i===undefined) {
		i = null;
	}
    if(i===null) {
        return this.getTokens(DataflowParser.ANNOTATION_GROUP);
    } else {
        return this.getToken(DataflowParser.ANNOTATION_GROUP, i);
    }
};


ColumnOperandContext.prototype.transformName = function() {
    return this.getTypedRuleContext(TransformNameContext,0);
};

ColumnOperandContext.prototype.AT = function(i) {
	if(i===undefined) {
		i = null;
	}
    if(i===null) {
        return this.getTokens(DataflowParser.AT);
    } else {
        return this.getToken(DataflowParser.AT, i);
    }
};


ColumnOperandContext.prototype.groupName = function() {
    return this.getTypedRuleContext(GroupNameContext,0);
};

ColumnOperandContext.prototype.enterRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.enterColumnOperand(this);
	}
};

ColumnOperandContext.prototype.exitRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.exitColumnOperand(this);
	}
};

ColumnOperandContext.prototype.accept = function(visitor) {
    if ( visitor instanceof DataflowParserVisitor ) {
        return visitor.visitColumnOperand(this);
    } else {
        return visitor.visitChildren(this);
    }
};




DataflowParser.ColumnOperandContext = ColumnOperandContext;

DataflowParser.prototype.columnOperand = function() {

    var localctx = new ColumnOperandContext(this, this._ctx, this.state);
    this.enterRule(localctx, 46, DataflowParser.RULE_columnOperand);
    var _la = 0; // Token type
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 231;
        this._errHandler.sync(this);
        _la = this._input.LA(1);
        if(_la===DataflowParser.ANNOTATION_GROUP) {
            this.state = 222;
            this.match(DataflowParser.ANNOTATION_GROUP);
            this.state = 223;
            this.transformName();
            this.state = 227;
            this._errHandler.sync(this);
            var la_ = this._interp.adaptivePredict(this._input,13,this._ctx);
            if(la_===1) {
                this.state = 224;
                this.match(DataflowParser.AT);
                this.state = 225;
                this.match(DataflowParser.ANNOTATION_GROUP);
                this.state = 226;
                this.groupName();

            }
            this.state = 229;
            this.match(DataflowParser.AT);
        }

        this.state = 233;
        this.name();
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};


function TransformFunctionContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = DataflowParser.RULE_transformFunction;
    return this;
}

TransformFunctionContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
TransformFunctionContext.prototype.constructor = TransformFunctionContext;

TransformFunctionContext.prototype.HASH = function() {
    return this.getToken(DataflowParser.HASH, 0);
};

TransformFunctionContext.prototype.basicName = function() {
    return this.getTypedRuleContext(BasicNameContext,0);
};

TransformFunctionContext.prototype.OPEN_PAREN = function() {
    return this.getToken(DataflowParser.OPEN_PAREN, 0);
};

TransformFunctionContext.prototype.CLOSE_PAREN = function() {
    return this.getToken(DataflowParser.CLOSE_PAREN, 0);
};

TransformFunctionContext.prototype.transformName = function() {
    return this.getTypedRuleContext(TransformNameContext,0);
};

TransformFunctionContext.prototype.expression = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(ExpressionContext);
    } else {
        return this.getTypedRuleContext(ExpressionContext,i);
    }
};

TransformFunctionContext.prototype.ANNOTATION_GROUP = function() {
    return this.getToken(DataflowParser.ANNOTATION_GROUP, 0);
};

TransformFunctionContext.prototype.AT = function() {
    return this.getToken(DataflowParser.AT, 0);
};

TransformFunctionContext.prototype.groupName = function() {
    return this.getTypedRuleContext(GroupNameContext,0);
};

TransformFunctionContext.prototype.COMMA = function(i) {
	if(i===undefined) {
		i = null;
	}
    if(i===null) {
        return this.getTokens(DataflowParser.COMMA);
    } else {
        return this.getToken(DataflowParser.COMMA, i);
    }
};


TransformFunctionContext.prototype.enterRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.enterTransformFunction(this);
	}
};

TransformFunctionContext.prototype.exitRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.exitTransformFunction(this);
	}
};

TransformFunctionContext.prototype.accept = function(visitor) {
    if ( visitor instanceof DataflowParserVisitor ) {
        return visitor.visitTransformFunction(this);
    } else {
        return visitor.visitChildren(this);
    }
};




DataflowParser.TransformFunctionContext = TransformFunctionContext;

DataflowParser.prototype.transformFunction = function() {

    var localctx = new TransformFunctionContext(this, this._ctx, this.state);
    this.enterRule(localctx, 48, DataflowParser.RULE_transformFunction);
    var _la = 0; // Token type
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 241;
        this._errHandler.sync(this);
        switch(this._input.LA(1)) {
        case DataflowParser.PARAMETERS:
        case DataflowParser.FUNCTIONS:
        case DataflowParser.AS:
        case DataflowParser.INPUT:
        case DataflowParser.OUTPUT:
        case DataflowParser.CONSTANT:
        case DataflowParser.EXPRESSION:
        case DataflowParser.INTEGER:
        case DataflowParser.SHORT:
        case DataflowParser.LONG:
        case DataflowParser.DOUBLE:
        case DataflowParser.FLOAT:
        case DataflowParser.DECIMAL:
        case DataflowParser.BOOLEAN:
        case DataflowParser.TIMESTAMP:
        case DataflowParser.DATE:
        case DataflowParser.BYTE:
        case DataflowParser.BINARY:
        case DataflowParser.INTEGRAL:
        case DataflowParser.NUMBER:
        case DataflowParser.FRACTIONAL:
        case DataflowParser.ANY_SIMPLE:
        case DataflowParser.IDENTIFIER:
            this.state = 235;
            this.transformName();
            break;
        case DataflowParser.ANNOTATION_GROUP:
            this.state = 236;
            this.match(DataflowParser.ANNOTATION_GROUP);
            this.state = 237;
            this.transformName();
            this.state = 238;
            this.match(DataflowParser.AT);
            this.state = 239;
            this.groupName();
            break;
        default:
            throw new antlr4.error.NoViableAltException(this);
        }
        this.state = 243;
        this.match(DataflowParser.HASH);
        this.state = 244;
        this.basicName();
        this.state = 245;
        this.match(DataflowParser.OPEN_PAREN);
        this.state = 254;
        this._errHandler.sync(this);
        _la = this._input.LA(1);
        if((((_la) & ~0x1f) == 0 && ((1 << _la) & ((1 << DataflowParser.DECIMAL_LITERAL) | (1 << DataflowParser.HEX_LITERAL) | (1 << DataflowParser.OCT_LITERAL) | (1 << DataflowParser.BINARY_LITERAL) | (1 << DataflowParser.MINUS) | (1 << DataflowParser.NOT) | (1 << DataflowParser.DOLLAR) | (1 << DataflowParser.TILDA) | (1 << DataflowParser.COLON) | (1 << DataflowParser.OPEN_PAREN))) !== 0) || ((((_la - 33)) & ~0x1f) == 0 && ((1 << (_la - 33)) & ((1 << (DataflowParser.HASH - 33)) | (1 << (DataflowParser.OPEN_SQ - 33)) | (1 << (DataflowParser.OPEN_STRUCT - 33)) | (1 << (DataflowParser.OPEN_CLOSE_SQ - 33)) | (1 << (DataflowParser.FLOAT_LITERAL - 33)) | (1 << (DataflowParser.HEX_FLOAT_LITERAL - 33)) | (1 << (DataflowParser.STRING_LITERAL - 33)) | (1 << (DataflowParser.REGEX_LITERAL - 33)) | (1 << (DataflowParser.PARAMETERS - 33)) | (1 << (DataflowParser.FUNCTIONS - 33)) | (1 << (DataflowParser.AS - 33)) | (1 << (DataflowParser.INPUT - 33)) | (1 << (DataflowParser.OUTPUT - 33)) | (1 << (DataflowParser.CONSTANT - 33)) | (1 << (DataflowParser.EXPRESSION - 33)) | (1 << (DataflowParser.INTEGER - 33)) | (1 << (DataflowParser.SHORT - 33)) | (1 << (DataflowParser.LONG - 33)) | (1 << (DataflowParser.DOUBLE - 33)) | (1 << (DataflowParser.FLOAT - 33)) | (1 << (DataflowParser.DECIMAL - 33)))) !== 0) || ((((_la - 65)) & ~0x1f) == 0 && ((1 << (_la - 65)) & ((1 << (DataflowParser.BOOLEAN - 65)) | (1 << (DataflowParser.TIMESTAMP - 65)) | (1 << (DataflowParser.DATE - 65)) | (1 << (DataflowParser.BYTE - 65)) | (1 << (DataflowParser.BINARY - 65)) | (1 << (DataflowParser.INTEGRAL - 65)) | (1 << (DataflowParser.NUMBER - 65)) | (1 << (DataflowParser.FRACTIONAL - 65)) | (1 << (DataflowParser.ANY_SIMPLE - 65)) | (1 << (DataflowParser.IDENTIFIER - 65)) | (1 << (DataflowParser.ANY_IDENTIFIER - 65)) | (1 << (DataflowParser.META_MATCH - 65)) | (1 << (DataflowParser.META_VARIABLE - 65)) | (1 << (DataflowParser.META_POS - 65)) | (1 << (DataflowParser.OPEN_INTERPOLATE - 65)) | (1 << (DataflowParser.COMMENT - 65)) | (1 << (DataflowParser.ANNOTATION_META_HEAD - 65)) | (1 << (DataflowParser.ANNOTATION_GROUP - 65)))) !== 0)) {
            this.state = 246;
            this.expression(0);
            this.state = 251;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            while(_la===DataflowParser.COMMA) {
                this.state = 247;
                this.match(DataflowParser.COMMA);
                this.state = 248;
                this.expression(0);
                this.state = 253;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
            }
        }

        this.state = 256;
        this.match(DataflowParser.CLOSE_PAREN);
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};


function TransientOperandContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = DataflowParser.RULE_transientOperand;
    return this;
}

TransientOperandContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
TransientOperandContext.prototype.constructor = TransientOperandContext;

TransientOperandContext.prototype.COLON = function() {
    return this.getToken(DataflowParser.COLON, 0);
};

TransientOperandContext.prototype.name = function() {
    return this.getTypedRuleContext(NameContext,0);
};

TransientOperandContext.prototype.enterRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.enterTransientOperand(this);
	}
};

TransientOperandContext.prototype.exitRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.exitTransientOperand(this);
	}
};

TransientOperandContext.prototype.accept = function(visitor) {
    if ( visitor instanceof DataflowParserVisitor ) {
        return visitor.visitTransientOperand(this);
    } else {
        return visitor.visitChildren(this);
    }
};




DataflowParser.TransientOperandContext = TransientOperandContext;

DataflowParser.prototype.transientOperand = function() {

    var localctx = new TransientOperandContext(this, this._ctx, this.state);
    this.enterRule(localctx, 50, DataflowParser.RULE_transientOperand);
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 258;
        this.match(DataflowParser.COLON);
        this.state = 259;
        this.name();
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};


function ParameterOperandContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = DataflowParser.RULE_parameterOperand;
    return this;
}

ParameterOperandContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
ParameterOperandContext.prototype.constructor = ParameterOperandContext;

ParameterOperandContext.prototype.DOLLAR = function() {
    return this.getToken(DataflowParser.DOLLAR, 0);
};

ParameterOperandContext.prototype.basicName = function() {
    return this.getTypedRuleContext(BasicNameContext,0);
};

ParameterOperandContext.prototype.enterRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.enterParameterOperand(this);
	}
};

ParameterOperandContext.prototype.exitRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.exitParameterOperand(this);
	}
};

ParameterOperandContext.prototype.accept = function(visitor) {
    if ( visitor instanceof DataflowParserVisitor ) {
        return visitor.visitParameterOperand(this);
    } else {
        return visitor.visitChildren(this);
    }
};




DataflowParser.ParameterOperandContext = ParameterOperandContext;

DataflowParser.prototype.parameterOperand = function() {

    var localctx = new ParameterOperandContext(this, this._ctx, this.state);
    this.enterRule(localctx, 52, DataflowParser.RULE_parameterOperand);
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 261;
        this.match(DataflowParser.DOLLAR);
        this.state = 262;
        this.basicName();
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};


function InterpolatePartsContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = DataflowParser.RULE_interpolateParts;
    return this;
}

InterpolatePartsContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
InterpolatePartsContext.prototype.constructor = InterpolatePartsContext;


 
InterpolatePartsContext.prototype.copyFrom = function(ctx) {
    antlr4.ParserRuleContext.prototype.copyFrom.call(this, ctx);
};


function InterpolateExprContext(parser, ctx) {
	InterpolatePartsContext.call(this, parser);
    InterpolatePartsContext.prototype.copyFrom.call(this, ctx);
    return this;
}

InterpolateExprContext.prototype = Object.create(InterpolatePartsContext.prototype);
InterpolateExprContext.prototype.constructor = InterpolateExprContext;

DataflowParser.InterpolateExprContext = InterpolateExprContext;

InterpolateExprContext.prototype.INTERPOLATE_OPEN_CURLY = function() {
    return this.getToken(DataflowParser.INTERPOLATE_OPEN_CURLY, 0);
};

InterpolateExprContext.prototype.expression = function() {
    return this.getTypedRuleContext(ExpressionContext,0);
};

InterpolateExprContext.prototype.CLOSE_CURLY = function() {
    return this.getToken(DataflowParser.CLOSE_CURLY, 0);
};
InterpolateExprContext.prototype.enterRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.enterInterpolateExpr(this);
	}
};

InterpolateExprContext.prototype.exitRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.exitInterpolateExpr(this);
	}
};

InterpolateExprContext.prototype.accept = function(visitor) {
    if ( visitor instanceof DataflowParserVisitor ) {
        return visitor.visitInterpolateExpr(this);
    } else {
        return visitor.visitChildren(this);
    }
};


function InterpolateTextContext(parser, ctx) {
	InterpolatePartsContext.call(this, parser);
    InterpolatePartsContext.prototype.copyFrom.call(this, ctx);
    return this;
}

InterpolateTextContext.prototype = Object.create(InterpolatePartsContext.prototype);
InterpolateTextContext.prototype.constructor = InterpolateTextContext;

DataflowParser.InterpolateTextContext = InterpolateTextContext;

InterpolateTextContext.prototype.INTERPOLATE_TEXT = function() {
    return this.getToken(DataflowParser.INTERPOLATE_TEXT, 0);
};
InterpolateTextContext.prototype.enterRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.enterInterpolateText(this);
	}
};

InterpolateTextContext.prototype.exitRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.exitInterpolateText(this);
	}
};

InterpolateTextContext.prototype.accept = function(visitor) {
    if ( visitor instanceof DataflowParserVisitor ) {
        return visitor.visitInterpolateText(this);
    } else {
        return visitor.visitChildren(this);
    }
};



DataflowParser.InterpolatePartsContext = InterpolatePartsContext;

DataflowParser.prototype.interpolateParts = function() {

    var localctx = new InterpolatePartsContext(this, this._ctx, this.state);
    this.enterRule(localctx, 54, DataflowParser.RULE_interpolateParts);
    try {
        this.state = 269;
        this._errHandler.sync(this);
        switch(this._input.LA(1)) {
        case DataflowParser.INTERPOLATE_TEXT:
            localctx = new InterpolateTextContext(this, localctx);
            this.enterOuterAlt(localctx, 1);
            this.state = 264;
            this.match(DataflowParser.INTERPOLATE_TEXT);
            break;
        case DataflowParser.INTERPOLATE_OPEN_CURLY:
            localctx = new InterpolateExprContext(this, localctx);
            this.enterOuterAlt(localctx, 2);
            this.state = 265;
            this.match(DataflowParser.INTERPOLATE_OPEN_CURLY);
            this.state = 266;
            this.expression(0);
            this.state = 267;
            this.match(DataflowParser.CLOSE_CURLY);
            break;
        default:
            throw new antlr4.error.NoViableAltException(this);
        }
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};


function ExpressionContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = DataflowParser.RULE_expression;
    return this;
}

ExpressionContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
ExpressionContext.prototype.constructor = ExpressionContext;


 
ExpressionContext.prototype.copyFrom = function(ctx) {
    antlr4.ParserRuleContext.prototype.copyFrom.call(this, ctx);
};

function CastContext(parser, ctx) {
	ExpressionContext.call(this, parser);
    this.left = null; // ExpressionContext;
    this.right = null; // InlineDatatypeContext;
    ExpressionContext.prototype.copyFrom.call(this, ctx);
    return this;
}

CastContext.prototype = Object.create(ExpressionContext.prototype);
CastContext.prototype.constructor = CastContext;

DataflowParser.CastContext = CastContext;

CastContext.prototype.QUESTION = function() {
    return this.getToken(DataflowParser.QUESTION, 0);
};

CastContext.prototype.expression = function() {
    return this.getTypedRuleContext(ExpressionContext,0);
};

CastContext.prototype.inlineDatatype = function() {
    return this.getTypedRuleContext(InlineDatatypeContext,0);
};
CastContext.prototype.enterRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.enterCast(this);
	}
};

CastContext.prototype.exitRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.exitCast(this);
	}
};

CastContext.prototype.accept = function(visitor) {
    if ( visitor instanceof DataflowParserVisitor ) {
        return visitor.visitCast(this);
    } else {
        return visitor.visitChildren(this);
    }
};


function AddMinusContext(parser, ctx) {
	ExpressionContext.call(this, parser);
    this.left = null; // ExpressionContext;
    this.op = null; // Token;
    this.right = null; // ExpressionContext;
    ExpressionContext.prototype.copyFrom.call(this, ctx);
    return this;
}

AddMinusContext.prototype = Object.create(ExpressionContext.prototype);
AddMinusContext.prototype.constructor = AddMinusContext;

DataflowParser.AddMinusContext = AddMinusContext;

AddMinusContext.prototype.expression = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(ExpressionContext);
    } else {
        return this.getTypedRuleContext(ExpressionContext,i);
    }
};

AddMinusContext.prototype.PLUS = function() {
    return this.getToken(DataflowParser.PLUS, 0);
};

AddMinusContext.prototype.MINUS = function() {
    return this.getToken(DataflowParser.MINUS, 0);
};
AddMinusContext.prototype.enterRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.enterAddMinus(this);
	}
};

AddMinusContext.prototype.exitRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.exitAddMinus(this);
	}
};

AddMinusContext.prototype.accept = function(visitor) {
    if ( visitor instanceof DataflowParserVisitor ) {
        return visitor.visitAddMinus(this);
    } else {
        return visitor.visitChildren(this);
    }
};


function VariableRefContext(parser, ctx) {
	ExpressionContext.call(this, parser);
    ExpressionContext.prototype.copyFrom.call(this, ctx);
    return this;
}

VariableRefContext.prototype = Object.create(ExpressionContext.prototype);
VariableRefContext.prototype.constructor = VariableRefContext;

DataflowParser.VariableRefContext = VariableRefContext;

VariableRefContext.prototype.variableReference = function() {
    return this.getTypedRuleContext(VariableReferenceContext,0);
};
VariableRefContext.prototype.enterRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.enterVariableRef(this);
	}
};

VariableRefContext.prototype.exitRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.exitVariableRef(this);
	}
};

VariableRefContext.prototype.accept = function(visitor) {
    if ( visitor instanceof DataflowParserVisitor ) {
        return visitor.visitVariableRef(this);
    } else {
        return visitor.visitChildren(this);
    }
};


function OrContext(parser, ctx) {
	ExpressionContext.call(this, parser);
    this.left = null; // ExpressionContext;
    this.right = null; // ExpressionContext;
    ExpressionContext.prototype.copyFrom.call(this, ctx);
    return this;
}

OrContext.prototype = Object.create(ExpressionContext.prototype);
OrContext.prototype.constructor = OrContext;

DataflowParser.OrContext = OrContext;

OrContext.prototype.OR = function() {
    return this.getToken(DataflowParser.OR, 0);
};

OrContext.prototype.expression = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(ExpressionContext);
    } else {
        return this.getTypedRuleContext(ExpressionContext,i);
    }
};
OrContext.prototype.enterRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.enterOr(this);
	}
};

OrContext.prototype.exitRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.exitOr(this);
	}
};

OrContext.prototype.accept = function(visitor) {
    if ( visitor instanceof DataflowParserVisitor ) {
        return visitor.visitOr(this);
    } else {
        return visitor.visitChildren(this);
    }
};


function ColumnOperandRefContext(parser, ctx) {
	ExpressionContext.call(this, parser);
    ExpressionContext.prototype.copyFrom.call(this, ctx);
    return this;
}

ColumnOperandRefContext.prototype = Object.create(ExpressionContext.prototype);
ColumnOperandRefContext.prototype.constructor = ColumnOperandRefContext;

DataflowParser.ColumnOperandRefContext = ColumnOperandRefContext;

ColumnOperandRefContext.prototype.columnOperand = function() {
    return this.getTypedRuleContext(ColumnOperandContext,0);
};
ColumnOperandRefContext.prototype.enterRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.enterColumnOperandRef(this);
	}
};

ColumnOperandRefContext.prototype.exitRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.exitColumnOperandRef(this);
	}
};

ColumnOperandRefContext.prototype.accept = function(visitor) {
    if ( visitor instanceof DataflowParserVisitor ) {
        return visitor.visitColumnOperandRef(this);
    } else {
        return visitor.visitChildren(this);
    }
};


function StructContext(parser, ctx) {
	ExpressionContext.call(this, parser);
    ExpressionContext.prototype.copyFrom.call(this, ctx);
    return this;
}

StructContext.prototype = Object.create(ExpressionContext.prototype);
StructContext.prototype.constructor = StructContext;

DataflowParser.StructContext = StructContext;

StructContext.prototype.OPEN_STRUCT = function() {
    return this.getToken(DataflowParser.OPEN_STRUCT, 0);
};

StructContext.prototype.CLOSE_PAREN = function() {
    return this.getToken(DataflowParser.CLOSE_PAREN, 0);
};

StructContext.prototype.expression = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(ExpressionContext);
    } else {
        return this.getTypedRuleContext(ExpressionContext,i);
    }
};

StructContext.prototype.assignment = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(AssignmentContext);
    } else {
        return this.getTypedRuleContext(AssignmentContext,i);
    }
};

StructContext.prototype.COMMA = function(i) {
	if(i===undefined) {
		i = null;
	}
    if(i===null) {
        return this.getTokens(DataflowParser.COMMA);
    } else {
        return this.getToken(DataflowParser.COMMA, i);
    }
};

StructContext.prototype.enterRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.enterStruct(this);
	}
};

StructContext.prototype.exitRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.exitStruct(this);
	}
};

StructContext.prototype.accept = function(visitor) {
    if ( visitor instanceof DataflowParserVisitor ) {
        return visitor.visitStruct(this);
    } else {
        return visitor.visitChildren(this);
    }
};


function MetaVariableRefContext(parser, ctx) {
	ExpressionContext.call(this, parser);
    ExpressionContext.prototype.copyFrom.call(this, ctx);
    return this;
}

MetaVariableRefContext.prototype = Object.create(ExpressionContext.prototype);
MetaVariableRefContext.prototype.constructor = MetaVariableRefContext;

DataflowParser.MetaVariableRefContext = MetaVariableRefContext;

MetaVariableRefContext.prototype.metaVariableReference = function() {
    return this.getTypedRuleContext(MetaVariableReferenceContext,0);
};
MetaVariableRefContext.prototype.enterRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.enterMetaVariableRef(this);
	}
};

MetaVariableRefContext.prototype.exitRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.exitMetaVariableRef(this);
	}
};

MetaVariableRefContext.prototype.accept = function(visitor) {
    if ( visitor instanceof DataflowParserVisitor ) {
        return visitor.visitMetaVariableRef(this);
    } else {
        return visitor.visitChildren(this);
    }
};


function MulDivModContext(parser, ctx) {
	ExpressionContext.call(this, parser);
    this.left = null; // ExpressionContext;
    this.op = null; // Token;
    this.right = null; // ExpressionContext;
    ExpressionContext.prototype.copyFrom.call(this, ctx);
    return this;
}

MulDivModContext.prototype = Object.create(ExpressionContext.prototype);
MulDivModContext.prototype.constructor = MulDivModContext;

DataflowParser.MulDivModContext = MulDivModContext;

MulDivModContext.prototype.expression = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(ExpressionContext);
    } else {
        return this.getTypedRuleContext(ExpressionContext,i);
    }
};

MulDivModContext.prototype.MUL = function() {
    return this.getToken(DataflowParser.MUL, 0);
};

MulDivModContext.prototype.SLASH = function() {
    return this.getToken(DataflowParser.SLASH, 0);
};

MulDivModContext.prototype.MOD = function() {
    return this.getToken(DataflowParser.MOD, 0);
};
MulDivModContext.prototype.enterRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.enterMulDivMod(this);
	}
};

MulDivModContext.prototype.exitRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.exitMulDivMod(this);
	}
};

MulDivModContext.prototype.accept = function(visitor) {
    if ( visitor instanceof DataflowParserVisitor ) {
        return visitor.visitMulDivMod(this);
    } else {
        return visitor.visitChildren(this);
    }
};


function EqNotEqContext(parser, ctx) {
	ExpressionContext.call(this, parser);
    this.left = null; // ExpressionContext;
    this.op = null; // Token;
    this.right = null; // ExpressionContext;
    ExpressionContext.prototype.copyFrom.call(this, ctx);
    return this;
}

EqNotEqContext.prototype = Object.create(ExpressionContext.prototype);
EqNotEqContext.prototype.constructor = EqNotEqContext;

DataflowParser.EqNotEqContext = EqNotEqContext;

EqNotEqContext.prototype.expression = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(ExpressionContext);
    } else {
        return this.getTypedRuleContext(ExpressionContext,i);
    }
};

EqNotEqContext.prototype.EQ = function() {
    return this.getToken(DataflowParser.EQ, 0);
};

EqNotEqContext.prototype.EQ_NULL = function() {
    return this.getToken(DataflowParser.EQ_NULL, 0);
};

EqNotEqContext.prototype.NOT_EQ = function() {
    return this.getToken(DataflowParser.NOT_EQ, 0);
};

EqNotEqContext.prototype.EQ_NOCASE = function() {
    return this.getToken(DataflowParser.EQ_NOCASE, 0);
};
EqNotEqContext.prototype.enterRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.enterEqNotEq(this);
	}
};

EqNotEqContext.prototype.exitRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.exitEqNotEq(this);
	}
};

EqNotEqContext.prototype.accept = function(visitor) {
    if ( visitor instanceof DataflowParserVisitor ) {
        return visitor.visitEqNotEq(this);
    } else {
        return visitor.visitChildren(this);
    }
};


function MetaPosRefContext(parser, ctx) {
	ExpressionContext.call(this, parser);
    ExpressionContext.prototype.copyFrom.call(this, ctx);
    return this;
}

MetaPosRefContext.prototype = Object.create(ExpressionContext.prototype);
MetaPosRefContext.prototype.constructor = MetaPosRefContext;

DataflowParser.MetaPosRefContext = MetaPosRefContext;

MetaPosRefContext.prototype.metaPosReference = function() {
    return this.getTypedRuleContext(MetaPosReferenceContext,0);
};
MetaPosRefContext.prototype.enterRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.enterMetaPosRef(this);
	}
};

MetaPosRefContext.prototype.exitRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.exitMetaPosRef(this);
	}
};

MetaPosRefContext.prototype.accept = function(visitor) {
    if ( visitor instanceof DataflowParserVisitor ) {
        return visitor.visitMetaPosRef(this);
    } else {
        return visitor.visitChildren(this);
    }
};


function TransformFunctionExprContext(parser, ctx) {
	ExpressionContext.call(this, parser);
    ExpressionContext.prototype.copyFrom.call(this, ctx);
    return this;
}

TransformFunctionExprContext.prototype = Object.create(ExpressionContext.prototype);
TransformFunctionExprContext.prototype.constructor = TransformFunctionExprContext;

DataflowParser.TransformFunctionExprContext = TransformFunctionExprContext;

TransformFunctionExprContext.prototype.transformFunction = function() {
    return this.getTypedRuleContext(TransformFunctionContext,0);
};
TransformFunctionExprContext.prototype.enterRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.enterTransformFunctionExpr(this);
	}
};

TransformFunctionExprContext.prototype.exitRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.exitTransformFunctionExpr(this);
	}
};

TransformFunctionExprContext.prototype.accept = function(visitor) {
    if ( visitor instanceof DataflowParserVisitor ) {
        return visitor.visitTransformFunctionExpr(this);
    } else {
        return visitor.visitChildren(this);
    }
};


function ComparisonContext(parser, ctx) {
	ExpressionContext.call(this, parser);
    this.left = null; // ExpressionContext;
    this.op = null; // Token;
    this.right = null; // ExpressionContext;
    ExpressionContext.prototype.copyFrom.call(this, ctx);
    return this;
}

ComparisonContext.prototype = Object.create(ExpressionContext.prototype);
ComparisonContext.prototype.constructor = ComparisonContext;

DataflowParser.ComparisonContext = ComparisonContext;

ComparisonContext.prototype.expression = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(ExpressionContext);
    } else {
        return this.getTypedRuleContext(ExpressionContext,i);
    }
};

ComparisonContext.prototype.GT = function() {
    return this.getToken(DataflowParser.GT, 0);
};

ComparisonContext.prototype.LT = function() {
    return this.getToken(DataflowParser.LT, 0);
};

ComparisonContext.prototype.GT_EQ = function() {
    return this.getToken(DataflowParser.GT_EQ, 0);
};

ComparisonContext.prototype.LT_EQ = function() {
    return this.getToken(DataflowParser.LT_EQ, 0);
};
ComparisonContext.prototype.enterRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.enterComparison(this);
	}
};

ComparisonContext.prototype.exitRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.exitComparison(this);
	}
};

ComparisonContext.prototype.accept = function(visitor) {
    if ( visitor instanceof DataflowParserVisitor ) {
        return visitor.visitComparison(this);
    } else {
        return visitor.visitChildren(this);
    }
};


function ArrayIndexerContext(parser, ctx) {
	ExpressionContext.call(this, parser);
    this.left = null; // ExpressionContext;
    this.right = null; // ExpressionContext;
    ExpressionContext.prototype.copyFrom.call(this, ctx);
    return this;
}

ArrayIndexerContext.prototype = Object.create(ExpressionContext.prototype);
ArrayIndexerContext.prototype.constructor = ArrayIndexerContext;

DataflowParser.ArrayIndexerContext = ArrayIndexerContext;

ArrayIndexerContext.prototype.OPEN_SQ = function() {
    return this.getToken(DataflowParser.OPEN_SQ, 0);
};

ArrayIndexerContext.prototype.CLOSE_SQ = function() {
    return this.getToken(DataflowParser.CLOSE_SQ, 0);
};

ArrayIndexerContext.prototype.expression = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(ExpressionContext);
    } else {
        return this.getTypedRuleContext(ExpressionContext,i);
    }
};
ArrayIndexerContext.prototype.enterRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.enterArrayIndexer(this);
	}
};

ArrayIndexerContext.prototype.exitRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.exitArrayIndexer(this);
	}
};

ArrayIndexerContext.prototype.accept = function(visitor) {
    if ( visitor instanceof DataflowParserVisitor ) {
        return visitor.visitArrayIndexer(this);
    } else {
        return visitor.visitChildren(this);
    }
};


function TransientRefContext(parser, ctx) {
	ExpressionContext.call(this, parser);
    ExpressionContext.prototype.copyFrom.call(this, ctx);
    return this;
}

TransientRefContext.prototype = Object.create(ExpressionContext.prototype);
TransientRefContext.prototype.constructor = TransientRefContext;

DataflowParser.TransientRefContext = TransientRefContext;

TransientRefContext.prototype.transientOperand = function() {
    return this.getTypedRuleContext(TransientOperandContext,0);
};
TransientRefContext.prototype.enterRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.enterTransientRef(this);
	}
};

TransientRefContext.prototype.exitRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.exitTransientRef(this);
	}
};

TransientRefContext.prototype.accept = function(visitor) {
    if ( visitor instanceof DataflowParserVisitor ) {
        return visitor.visitTransientRef(this);
    } else {
        return visitor.visitChildren(this);
    }
};


function LiteralExprContext(parser, ctx) {
	ExpressionContext.call(this, parser);
    ExpressionContext.prototype.copyFrom.call(this, ctx);
    return this;
}

LiteralExprContext.prototype = Object.create(ExpressionContext.prototype);
LiteralExprContext.prototype.constructor = LiteralExprContext;

DataflowParser.LiteralExprContext = LiteralExprContext;

LiteralExprContext.prototype.literal = function() {
    return this.getTypedRuleContext(LiteralContext,0);
};
LiteralExprContext.prototype.enterRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.enterLiteralExpr(this);
	}
};

LiteralExprContext.prototype.exitRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.exitLiteralExpr(this);
	}
};

LiteralExprContext.prototype.accept = function(visitor) {
    if ( visitor instanceof DataflowParserVisitor ) {
        return visitor.visitLiteralExpr(this);
    } else {
        return visitor.visitChildren(this);
    }
};


function FieldSelectorContext(parser, ctx) {
	ExpressionContext.call(this, parser);
    this.left = null; // ExpressionContext;
    this.right = null; // NameContext;
    ExpressionContext.prototype.copyFrom.call(this, ctx);
    return this;
}

FieldSelectorContext.prototype = Object.create(ExpressionContext.prototype);
FieldSelectorContext.prototype.constructor = FieldSelectorContext;

DataflowParser.FieldSelectorContext = FieldSelectorContext;

FieldSelectorContext.prototype.DOT = function() {
    return this.getToken(DataflowParser.DOT, 0);
};

FieldSelectorContext.prototype.expression = function() {
    return this.getTypedRuleContext(ExpressionContext,0);
};

FieldSelectorContext.prototype.name = function() {
    return this.getTypedRuleContext(NameContext,0);
};
FieldSelectorContext.prototype.enterRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.enterFieldSelector(this);
	}
};

FieldSelectorContext.prototype.exitRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.exitFieldSelector(this);
	}
};

FieldSelectorContext.prototype.accept = function(visitor) {
    if ( visitor instanceof DataflowParserVisitor ) {
        return visitor.visitFieldSelector(this);
    } else {
        return visitor.visitChildren(this);
    }
};


function FunctionExprContext(parser, ctx) {
	ExpressionContext.call(this, parser);
    ExpressionContext.prototype.copyFrom.call(this, ctx);
    return this;
}

FunctionExprContext.prototype = Object.create(ExpressionContext.prototype);
FunctionExprContext.prototype.constructor = FunctionExprContext;

DataflowParser.FunctionExprContext = FunctionExprContext;

FunctionExprContext.prototype.basicFunction = function() {
    return this.getTypedRuleContext(BasicFunctionContext,0);
};
FunctionExprContext.prototype.enterRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.enterFunctionExpr(this);
	}
};

FunctionExprContext.prototype.exitRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.exitFunctionExpr(this);
	}
};

FunctionExprContext.prototype.accept = function(visitor) {
    if ( visitor instanceof DataflowParserVisitor ) {
        return visitor.visitFunctionExpr(this);
    } else {
        return visitor.visitChildren(this);
    }
};


function EmptyArrayContext(parser, ctx) {
	ExpressionContext.call(this, parser);
    ExpressionContext.prototype.copyFrom.call(this, ctx);
    return this;
}

EmptyArrayContext.prototype = Object.create(ExpressionContext.prototype);
EmptyArrayContext.prototype.constructor = EmptyArrayContext;

DataflowParser.EmptyArrayContext = EmptyArrayContext;

EmptyArrayContext.prototype.OPEN_CLOSE_SQ = function() {
    return this.getToken(DataflowParser.OPEN_CLOSE_SQ, 0);
};
EmptyArrayContext.prototype.enterRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.enterEmptyArray(this);
	}
};

EmptyArrayContext.prototype.exitRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.exitEmptyArray(this);
	}
};

EmptyArrayContext.prototype.accept = function(visitor) {
    if ( visitor instanceof DataflowParserVisitor ) {
        return visitor.visitEmptyArray(this);
    } else {
        return visitor.visitChildren(this);
    }
};


function UnaryMinusContext(parser, ctx) {
	ExpressionContext.call(this, parser);
    this.op = null; // Token;
    this.right = null; // ExpressionContext;
    ExpressionContext.prototype.copyFrom.call(this, ctx);
    return this;
}

UnaryMinusContext.prototype = Object.create(ExpressionContext.prototype);
UnaryMinusContext.prototype.constructor = UnaryMinusContext;

DataflowParser.UnaryMinusContext = UnaryMinusContext;

UnaryMinusContext.prototype.MINUS = function() {
    return this.getToken(DataflowParser.MINUS, 0);
};

UnaryMinusContext.prototype.expression = function() {
    return this.getTypedRuleContext(ExpressionContext,0);
};
UnaryMinusContext.prototype.enterRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.enterUnaryMinus(this);
	}
};

UnaryMinusContext.prototype.exitRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.exitUnaryMinus(this);
	}
};

UnaryMinusContext.prototype.accept = function(visitor) {
    if ( visitor instanceof DataflowParserVisitor ) {
        return visitor.visitUnaryMinus(this);
    } else {
        return visitor.visitChildren(this);
    }
};


function CommentedExpressionContext(parser, ctx) {
	ExpressionContext.call(this, parser);
    ExpressionContext.prototype.copyFrom.call(this, ctx);
    return this;
}

CommentedExpressionContext.prototype = Object.create(ExpressionContext.prototype);
CommentedExpressionContext.prototype.constructor = CommentedExpressionContext;

DataflowParser.CommentedExpressionContext = CommentedExpressionContext;

CommentedExpressionContext.prototype.COMMENT = function() {
    return this.getToken(DataflowParser.COMMENT, 0);
};

CommentedExpressionContext.prototype.expression = function() {
    return this.getTypedRuleContext(ExpressionContext,0);
};
CommentedExpressionContext.prototype.enterRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.enterCommentedExpression(this);
	}
};

CommentedExpressionContext.prototype.exitRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.exitCommentedExpression(this);
	}
};

CommentedExpressionContext.prototype.accept = function(visitor) {
    if ( visitor instanceof DataflowParserVisitor ) {
        return visitor.visitCommentedExpression(this);
    } else {
        return visitor.visitChildren(this);
    }
};


function ArrayContext(parser, ctx) {
	ExpressionContext.call(this, parser);
    ExpressionContext.prototype.copyFrom.call(this, ctx);
    return this;
}

ArrayContext.prototype = Object.create(ExpressionContext.prototype);
ArrayContext.prototype.constructor = ArrayContext;

DataflowParser.ArrayContext = ArrayContext;

ArrayContext.prototype.OPEN_SQ = function() {
    return this.getToken(DataflowParser.OPEN_SQ, 0);
};

ArrayContext.prototype.CLOSE_SQ = function() {
    return this.getToken(DataflowParser.CLOSE_SQ, 0);
};

ArrayContext.prototype.expression = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(ExpressionContext);
    } else {
        return this.getTypedRuleContext(ExpressionContext,i);
    }
};

ArrayContext.prototype.COMMA = function(i) {
	if(i===undefined) {
		i = null;
	}
    if(i===null) {
        return this.getTokens(DataflowParser.COMMA);
    } else {
        return this.getToken(DataflowParser.COMMA, i);
    }
};

ArrayContext.prototype.enterRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.enterArray(this);
	}
};

ArrayContext.prototype.exitRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.exitArray(this);
	}
};

ArrayContext.prototype.accept = function(visitor) {
    if ( visitor instanceof DataflowParserVisitor ) {
        return visitor.visitArray(this);
    } else {
        return visitor.visitChildren(this);
    }
};


function MetaFunctionExprContext(parser, ctx) {
	ExpressionContext.call(this, parser);
    ExpressionContext.prototype.copyFrom.call(this, ctx);
    return this;
}

MetaFunctionExprContext.prototype = Object.create(ExpressionContext.prototype);
MetaFunctionExprContext.prototype.constructor = MetaFunctionExprContext;

DataflowParser.MetaFunctionExprContext = MetaFunctionExprContext;

MetaFunctionExprContext.prototype.ANNOTATION_META_HEAD = function() {
    return this.getToken(DataflowParser.ANNOTATION_META_HEAD, 0);
};

MetaFunctionExprContext.prototype.metafunction = function() {
    return this.getTypedRuleContext(MetafunctionContext,0);
};
MetaFunctionExprContext.prototype.enterRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.enterMetaFunctionExpr(this);
	}
};

MetaFunctionExprContext.prototype.exitRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.exitMetaFunctionExpr(this);
	}
};

MetaFunctionExprContext.prototype.accept = function(visitor) {
    if ( visitor instanceof DataflowParserVisitor ) {
        return visitor.visitMetaFunctionExpr(this);
    } else {
        return visitor.visitChildren(this);
    }
};


function InterpolationContext(parser, ctx) {
	ExpressionContext.call(this, parser);
    ExpressionContext.prototype.copyFrom.call(this, ctx);
    return this;
}

InterpolationContext.prototype = Object.create(ExpressionContext.prototype);
InterpolationContext.prototype.constructor = InterpolationContext;

DataflowParser.InterpolationContext = InterpolationContext;

InterpolationContext.prototype.OPEN_INTERPOLATE = function(i) {
	if(i===undefined) {
		i = null;
	}
    if(i===null) {
        return this.getTokens(DataflowParser.OPEN_INTERPOLATE);
    } else {
        return this.getToken(DataflowParser.OPEN_INTERPOLATE, i);
    }
};


InterpolationContext.prototype.interpolateParts = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(InterpolatePartsContext);
    } else {
        return this.getTypedRuleContext(InterpolatePartsContext,i);
    }
};
InterpolationContext.prototype.enterRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.enterInterpolation(this);
	}
};

InterpolationContext.prototype.exitRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.exitInterpolation(this);
	}
};

InterpolationContext.prototype.accept = function(visitor) {
    if ( visitor instanceof DataflowParserVisitor ) {
        return visitor.visitInterpolation(this);
    } else {
        return visitor.visitChildren(this);
    }
};


function NotContext(parser, ctx) {
	ExpressionContext.call(this, parser);
    this.op = null; // Token;
    this.right = null; // ExpressionContext;
    ExpressionContext.prototype.copyFrom.call(this, ctx);
    return this;
}

NotContext.prototype = Object.create(ExpressionContext.prototype);
NotContext.prototype.constructor = NotContext;

DataflowParser.NotContext = NotContext;

NotContext.prototype.NOT = function() {
    return this.getToken(DataflowParser.NOT, 0);
};

NotContext.prototype.expression = function() {
    return this.getTypedRuleContext(ExpressionContext,0);
};
NotContext.prototype.enterRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.enterNot(this);
	}
};

NotContext.prototype.exitRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.exitNot(this);
	}
};

NotContext.prototype.accept = function(visitor) {
    if ( visitor instanceof DataflowParserVisitor ) {
        return visitor.visitNot(this);
    } else {
        return visitor.visitChildren(this);
    }
};


function ParameterRefContext(parser, ctx) {
	ExpressionContext.call(this, parser);
    ExpressionContext.prototype.copyFrom.call(this, ctx);
    return this;
}

ParameterRefContext.prototype = Object.create(ExpressionContext.prototype);
ParameterRefContext.prototype.constructor = ParameterRefContext;

DataflowParser.ParameterRefContext = ParameterRefContext;

ParameterRefContext.prototype.parameterOperand = function() {
    return this.getTypedRuleContext(ParameterOperandContext,0);
};
ParameterRefContext.prototype.enterRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.enterParameterRef(this);
	}
};

ParameterRefContext.prototype.exitRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.exitParameterRef(this);
	}
};

ParameterRefContext.prototype.accept = function(visitor) {
    if ( visitor instanceof DataflowParserVisitor ) {
        return visitor.visitParameterRef(this);
    } else {
        return visitor.visitChildren(this);
    }
};


function ScopeContext(parser, ctx) {
	ExpressionContext.call(this, parser);
    ExpressionContext.prototype.copyFrom.call(this, ctx);
    return this;
}

ScopeContext.prototype = Object.create(ExpressionContext.prototype);
ScopeContext.prototype.constructor = ScopeContext;

DataflowParser.ScopeContext = ScopeContext;

ScopeContext.prototype.OPEN_PAREN = function() {
    return this.getToken(DataflowParser.OPEN_PAREN, 0);
};

ScopeContext.prototype.expression = function() {
    return this.getTypedRuleContext(ExpressionContext,0);
};

ScopeContext.prototype.CLOSE_PAREN = function() {
    return this.getToken(DataflowParser.CLOSE_PAREN, 0);
};
ScopeContext.prototype.enterRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.enterScope(this);
	}
};

ScopeContext.prototype.exitRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.exitScope(this);
	}
};

ScopeContext.prototype.accept = function(visitor) {
    if ( visitor instanceof DataflowParserVisitor ) {
        return visitor.visitScope(this);
    } else {
        return visitor.visitChildren(this);
    }
};


function AndContext(parser, ctx) {
	ExpressionContext.call(this, parser);
    this.left = null; // ExpressionContext;
    this.right = null; // ExpressionContext;
    ExpressionContext.prototype.copyFrom.call(this, ctx);
    return this;
}

AndContext.prototype = Object.create(ExpressionContext.prototype);
AndContext.prototype.constructor = AndContext;

DataflowParser.AndContext = AndContext;

AndContext.prototype.AND = function() {
    return this.getToken(DataflowParser.AND, 0);
};

AndContext.prototype.expression = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(ExpressionContext);
    } else {
        return this.getTypedRuleContext(ExpressionContext,i);
    }
};
AndContext.prototype.enterRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.enterAnd(this);
	}
};

AndContext.prototype.exitRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.exitAnd(this);
	}
};

AndContext.prototype.accept = function(visitor) {
    if ( visitor instanceof DataflowParserVisitor ) {
        return visitor.visitAnd(this);
    } else {
        return visitor.visitChildren(this);
    }
};


function MetaMatchRefContext(parser, ctx) {
	ExpressionContext.call(this, parser);
    ExpressionContext.prototype.copyFrom.call(this, ctx);
    return this;
}

MetaMatchRefContext.prototype = Object.create(ExpressionContext.prototype);
MetaMatchRefContext.prototype.constructor = MetaMatchRefContext;

DataflowParser.MetaMatchRefContext = MetaMatchRefContext;

MetaMatchRefContext.prototype.metaMatchReference = function() {
    return this.getTypedRuleContext(MetaMatchReferenceContext,0);
};
MetaMatchRefContext.prototype.enterRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.enterMetaMatchRef(this);
	}
};

MetaMatchRefContext.prototype.exitRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.exitMetaMatchRef(this);
	}
};

MetaMatchRefContext.prototype.accept = function(visitor) {
    if ( visitor instanceof DataflowParserVisitor ) {
        return visitor.visitMetaMatchRef(this);
    } else {
        return visitor.visitChildren(this);
    }
};


function XorContext(parser, ctx) {
	ExpressionContext.call(this, parser);
    this.left = null; // ExpressionContext;
    this.right = null; // ExpressionContext;
    ExpressionContext.prototype.copyFrom.call(this, ctx);
    return this;
}

XorContext.prototype = Object.create(ExpressionContext.prototype);
XorContext.prototype.constructor = XorContext;

DataflowParser.XorContext = XorContext;

XorContext.prototype.XOR = function() {
    return this.getToken(DataflowParser.XOR, 0);
};

XorContext.prototype.expression = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(ExpressionContext);
    } else {
        return this.getTypedRuleContext(ExpressionContext,i);
    }
};
XorContext.prototype.enterRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.enterXor(this);
	}
};

XorContext.prototype.exitRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.exitXor(this);
	}
};

XorContext.prototype.accept = function(visitor) {
    if ( visitor instanceof DataflowParserVisitor ) {
        return visitor.visitXor(this);
    } else {
        return visitor.visitChildren(this);
    }
};


function MetaArgumentRefContext(parser, ctx) {
	ExpressionContext.call(this, parser);
    ExpressionContext.prototype.copyFrom.call(this, ctx);
    return this;
}

MetaArgumentRefContext.prototype = Object.create(ExpressionContext.prototype);
MetaArgumentRefContext.prototype.constructor = MetaArgumentRefContext;

DataflowParser.MetaArgumentRefContext = MetaArgumentRefContext;

MetaArgumentRefContext.prototype.metaArgumentReference = function() {
    return this.getTypedRuleContext(MetaArgumentReferenceContext,0);
};
MetaArgumentRefContext.prototype.enterRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.enterMetaArgumentRef(this);
	}
};

MetaArgumentRefContext.prototype.exitRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.exitMetaArgumentRef(this);
	}
};

MetaArgumentRefContext.prototype.accept = function(visitor) {
    if ( visitor instanceof DataflowParserVisitor ) {
        return visitor.visitMetaArgumentRef(this);
    } else {
        return visitor.visitChildren(this);
    }
};


function MapContext(parser, ctx) {
	ExpressionContext.call(this, parser);
    ExpressionContext.prototype.copyFrom.call(this, ctx);
    return this;
}

MapContext.prototype = Object.create(ExpressionContext.prototype);
MapContext.prototype.constructor = MapContext;

DataflowParser.MapContext = MapContext;

MapContext.prototype.OPEN_SQ = function() {
    return this.getToken(DataflowParser.OPEN_SQ, 0);
};

MapContext.prototype.CLOSE_SQ = function() {
    return this.getToken(DataflowParser.CLOSE_SQ, 0);
};

MapContext.prototype.expression = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(ExpressionContext);
    } else {
        return this.getTypedRuleContext(ExpressionContext,i);
    }
};

MapContext.prototype.MAP = function(i) {
	if(i===undefined) {
		i = null;
	}
    if(i===null) {
        return this.getTokens(DataflowParser.MAP);
    } else {
        return this.getToken(DataflowParser.MAP, i);
    }
};


MapContext.prototype.COMMA = function(i) {
	if(i===undefined) {
		i = null;
	}
    if(i===null) {
        return this.getTokens(DataflowParser.COMMA);
    } else {
        return this.getToken(DataflowParser.COMMA, i);
    }
};

MapContext.prototype.enterRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.enterMap(this);
	}
};

MapContext.prototype.exitRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.exitMap(this);
	}
};

MapContext.prototype.accept = function(visitor) {
    if ( visitor instanceof DataflowParserVisitor ) {
        return visitor.visitMap(this);
    } else {
        return visitor.visitChildren(this);
    }
};



DataflowParser.prototype.expression = function(_p) {
	if(_p===undefined) {
	    _p = 0;
	}
    var _parentctx = this._ctx;
    var _parentState = this.state;
    var localctx = new ExpressionContext(this, this._ctx, _parentState);
    var _prevctx = localctx;
    var _startState = 56;
    this.enterRecursionRule(localctx, 56, DataflowParser.RULE_expression, _p);
    var _la = 0; // Token type
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 349;
        this._errHandler.sync(this);
        var la_ = this._interp.adaptivePredict(this._input,25,this._ctx);
        switch(la_) {
        case 1:
            localctx = new ScopeContext(this, localctx);
            this._ctx = localctx;
            _prevctx = localctx;

            this.state = 272;
            this.match(DataflowParser.OPEN_PAREN);
            this.state = 273;
            this.expression(0);
            this.state = 274;
            this.match(DataflowParser.CLOSE_PAREN);
            break;

        case 2:
            localctx = new UnaryMinusContext(this, localctx);
            this._ctx = localctx;
            _prevctx = localctx;
            this.state = 276;
            localctx.op = this.match(DataflowParser.MINUS);
            this.state = 277;
            localctx.right = this.expression(29);
            break;

        case 3:
            localctx = new NotContext(this, localctx);
            this._ctx = localctx;
            _prevctx = localctx;
            this.state = 278;
            localctx.op = this.match(DataflowParser.NOT);
            this.state = 279;
            localctx.right = this.expression(28);
            break;

        case 4:
            localctx = new StructContext(this, localctx);
            this._ctx = localctx;
            _prevctx = localctx;
            this.state = 280;
            this.match(DataflowParser.OPEN_STRUCT);

            this.state = 283;
            this._errHandler.sync(this);
            var la_ = this._interp.adaptivePredict(this._input,19,this._ctx);
            switch(la_) {
            case 1:
                this.state = 281;
                this.expression(0);
                break;

            case 2:
                this.state = 282;
                this.assignment();
                break;

            }
            this.state = 292;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            while(_la===DataflowParser.COMMA) {
                this.state = 285;
                this.match(DataflowParser.COMMA);
                this.state = 288;
                this._errHandler.sync(this);
                var la_ = this._interp.adaptivePredict(this._input,20,this._ctx);
                switch(la_) {
                case 1:
                    this.state = 286;
                    this.expression(0);
                    break;

                case 2:
                    this.state = 287;
                    this.assignment();
                    break;

                }
                this.state = 294;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
            }
            this.state = 295;
            this.match(DataflowParser.CLOSE_PAREN);
            break;

        case 5:
            localctx = new ColumnOperandRefContext(this, localctx);
            this._ctx = localctx;
            _prevctx = localctx;
            this.state = 297;
            this.columnOperand();
            break;

        case 6:
            localctx = new ParameterRefContext(this, localctx);
            this._ctx = localctx;
            _prevctx = localctx;
            this.state = 298;
            this.parameterOperand();
            break;

        case 7:
            localctx = new VariableRefContext(this, localctx);
            this._ctx = localctx;
            _prevctx = localctx;
            this.state = 299;
            this.variableReference();
            break;

        case 8:
            localctx = new TransientRefContext(this, localctx);
            this._ctx = localctx;
            _prevctx = localctx;
            this.state = 300;
            this.transientOperand();
            break;

        case 9:
            localctx = new FunctionExprContext(this, localctx);
            this._ctx = localctx;
            _prevctx = localctx;
            this.state = 301;
            this.basicFunction();
            break;

        case 10:
            localctx = new MetaFunctionExprContext(this, localctx);
            this._ctx = localctx;
            _prevctx = localctx;
            this.state = 302;
            this.match(DataflowParser.ANNOTATION_META_HEAD);
            this.state = 303;
            this.metafunction();
            break;

        case 11:
            localctx = new MetaVariableRefContext(this, localctx);
            this._ctx = localctx;
            _prevctx = localctx;
            this.state = 304;
            this.metaVariableReference();
            break;

        case 12:
            localctx = new MetaPosRefContext(this, localctx);
            this._ctx = localctx;
            _prevctx = localctx;
            this.state = 305;
            this.metaPosReference();
            break;

        case 13:
            localctx = new MetaMatchRefContext(this, localctx);
            this._ctx = localctx;
            _prevctx = localctx;
            this.state = 306;
            this.metaMatchReference();
            break;

        case 14:
            localctx = new MetaArgumentRefContext(this, localctx);
            this._ctx = localctx;
            _prevctx = localctx;
            this.state = 307;
            this.metaArgumentReference();
            break;

        case 15:
            localctx = new TransformFunctionExprContext(this, localctx);
            this._ctx = localctx;
            _prevctx = localctx;
            this.state = 308;
            this.transformFunction();
            break;

        case 16:
            localctx = new LiteralExprContext(this, localctx);
            this._ctx = localctx;
            _prevctx = localctx;
            this.state = 309;
            this.literal();
            break;

        case 17:
            localctx = new ArrayContext(this, localctx);
            this._ctx = localctx;
            _prevctx = localctx;
            this.state = 310;
            this.match(DataflowParser.OPEN_SQ);

            this.state = 311;
            this.expression(0);
            this.state = 316;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            while(_la===DataflowParser.COMMA) {
                this.state = 312;
                this.match(DataflowParser.COMMA);
                this.state = 313;
                this.expression(0);
                this.state = 318;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
            }
            this.state = 319;
            this.match(DataflowParser.CLOSE_SQ);
            break;

        case 18:
            localctx = new MapContext(this, localctx);
            this._ctx = localctx;
            _prevctx = localctx;
            this.state = 321;
            this.match(DataflowParser.OPEN_SQ);

            this.state = 322;
            this.expression(0);
            this.state = 323;
            this.match(DataflowParser.MAP);
            this.state = 324;
            this.expression(0);
            this.state = 333;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            while(_la===DataflowParser.COMMA) {
                this.state = 326;
                this.match(DataflowParser.COMMA);
                this.state = 327;
                this.expression(0);
                this.state = 328;
                this.match(DataflowParser.MAP);
                this.state = 329;
                this.expression(0);
                this.state = 335;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
            }
            this.state = 336;
            this.match(DataflowParser.CLOSE_SQ);
            break;

        case 19:
            localctx = new EmptyArrayContext(this, localctx);
            this._ctx = localctx;
            _prevctx = localctx;
            this.state = 338;
            this.match(DataflowParser.OPEN_CLOSE_SQ);
            break;

        case 20:
            localctx = new InterpolationContext(this, localctx);
            this._ctx = localctx;
            _prevctx = localctx;
            this.state = 339;
            this.match(DataflowParser.OPEN_INTERPOLATE);
            this.state = 343;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            while(_la===DataflowParser.INTERPOLATE_TEXT || _la===DataflowParser.INTERPOLATE_OPEN_CURLY) {
                this.state = 340;
                this.interpolateParts();
                this.state = 345;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
            }
            this.state = 346;
            this.match(DataflowParser.OPEN_INTERPOLATE);
            break;

        case 21:
            localctx = new CommentedExpressionContext(this, localctx);
            this._ctx = localctx;
            _prevctx = localctx;
            this.state = 347;
            this.match(DataflowParser.COMMENT);
            this.state = 348;
            this.expression(2);
            break;

        }
        this._ctx.stop = this._input.LT(-1);
        this.state = 387;
        this._errHandler.sync(this);
        var _alt = this._interp.adaptivePredict(this._input,27,this._ctx)
        while(_alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER) {
            if(_alt===1) {
                if(this._parseListeners!==null) {
                    this.triggerExitRuleEvent();
                }
                _prevctx = localctx;
                this.state = 385;
                this._errHandler.sync(this);
                var la_ = this._interp.adaptivePredict(this._input,26,this._ctx);
                switch(la_) {
                case 1:
                    localctx = new MulDivModContext(this, new ExpressionContext(this, _parentctx, _parentState));
                    localctx.left = _prevctx;
                    this.pushNewRecursionContext(localctx, _startState, DataflowParser.RULE_expression);
                    this.state = 351;
                    if (!( this.precpred(this._ctx, 26))) {
                        throw new antlr4.error.FailedPredicateException(this, "this.precpred(this._ctx, 26)");
                    }
                    this.state = 352;
                    localctx.op = this._input.LT(1);
                    _la = this._input.LA(1);
                    if(!(_la===DataflowParser.MUL || _la===DataflowParser.MOD || _la===DataflowParser.SLASH)) {
                        localctx.op = this._errHandler.recoverInline(this);
                    }
                    else {
                    	this._errHandler.reportMatch(this);
                        this.consume();
                    }
                    this.state = 353;
                    localctx.right = this.expression(27);
                    break;

                case 2:
                    localctx = new AddMinusContext(this, new ExpressionContext(this, _parentctx, _parentState));
                    localctx.left = _prevctx;
                    this.pushNewRecursionContext(localctx, _startState, DataflowParser.RULE_expression);
                    this.state = 354;
                    if (!( this.precpred(this._ctx, 25))) {
                        throw new antlr4.error.FailedPredicateException(this, "this.precpred(this._ctx, 25)");
                    }
                    this.state = 355;
                    localctx.op = this._input.LT(1);
                    _la = this._input.LA(1);
                    if(!(_la===DataflowParser.PLUS || _la===DataflowParser.MINUS)) {
                        localctx.op = this._errHandler.recoverInline(this);
                    }
                    else {
                    	this._errHandler.reportMatch(this);
                        this.consume();
                    }
                    this.state = 356;
                    localctx.right = this.expression(26);
                    break;

                case 3:
                    localctx = new EqNotEqContext(this, new ExpressionContext(this, _parentctx, _parentState));
                    localctx.left = _prevctx;
                    this.pushNewRecursionContext(localctx, _startState, DataflowParser.RULE_expression);
                    this.state = 357;
                    if (!( this.precpred(this._ctx, 24))) {
                        throw new antlr4.error.FailedPredicateException(this, "this.precpred(this._ctx, 24)");
                    }
                    this.state = 358;
                    localctx.op = this._input.LT(1);
                    _la = this._input.LA(1);
                    if(!((((_la) & ~0x1f) == 0 && ((1 << _la) & ((1 << DataflowParser.EQ) | (1 << DataflowParser.EQ_NULL) | (1 << DataflowParser.EQ_NOCASE) | (1 << DataflowParser.NOT_EQ))) !== 0))) {
                        localctx.op = this._errHandler.recoverInline(this);
                    }
                    else {
                    	this._errHandler.reportMatch(this);
                        this.consume();
                    }
                    this.state = 359;
                    localctx.right = this.expression(25);
                    break;

                case 4:
                    localctx = new ComparisonContext(this, new ExpressionContext(this, _parentctx, _parentState));
                    localctx.left = _prevctx;
                    this.pushNewRecursionContext(localctx, _startState, DataflowParser.RULE_expression);
                    this.state = 360;
                    if (!( this.precpred(this._ctx, 23))) {
                        throw new antlr4.error.FailedPredicateException(this, "this.precpred(this._ctx, 23)");
                    }
                    this.state = 361;
                    localctx.op = this._input.LT(1);
                    _la = this._input.LA(1);
                    if(!((((_la) & ~0x1f) == 0 && ((1 << _la) & ((1 << DataflowParser.GT) | (1 << DataflowParser.LT) | (1 << DataflowParser.GT_EQ) | (1 << DataflowParser.LT_EQ))) !== 0))) {
                        localctx.op = this._errHandler.recoverInline(this);
                    }
                    else {
                    	this._errHandler.reportMatch(this);
                        this.consume();
                    }
                    this.state = 362;
                    localctx.right = this.expression(24);
                    break;

                case 5:
                    localctx = new AndContext(this, new ExpressionContext(this, _parentctx, _parentState));
                    localctx.left = _prevctx;
                    this.pushNewRecursionContext(localctx, _startState, DataflowParser.RULE_expression);
                    this.state = 363;
                    if (!( this.precpred(this._ctx, 22))) {
                        throw new antlr4.error.FailedPredicateException(this, "this.precpred(this._ctx, 22)");
                    }
                    this.state = 364;
                    this.match(DataflowParser.AND);
                    this.state = 365;
                    localctx.right = this.expression(23);
                    break;

                case 6:
                    localctx = new XorContext(this, new ExpressionContext(this, _parentctx, _parentState));
                    localctx.left = _prevctx;
                    this.pushNewRecursionContext(localctx, _startState, DataflowParser.RULE_expression);
                    this.state = 366;
                    if (!( this.precpred(this._ctx, 21))) {
                        throw new antlr4.error.FailedPredicateException(this, "this.precpred(this._ctx, 21)");
                    }
                    this.state = 367;
                    this.match(DataflowParser.XOR);
                    this.state = 368;
                    localctx.right = this.expression(22);
                    break;

                case 7:
                    localctx = new OrContext(this, new ExpressionContext(this, _parentctx, _parentState));
                    localctx.left = _prevctx;
                    this.pushNewRecursionContext(localctx, _startState, DataflowParser.RULE_expression);
                    this.state = 369;
                    if (!( this.precpred(this._ctx, 20))) {
                        throw new antlr4.error.FailedPredicateException(this, "this.precpred(this._ctx, 20)");
                    }
                    this.state = 370;
                    this.match(DataflowParser.OR);
                    this.state = 371;
                    localctx.right = this.expression(21);
                    break;

                case 8:
                    localctx = new FieldSelectorContext(this, new ExpressionContext(this, _parentctx, _parentState));
                    localctx.left = _prevctx;
                    this.pushNewRecursionContext(localctx, _startState, DataflowParser.RULE_expression);
                    this.state = 372;
                    if (!( this.precpred(this._ctx, 31))) {
                        throw new antlr4.error.FailedPredicateException(this, "this.precpred(this._ctx, 31)");
                    }
                    this.state = 373;
                    this.match(DataflowParser.DOT);
                    this.state = 374;
                    localctx.right = this.name();
                    break;

                case 9:
                    localctx = new ArrayIndexerContext(this, new ExpressionContext(this, _parentctx, _parentState));
                    localctx.left = _prevctx;
                    this.pushNewRecursionContext(localctx, _startState, DataflowParser.RULE_expression);
                    this.state = 375;
                    if (!( this.precpred(this._ctx, 30))) {
                        throw new antlr4.error.FailedPredicateException(this, "this.precpred(this._ctx, 30)");
                    }
                    this.state = 376;
                    this.match(DataflowParser.OPEN_SQ);
                    this.state = 377;
                    localctx.right = this.expression(0);
                    this.state = 378;
                    this.match(DataflowParser.CLOSE_SQ);
                    break;

                case 10:
                    localctx = new CastContext(this, new ExpressionContext(this, _parentctx, _parentState));
                    localctx.left = _prevctx;
                    this.pushNewRecursionContext(localctx, _startState, DataflowParser.RULE_expression);
                    this.state = 380;
                    if (!( this.precpred(this._ctx, 27))) {
                        throw new antlr4.error.FailedPredicateException(this, "this.precpred(this._ctx, 27)");
                    }
                    this.state = 381;
                    this.match(DataflowParser.QUESTION);
                    this.state = 382;
                    localctx.right = this.inlineDatatype();
                    break;

                case 11:
                    localctx = new CommentedExpressionContext(this, new ExpressionContext(this, _parentctx, _parentState));
                    this.pushNewRecursionContext(localctx, _startState, DataflowParser.RULE_expression);
                    this.state = 383;
                    if (!( this.precpred(this._ctx, 1))) {
                        throw new antlr4.error.FailedPredicateException(this, "this.precpred(this._ctx, 1)");
                    }
                    this.state = 384;
                    this.match(DataflowParser.COMMENT);
                    break;

                } 
            }
            this.state = 389;
            this._errHandler.sync(this);
            _alt = this._interp.adaptivePredict(this._input,27,this._ctx);
        }

    } catch( error) {
        if(error instanceof antlr4.error.RecognitionException) {
	        localctx.exception = error;
	        this._errHandler.reportError(this, error);
	        this._errHandler.recover(this, error);
	    } else {
	    	throw error;
	    }
    } finally {
        this.unrollRecursionContexts(_parentctx)
    }
    return localctx;
};


function AssignmentContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = DataflowParser.RULE_assignment;
    return this;
}

AssignmentContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
AssignmentContext.prototype.constructor = AssignmentContext;

AssignmentContext.prototype.ASSIGN = function() {
    return this.getToken(DataflowParser.ASSIGN, 0);
};

AssignmentContext.prototype.expression = function() {
    return this.getTypedRuleContext(ExpressionContext,0);
};

AssignmentContext.prototype.columnIdentifier = function() {
    return this.getTypedRuleContext(ColumnIdentifierContext,0);
};

AssignmentContext.prototype.parameterOperand = function() {
    return this.getTypedRuleContext(ParameterOperandContext,0);
};

AssignmentContext.prototype.enterRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.enterAssignment(this);
	}
};

AssignmentContext.prototype.exitRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.exitAssignment(this);
	}
};

AssignmentContext.prototype.accept = function(visitor) {
    if ( visitor instanceof DataflowParserVisitor ) {
        return visitor.visitAssignment(this);
    } else {
        return visitor.visitChildren(this);
    }
};




DataflowParser.AssignmentContext = AssignmentContext;

DataflowParser.prototype.assignment = function() {

    var localctx = new AssignmentContext(this, this._ctx, this.state);
    this.enterRule(localctx, 58, DataflowParser.RULE_assignment);
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 392;
        this._errHandler.sync(this);
        switch(this._input.LA(1)) {
        case DataflowParser.PARAMETERS:
        case DataflowParser.FUNCTIONS:
        case DataflowParser.AS:
        case DataflowParser.INPUT:
        case DataflowParser.OUTPUT:
        case DataflowParser.CONSTANT:
        case DataflowParser.EXPRESSION:
        case DataflowParser.INTEGER:
        case DataflowParser.SHORT:
        case DataflowParser.LONG:
        case DataflowParser.DOUBLE:
        case DataflowParser.FLOAT:
        case DataflowParser.DECIMAL:
        case DataflowParser.BOOLEAN:
        case DataflowParser.TIMESTAMP:
        case DataflowParser.DATE:
        case DataflowParser.BYTE:
        case DataflowParser.BINARY:
        case DataflowParser.INTEGRAL:
        case DataflowParser.NUMBER:
        case DataflowParser.FRACTIONAL:
        case DataflowParser.ANY_SIMPLE:
        case DataflowParser.IDENTIFIER:
        case DataflowParser.ANY_IDENTIFIER:
            this.state = 390;
            this.columnIdentifier();
            break;
        case DataflowParser.DOLLAR:
            this.state = 391;
            this.parameterOperand();
            break;
        default:
            throw new antlr4.error.NoViableAltException(this);
        }
        this.state = 394;
        this.match(DataflowParser.ASSIGN);
        this.state = 395;
        this.expression(0);
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};


function TransientAssignmentContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = DataflowParser.RULE_transientAssignment;
    return this;
}

TransientAssignmentContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
TransientAssignmentContext.prototype.constructor = TransientAssignmentContext;

TransientAssignmentContext.prototype.columnIdentifier = function() {
    return this.getTypedRuleContext(ColumnIdentifierContext,0);
};

TransientAssignmentContext.prototype.TRANSIENT_ASSIGN = function() {
    return this.getToken(DataflowParser.TRANSIENT_ASSIGN, 0);
};

TransientAssignmentContext.prototype.expression = function() {
    return this.getTypedRuleContext(ExpressionContext,0);
};

TransientAssignmentContext.prototype.enterRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.enterTransientAssignment(this);
	}
};

TransientAssignmentContext.prototype.exitRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.exitTransientAssignment(this);
	}
};

TransientAssignmentContext.prototype.accept = function(visitor) {
    if ( visitor instanceof DataflowParserVisitor ) {
        return visitor.visitTransientAssignment(this);
    } else {
        return visitor.visitChildren(this);
    }
};




DataflowParser.TransientAssignmentContext = TransientAssignmentContext;

DataflowParser.prototype.transientAssignment = function() {

    var localctx = new TransientAssignmentContext(this, this._ctx, this.state);
    this.enterRule(localctx, 60, DataflowParser.RULE_transientAssignment);
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 397;
        this.columnIdentifier();
        this.state = 398;
        this.match(DataflowParser.TRANSIENT_ASSIGN);
        this.state = 399;
        this.expression(0);
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};


function MetaAssignmentContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = DataflowParser.RULE_metaAssignment;
    this.left = null; // ExpressionContext
    this.right = null; // ExpressionContext
    return this;
}

MetaAssignmentContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
MetaAssignmentContext.prototype.constructor = MetaAssignmentContext;

MetaAssignmentContext.prototype.ASSIGN = function() {
    return this.getToken(DataflowParser.ASSIGN, 0);
};

MetaAssignmentContext.prototype.expression = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(ExpressionContext);
    } else {
        return this.getTypedRuleContext(ExpressionContext,i);
    }
};

MetaAssignmentContext.prototype.enterRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.enterMetaAssignment(this);
	}
};

MetaAssignmentContext.prototype.exitRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.exitMetaAssignment(this);
	}
};

MetaAssignmentContext.prototype.accept = function(visitor) {
    if ( visitor instanceof DataflowParserVisitor ) {
        return visitor.visitMetaAssignment(this);
    } else {
        return visitor.visitChildren(this);
    }
};




DataflowParser.MetaAssignmentContext = MetaAssignmentContext;

DataflowParser.prototype.metaAssignment = function() {

    var localctx = new MetaAssignmentContext(this, this._ctx, this.state);
    this.enterRule(localctx, 62, DataflowParser.RULE_metaAssignment);
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 401;
        localctx.left = this.expression(0);
        this.state = 402;
        this.match(DataflowParser.ASSIGN);
        this.state = 403;
        localctx.right = this.expression(0);
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};


function SectionsContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = DataflowParser.RULE_sections;
    return this;
}

SectionsContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
SectionsContext.prototype.constructor = SectionsContext;

SectionsContext.prototype.section = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(SectionContext);
    } else {
        return this.getTypedRuleContext(SectionContext,i);
    }
};

SectionsContext.prototype.enterRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.enterSections(this);
	}
};

SectionsContext.prototype.exitRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.exitSections(this);
	}
};

SectionsContext.prototype.accept = function(visitor) {
    if ( visitor instanceof DataflowParserVisitor ) {
        return visitor.visitSections(this);
    } else {
        return visitor.visitChildren(this);
    }
};




DataflowParser.SectionsContext = SectionsContext;

DataflowParser.prototype.sections = function() {

    var localctx = new SectionsContext(this, this._ctx, this.state);
    this.enterRule(localctx, 64, DataflowParser.RULE_sections);
    var _la = 0; // Token type
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 406; 
        this._errHandler.sync(this);
        _la = this._input.LA(1);
        do {
            this.state = 405;
            this.section();
            this.state = 408; 
            this._errHandler.sync(this);
            _la = this._input.LA(1);
        } while(_la===DataflowParser.OPEN_SECTION);
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};


function SectionContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = DataflowParser.RULE_section;
    return this;
}

SectionContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
SectionContext.prototype.constructor = SectionContext;

SectionContext.prototype.OPEN_SECTION = function() {
    return this.getToken(DataflowParser.OPEN_SECTION, 0);
};

SectionContext.prototype.sectionName = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(SectionNameContext);
    } else {
        return this.getTypedRuleContext(SectionNameContext,i);
    }
};

SectionContext.prototype.CLOSE_SECTION = function() {
    return this.getToken(DataflowParser.CLOSE_SECTION, 0);
};

SectionContext.prototype.SLASH = function() {
    return this.getToken(DataflowParser.SLASH, 0);
};

SectionContext.prototype.keyExpression = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(KeyExpressionContext);
    } else {
        return this.getTypedRuleContext(KeyExpressionContext,i);
    }
};

SectionContext.prototype.enterRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.enterSection(this);
	}
};

SectionContext.prototype.exitRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.exitSection(this);
	}
};

SectionContext.prototype.accept = function(visitor) {
    if ( visitor instanceof DataflowParserVisitor ) {
        return visitor.visitSection(this);
    } else {
        return visitor.visitChildren(this);
    }
};




DataflowParser.SectionContext = SectionContext;

DataflowParser.prototype.section = function() {

    var localctx = new SectionContext(this, this._ctx, this.state);
    this.enterRule(localctx, 66, DataflowParser.RULE_section);
    var _la = 0; // Token type
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 410;
        this.match(DataflowParser.OPEN_SECTION);
        this.state = 411;
        this.sectionName();
        this.state = 414;
        this._errHandler.sync(this);
        _la = this._input.LA(1);
        if(_la===DataflowParser.SLASH) {
            this.state = 412;
            this.match(DataflowParser.SLASH);
            this.state = 413;
            this.sectionName();
        }

        this.state = 416;
        this.match(DataflowParser.CLOSE_SECTION);
        this.state = 420;
        this._errHandler.sync(this);
        _la = this._input.LA(1);
        while(((((_la - 52)) & ~0x1f) == 0 && ((1 << (_la - 52)) & ((1 << (DataflowParser.PARAMETERS - 52)) | (1 << (DataflowParser.FUNCTIONS - 52)) | (1 << (DataflowParser.AS - 52)) | (1 << (DataflowParser.INPUT - 52)) | (1 << (DataflowParser.OUTPUT - 52)) | (1 << (DataflowParser.CONSTANT - 52)) | (1 << (DataflowParser.EXPRESSION - 52)) | (1 << (DataflowParser.INTEGER - 52)) | (1 << (DataflowParser.SHORT - 52)) | (1 << (DataflowParser.LONG - 52)) | (1 << (DataflowParser.DOUBLE - 52)) | (1 << (DataflowParser.FLOAT - 52)) | (1 << (DataflowParser.DECIMAL - 52)) | (1 << (DataflowParser.BOOLEAN - 52)) | (1 << (DataflowParser.TIMESTAMP - 52)) | (1 << (DataflowParser.DATE - 52)) | (1 << (DataflowParser.BYTE - 52)) | (1 << (DataflowParser.BINARY - 52)) | (1 << (DataflowParser.INTEGRAL - 52)) | (1 << (DataflowParser.NUMBER - 52)) | (1 << (DataflowParser.FRACTIONAL - 52)) | (1 << (DataflowParser.ANY_SIMPLE - 52)) | (1 << (DataflowParser.IDENTIFIER - 52)) | (1 << (DataflowParser.ANY_IDENTIFIER - 52)))) !== 0)) {
            this.state = 417;
            this.keyExpression();
            this.state = 422;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
        }
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};


function KeyContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = DataflowParser.RULE_key;
    return this;
}

KeyContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
KeyContext.prototype.constructor = KeyContext;

KeyContext.prototype.name = function() {
    return this.getTypedRuleContext(NameContext,0);
};

KeyContext.prototype.enterRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.enterKey(this);
	}
};

KeyContext.prototype.exitRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.exitKey(this);
	}
};

KeyContext.prototype.accept = function(visitor) {
    if ( visitor instanceof DataflowParserVisitor ) {
        return visitor.visitKey(this);
    } else {
        return visitor.visitChildren(this);
    }
};




DataflowParser.KeyContext = KeyContext;

DataflowParser.prototype.key = function() {

    var localctx = new KeyContext(this, this._ctx, this.state);
    this.enterRule(localctx, 68, DataflowParser.RULE_key);
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 423;
        this.name();
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};


function KeyExpressionContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = DataflowParser.RULE_keyExpression;
    return this;
}

KeyExpressionContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
KeyExpressionContext.prototype.constructor = KeyExpressionContext;

KeyExpressionContext.prototype.key = function() {
    return this.getTypedRuleContext(KeyContext,0);
};

KeyExpressionContext.prototype.ASSIGN = function() {
    return this.getToken(DataflowParser.ASSIGN, 0);
};

KeyExpressionContext.prototype.expression = function() {
    return this.getTypedRuleContext(ExpressionContext,0);
};

KeyExpressionContext.prototype.outputDefinition = function() {
    return this.getTypedRuleContext(OutputDefinitionContext,0);
};

KeyExpressionContext.prototype.inputDefinition = function() {
    return this.getTypedRuleContext(InputDefinitionContext,0);
};

KeyExpressionContext.prototype.enterRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.enterKeyExpression(this);
	}
};

KeyExpressionContext.prototype.exitRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.exitKeyExpression(this);
	}
};

KeyExpressionContext.prototype.accept = function(visitor) {
    if ( visitor instanceof DataflowParserVisitor ) {
        return visitor.visitKeyExpression(this);
    } else {
        return visitor.visitChildren(this);
    }
};




DataflowParser.KeyExpressionContext = KeyExpressionContext;

DataflowParser.prototype.keyExpression = function() {

    var localctx = new KeyExpressionContext(this, this._ctx, this.state);
    this.enterRule(localctx, 70, DataflowParser.RULE_keyExpression);
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 425;
        this.key();
        this.state = 426;
        this.match(DataflowParser.ASSIGN);
        this.state = 430;
        this._errHandler.sync(this);
        var la_ = this._interp.adaptivePredict(this._input,32,this._ctx);
        switch(la_) {
        case 1:
            this.state = 427;
            this.expression(0);
            break;

        case 2:
            this.state = 428;
            this.outputDefinition();
            break;

        case 3:
            this.state = 429;
            this.inputDefinition();
            break;

        }
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};


function ConfigNameContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = DataflowParser.RULE_configName;
    return this;
}

ConfigNameContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
ConfigNameContext.prototype.constructor = ConfigNameContext;

ConfigNameContext.prototype.basicName = function() {
    return this.getTypedRuleContext(BasicNameContext,0);
};

ConfigNameContext.prototype.enterRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.enterConfigName(this);
	}
};

ConfigNameContext.prototype.exitRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.exitConfigName(this);
	}
};

ConfigNameContext.prototype.accept = function(visitor) {
    if ( visitor instanceof DataflowParserVisitor ) {
        return visitor.visitConfigName(this);
    } else {
        return visitor.visitChildren(this);
    }
};




DataflowParser.ConfigNameContext = ConfigNameContext;

DataflowParser.prototype.configName = function() {

    var localctx = new ConfigNameContext(this, this._ctx, this.state);
    this.enterRule(localctx, 72, DataflowParser.RULE_configName);
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 432;
        this.basicName();
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};


function ConfigurationContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = DataflowParser.RULE_configuration;
    return this;
}

ConfigurationContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
ConfigurationContext.prototype.constructor = ConfigurationContext;

ConfigurationContext.prototype.configName = function() {
    return this.getTypedRuleContext(ConfigNameContext,0);
};

ConfigurationContext.prototype.COLON = function() {
    return this.getToken(DataflowParser.COLON, 0);
};

ConfigurationContext.prototype.expression = function() {
    return this.getTypedRuleContext(ExpressionContext,0);
};

ConfigurationContext.prototype.enterRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.enterConfiguration(this);
	}
};

ConfigurationContext.prototype.exitRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.exitConfiguration(this);
	}
};

ConfigurationContext.prototype.accept = function(visitor) {
    if ( visitor instanceof DataflowParserVisitor ) {
        return visitor.visitConfiguration(this);
    } else {
        return visitor.visitChildren(this);
    }
};




DataflowParser.ConfigurationContext = ConfigurationContext;

DataflowParser.prototype.configuration = function() {

    var localctx = new ConfigurationContext(this, this._ctx, this.state);
    this.enterRule(localctx, 74, DataflowParser.RULE_configuration);
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 434;
        this.configName();
        this.state = 435;
        this.match(DataflowParser.COLON);
        this.state = 436;
        this.expression(0);
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};


function TransformationContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = DataflowParser.RULE_transformation;
    return this;
}

TransformationContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
TransformationContext.prototype.constructor = TransformationContext;

TransformationContext.prototype.transformName = function() {
    return this.getTypedRuleContext(TransformNameContext,0);
};

TransformationContext.prototype.OPEN_PAREN = function() {
    return this.getToken(DataflowParser.OPEN_PAREN, 0);
};

TransformationContext.prototype.CLOSE_PAREN = function() {
    return this.getToken(DataflowParser.CLOSE_PAREN, 0);
};

TransformationContext.prototype.ANNOTATION_META_HEAD = function() {
    return this.getToken(DataflowParser.ANNOTATION_META_HEAD, 0);
};

TransformationContext.prototype.expression = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(ExpressionContext);
    } else {
        return this.getTypedRuleContext(ExpressionContext,i);
    }
};

TransformationContext.prototype.assignment = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(AssignmentContext);
    } else {
        return this.getTypedRuleContext(AssignmentContext,i);
    }
};

TransformationContext.prototype.inputDefinition = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(InputDefinitionContext);
    } else {
        return this.getTypedRuleContext(InputDefinitionContext,i);
    }
};

TransformationContext.prototype.outputDefinition = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(OutputDefinitionContext);
    } else {
        return this.getTypedRuleContext(OutputDefinitionContext,i);
    }
};

TransformationContext.prototype.COMMA = function(i) {
	if(i===undefined) {
		i = null;
	}
    if(i===null) {
        return this.getTokens(DataflowParser.COMMA);
    } else {
        return this.getToken(DataflowParser.COMMA, i);
    }
};


TransformationContext.prototype.ANNOTATION_TRANSIENT_ASSIGNMENT = function(i) {
	if(i===undefined) {
		i = null;
	}
    if(i===null) {
        return this.getTokens(DataflowParser.ANNOTATION_TRANSIENT_ASSIGNMENT);
    } else {
        return this.getToken(DataflowParser.ANNOTATION_TRANSIENT_ASSIGNMENT, i);
    }
};


TransformationContext.prototype.transientAssignment = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(TransientAssignmentContext);
    } else {
        return this.getTypedRuleContext(TransientAssignmentContext,i);
    }
};

TransformationContext.prototype.ANNOTATION_CONFIGURATION = function(i) {
	if(i===undefined) {
		i = null;
	}
    if(i===null) {
        return this.getTokens(DataflowParser.ANNOTATION_CONFIGURATION);
    } else {
        return this.getToken(DataflowParser.ANNOTATION_CONFIGURATION, i);
    }
};


TransformationContext.prototype.configuration = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(ConfigurationContext);
    } else {
        return this.getTypedRuleContext(ConfigurationContext,i);
    }
};

TransformationContext.prototype.enterRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.enterTransformation(this);
	}
};

TransformationContext.prototype.exitRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.exitTransformation(this);
	}
};

TransformationContext.prototype.accept = function(visitor) {
    if ( visitor instanceof DataflowParserVisitor ) {
        return visitor.visitTransformation(this);
    } else {
        return visitor.visitChildren(this);
    }
};




DataflowParser.TransformationContext = TransformationContext;

DataflowParser.prototype.transformation = function() {

    var localctx = new TransformationContext(this, this._ctx, this.state);
    this.enterRule(localctx, 76, DataflowParser.RULE_transformation);
    var _la = 0; // Token type
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 439;
        this._errHandler.sync(this);
        _la = this._input.LA(1);
        if(_la===DataflowParser.ANNOTATION_META_HEAD) {
            this.state = 438;
            this.match(DataflowParser.ANNOTATION_META_HEAD);
        }

        this.state = 441;
        this.transformName();
        this.state = 442;
        this.match(DataflowParser.OPEN_PAREN);
        this.state = 469;
        this._errHandler.sync(this);
        _la = this._input.LA(1);
        if((((_la) & ~0x1f) == 0 && ((1 << _la) & ((1 << DataflowParser.DECIMAL_LITERAL) | (1 << DataflowParser.HEX_LITERAL) | (1 << DataflowParser.OCT_LITERAL) | (1 << DataflowParser.BINARY_LITERAL) | (1 << DataflowParser.MINUS) | (1 << DataflowParser.NOT) | (1 << DataflowParser.DOLLAR) | (1 << DataflowParser.TILDA) | (1 << DataflowParser.COLON) | (1 << DataflowParser.OPEN_PAREN))) !== 0) || ((((_la - 33)) & ~0x1f) == 0 && ((1 << (_la - 33)) & ((1 << (DataflowParser.HASH - 33)) | (1 << (DataflowParser.OPEN_SQ - 33)) | (1 << (DataflowParser.OPEN_STRUCT - 33)) | (1 << (DataflowParser.OPEN_CLOSE_SQ - 33)) | (1 << (DataflowParser.FLOAT_LITERAL - 33)) | (1 << (DataflowParser.HEX_FLOAT_LITERAL - 33)) | (1 << (DataflowParser.STRING_LITERAL - 33)) | (1 << (DataflowParser.REGEX_LITERAL - 33)) | (1 << (DataflowParser.PARAMETERS - 33)) | (1 << (DataflowParser.FUNCTIONS - 33)) | (1 << (DataflowParser.AS - 33)) | (1 << (DataflowParser.INPUT - 33)) | (1 << (DataflowParser.OUTPUT - 33)) | (1 << (DataflowParser.CONSTANT - 33)) | (1 << (DataflowParser.EXPRESSION - 33)) | (1 << (DataflowParser.INTEGER - 33)) | (1 << (DataflowParser.SHORT - 33)) | (1 << (DataflowParser.LONG - 33)) | (1 << (DataflowParser.DOUBLE - 33)) | (1 << (DataflowParser.FLOAT - 33)) | (1 << (DataflowParser.DECIMAL - 33)))) !== 0) || ((((_la - 65)) & ~0x1f) == 0 && ((1 << (_la - 65)) & ((1 << (DataflowParser.BOOLEAN - 65)) | (1 << (DataflowParser.TIMESTAMP - 65)) | (1 << (DataflowParser.DATE - 65)) | (1 << (DataflowParser.BYTE - 65)) | (1 << (DataflowParser.BINARY - 65)) | (1 << (DataflowParser.INTEGRAL - 65)) | (1 << (DataflowParser.NUMBER - 65)) | (1 << (DataflowParser.FRACTIONAL - 65)) | (1 << (DataflowParser.ANY_SIMPLE - 65)) | (1 << (DataflowParser.IDENTIFIER - 65)) | (1 << (DataflowParser.ANY_IDENTIFIER - 65)) | (1 << (DataflowParser.META_MATCH - 65)) | (1 << (DataflowParser.META_VARIABLE - 65)) | (1 << (DataflowParser.META_POS - 65)) | (1 << (DataflowParser.OPEN_INTERPOLATE - 65)) | (1 << (DataflowParser.COMMENT - 65)) | (1 << (DataflowParser.ANNOTATION_META_HEAD - 65)) | (1 << (DataflowParser.ANNOTATION_GROUP - 65)) | (1 << (DataflowParser.ANNOTATION_TRANSIENT_ASSIGNMENT - 65)) | (1 << (DataflowParser.ANNOTATION_CONFIGURATION - 65)))) !== 0)) {
            this.state = 451;
            this._errHandler.sync(this);
            var la_ = this._interp.adaptivePredict(this._input,34,this._ctx);
            switch(la_) {
            case 1:
                this.state = 443;
                this.expression(0);
                break;

            case 2:
                this.state = 444;
                this.assignment();
                break;

            case 3:
                this.state = 445;
                this.match(DataflowParser.ANNOTATION_TRANSIENT_ASSIGNMENT);
                this.state = 446;
                this.transientAssignment();
                break;

            case 4:
                this.state = 447;
                this.match(DataflowParser.ANNOTATION_CONFIGURATION);
                this.state = 448;
                this.configuration();
                break;

            case 5:
                this.state = 449;
                this.inputDefinition();
                break;

            case 6:
                this.state = 450;
                this.outputDefinition();
                break;

            }
            this.state = 466;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            while(_la===DataflowParser.COMMA) {
                this.state = 453;
                this.match(DataflowParser.COMMA);
                this.state = 462;
                this._errHandler.sync(this);
                var la_ = this._interp.adaptivePredict(this._input,35,this._ctx);
                switch(la_) {
                case 1:
                    this.state = 454;
                    this.expression(0);
                    break;

                case 2:
                    this.state = 455;
                    this.assignment();
                    break;

                case 3:
                    this.state = 456;
                    this.match(DataflowParser.ANNOTATION_TRANSIENT_ASSIGNMENT);
                    this.state = 457;
                    this.transientAssignment();
                    break;

                case 4:
                    this.state = 458;
                    this.match(DataflowParser.ANNOTATION_CONFIGURATION);
                    this.state = 459;
                    this.configuration();
                    break;

                case 5:
                    this.state = 460;
                    this.inputDefinition();
                    break;

                case 6:
                    this.state = 461;
                    this.outputDefinition();
                    break;

                }
                this.state = 468;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
            }
        }

        this.state = 471;
        this.match(DataflowParser.CLOSE_PAREN);
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};


function TransformNameContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = DataflowParser.RULE_transformName;
    return this;
}

TransformNameContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
TransformNameContext.prototype.constructor = TransformNameContext;

TransformNameContext.prototype.basicName = function() {
    return this.getTypedRuleContext(BasicNameContext,0);
};

TransformNameContext.prototype.enterRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.enterTransformName(this);
	}
};

TransformNameContext.prototype.exitRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.exitTransformName(this);
	}
};

TransformNameContext.prototype.accept = function(visitor) {
    if ( visitor instanceof DataflowParserVisitor ) {
        return visitor.visitTransformName(this);
    } else {
        return visitor.visitChildren(this);
    }
};




DataflowParser.TransformNameContext = TransformNameContext;

DataflowParser.prototype.transformName = function() {

    var localctx = new TransformNameContext(this, this._ctx, this.state);
    this.enterRule(localctx, 78, DataflowParser.RULE_transformName);
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 473;
        this.basicName();
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};


function TransformedContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = DataflowParser.RULE_transformed;
    return this;
}

TransformedContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
TransformedContext.prototype.constructor = TransformedContext;

TransformedContext.prototype.basicName = function() {
    return this.getTypedRuleContext(BasicNameContext,0);
};

TransformedContext.prototype.enterRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.enterTransformed(this);
	}
};

TransformedContext.prototype.exitRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.exitTransformed(this);
	}
};

TransformedContext.prototype.accept = function(visitor) {
    if ( visitor instanceof DataflowParserVisitor ) {
        return visitor.visitTransformed(this);
    } else {
        return visitor.visitChildren(this);
    }
};




DataflowParser.TransformedContext = TransformedContext;

DataflowParser.prototype.transformed = function() {

    var localctx = new TransformedContext(this, this._ctx, this.state);
    this.enterRule(localctx, 80, DataflowParser.RULE_transformed);
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 475;
        this.basicName();
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};


function GroupNameContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = DataflowParser.RULE_groupName;
    return this;
}

GroupNameContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
GroupNameContext.prototype.constructor = GroupNameContext;

GroupNameContext.prototype.basicName = function() {
    return this.getTypedRuleContext(BasicNameContext,0);
};

GroupNameContext.prototype.enterRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.enterGroupName(this);
	}
};

GroupNameContext.prototype.exitRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.exitGroupName(this);
	}
};

GroupNameContext.prototype.accept = function(visitor) {
    if ( visitor instanceof DataflowParserVisitor ) {
        return visitor.visitGroupName(this);
    } else {
        return visitor.visitChildren(this);
    }
};




DataflowParser.GroupNameContext = GroupNameContext;

DataflowParser.prototype.groupName = function() {

    var localctx = new GroupNameContext(this, this._ctx, this.state);
    this.enterRule(localctx, 82, DataflowParser.RULE_groupName);
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 477;
        this.basicName();
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};


function TransformedGroupContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = DataflowParser.RULE_transformedGroup;
    return this;
}

TransformedGroupContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
TransformedGroupContext.prototype.constructor = TransformedGroupContext;

TransformedGroupContext.prototype.transformName = function() {
    return this.getTypedRuleContext(TransformNameContext,0);
};

TransformedGroupContext.prototype.AT = function() {
    return this.getToken(DataflowParser.AT, 0);
};

TransformedGroupContext.prototype.groupName = function() {
    return this.getTypedRuleContext(GroupNameContext,0);
};

TransformedGroupContext.prototype.enterRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.enterTransformedGroup(this);
	}
};

TransformedGroupContext.prototype.exitRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.exitTransformedGroup(this);
	}
};

TransformedGroupContext.prototype.accept = function(visitor) {
    if ( visitor instanceof DataflowParserVisitor ) {
        return visitor.visitTransformedGroup(this);
    } else {
        return visitor.visitChildren(this);
    }
};




DataflowParser.TransformedGroupContext = TransformedGroupContext;

DataflowParser.prototype.transformedGroup = function() {

    var localctx = new TransformedGroupContext(this, this._ctx, this.state);
    this.enterRule(localctx, 84, DataflowParser.RULE_transformedGroup);
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 479;
        this.transformName();
        this.state = 480;
        this.match(DataflowParser.AT);
        this.state = 481;
        this.groupName();
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};


function InputTransformedListContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = DataflowParser.RULE_inputTransformedList;
    return this;
}

InputTransformedListContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
InputTransformedListContext.prototype.constructor = InputTransformedListContext;

InputTransformedListContext.prototype.transformed = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(TransformedContext);
    } else {
        return this.getTypedRuleContext(TransformedContext,i);
    }
};

InputTransformedListContext.prototype.ANNOTATION_GROUP = function(i) {
	if(i===undefined) {
		i = null;
	}
    if(i===null) {
        return this.getTokens(DataflowParser.ANNOTATION_GROUP);
    } else {
        return this.getToken(DataflowParser.ANNOTATION_GROUP, i);
    }
};


InputTransformedListContext.prototype.transformedGroup = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(TransformedGroupContext);
    } else {
        return this.getTypedRuleContext(TransformedGroupContext,i);
    }
};

InputTransformedListContext.prototype.COMMA = function(i) {
	if(i===undefined) {
		i = null;
	}
    if(i===null) {
        return this.getTokens(DataflowParser.COMMA);
    } else {
        return this.getToken(DataflowParser.COMMA, i);
    }
};


InputTransformedListContext.prototype.enterRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.enterInputTransformedList(this);
	}
};

InputTransformedListContext.prototype.exitRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.exitInputTransformedList(this);
	}
};

InputTransformedListContext.prototype.accept = function(visitor) {
    if ( visitor instanceof DataflowParserVisitor ) {
        return visitor.visitInputTransformedList(this);
    } else {
        return visitor.visitChildren(this);
    }
};




DataflowParser.InputTransformedListContext = InputTransformedListContext;

DataflowParser.prototype.inputTransformedList = function() {

    var localctx = new InputTransformedListContext(this, this._ctx, this.state);
    this.enterRule(localctx, 86, DataflowParser.RULE_inputTransformedList);
    var _la = 0; // Token type
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 486;
        this._errHandler.sync(this);
        switch(this._input.LA(1)) {
        case DataflowParser.PARAMETERS:
        case DataflowParser.FUNCTIONS:
        case DataflowParser.AS:
        case DataflowParser.INPUT:
        case DataflowParser.OUTPUT:
        case DataflowParser.CONSTANT:
        case DataflowParser.EXPRESSION:
        case DataflowParser.INTEGER:
        case DataflowParser.SHORT:
        case DataflowParser.LONG:
        case DataflowParser.DOUBLE:
        case DataflowParser.FLOAT:
        case DataflowParser.DECIMAL:
        case DataflowParser.BOOLEAN:
        case DataflowParser.TIMESTAMP:
        case DataflowParser.DATE:
        case DataflowParser.BYTE:
        case DataflowParser.BINARY:
        case DataflowParser.INTEGRAL:
        case DataflowParser.NUMBER:
        case DataflowParser.FRACTIONAL:
        case DataflowParser.ANY_SIMPLE:
        case DataflowParser.IDENTIFIER:
            this.state = 483;
            this.transformed();
            break;
        case DataflowParser.ANNOTATION_GROUP:
            this.state = 484;
            this.match(DataflowParser.ANNOTATION_GROUP);
            this.state = 485;
            this.transformedGroup();
            break;
        default:
            throw new antlr4.error.NoViableAltException(this);
        }
        this.state = 496;
        this._errHandler.sync(this);
        _la = this._input.LA(1);
        while(_la===DataflowParser.COMMA) {
            this.state = 488;
            this.match(DataflowParser.COMMA);
            this.state = 492;
            this._errHandler.sync(this);
            switch(this._input.LA(1)) {
            case DataflowParser.PARAMETERS:
            case DataflowParser.FUNCTIONS:
            case DataflowParser.AS:
            case DataflowParser.INPUT:
            case DataflowParser.OUTPUT:
            case DataflowParser.CONSTANT:
            case DataflowParser.EXPRESSION:
            case DataflowParser.INTEGER:
            case DataflowParser.SHORT:
            case DataflowParser.LONG:
            case DataflowParser.DOUBLE:
            case DataflowParser.FLOAT:
            case DataflowParser.DECIMAL:
            case DataflowParser.BOOLEAN:
            case DataflowParser.TIMESTAMP:
            case DataflowParser.DATE:
            case DataflowParser.BYTE:
            case DataflowParser.BINARY:
            case DataflowParser.INTEGRAL:
            case DataflowParser.NUMBER:
            case DataflowParser.FRACTIONAL:
            case DataflowParser.ANY_SIMPLE:
            case DataflowParser.IDENTIFIER:
                this.state = 489;
                this.transformed();
                break;
            case DataflowParser.ANNOTATION_GROUP:
                this.state = 490;
                this.match(DataflowParser.ANNOTATION_GROUP);
                this.state = 491;
                this.transformedGroup();
                break;
            default:
                throw new antlr4.error.NoViableAltException(this);
            }
            this.state = 498;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
        }
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};


function InputDefinitionContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = DataflowParser.RULE_inputDefinition;
    return this;
}

InputDefinitionContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
InputDefinitionContext.prototype.constructor = InputDefinitionContext;

InputDefinitionContext.prototype.INPUT = function() {
    return this.getToken(DataflowParser.INPUT, 0);
};

InputDefinitionContext.prototype.OPEN_PAREN = function() {
    return this.getToken(DataflowParser.OPEN_PAREN, 0);
};

InputDefinitionContext.prototype.columnDefinition = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(ColumnDefinitionContext);
    } else {
        return this.getTypedRuleContext(ColumnDefinitionContext,i);
    }
};

InputDefinitionContext.prototype.CLOSE_PAREN = function() {
    return this.getToken(DataflowParser.CLOSE_PAREN, 0);
};

InputDefinitionContext.prototype.groupName = function() {
    return this.getTypedRuleContext(GroupNameContext,0);
};

InputDefinitionContext.prototype.COMMA = function(i) {
	if(i===undefined) {
		i = null;
	}
    if(i===null) {
        return this.getTokens(DataflowParser.COMMA);
    } else {
        return this.getToken(DataflowParser.COMMA, i);
    }
};


InputDefinitionContext.prototype.enterRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.enterInputDefinition(this);
	}
};

InputDefinitionContext.prototype.exitRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.exitInputDefinition(this);
	}
};

InputDefinitionContext.prototype.accept = function(visitor) {
    if ( visitor instanceof DataflowParserVisitor ) {
        return visitor.visitInputDefinition(this);
    } else {
        return visitor.visitChildren(this);
    }
};




DataflowParser.InputDefinitionContext = InputDefinitionContext;

DataflowParser.prototype.inputDefinition = function() {

    var localctx = new InputDefinitionContext(this, this._ctx, this.state);
    this.enterRule(localctx, 88, DataflowParser.RULE_inputDefinition);
    var _la = 0; // Token type
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 499;
        this.match(DataflowParser.INPUT);
        this.state = 500;
        this.match(DataflowParser.OPEN_PAREN);
        this.state = 504;
        this._errHandler.sync(this);
        var la_ = this._interp.adaptivePredict(this._input,41,this._ctx);
        if(la_===1) {
            this.state = 501;
            this.groupName();
            this.state = 502;
            this.match(DataflowParser.COMMA);

        }
        this.state = 506;
        this.columnDefinition();
        this.state = 511;
        this._errHandler.sync(this);
        _la = this._input.LA(1);
        while(_la===DataflowParser.COMMA) {
            this.state = 507;
            this.match(DataflowParser.COMMA);
            this.state = 508;
            this.columnDefinition();
            this.state = 513;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
        }
        this.state = 514;
        this.match(DataflowParser.CLOSE_PAREN);
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};


function OutputDefinitionContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = DataflowParser.RULE_outputDefinition;
    return this;
}

OutputDefinitionContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
OutputDefinitionContext.prototype.constructor = OutputDefinitionContext;

OutputDefinitionContext.prototype.OUTPUT = function() {
    return this.getToken(DataflowParser.OUTPUT, 0);
};

OutputDefinitionContext.prototype.OPEN_PAREN = function() {
    return this.getToken(DataflowParser.OPEN_PAREN, 0);
};

OutputDefinitionContext.prototype.columnDefinition = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(ColumnDefinitionContext);
    } else {
        return this.getTypedRuleContext(ColumnDefinitionContext,i);
    }
};

OutputDefinitionContext.prototype.CLOSE_PAREN = function() {
    return this.getToken(DataflowParser.CLOSE_PAREN, 0);
};

OutputDefinitionContext.prototype.groupName = function() {
    return this.getTypedRuleContext(GroupNameContext,0);
};

OutputDefinitionContext.prototype.COMMA = function(i) {
	if(i===undefined) {
		i = null;
	}
    if(i===null) {
        return this.getTokens(DataflowParser.COMMA);
    } else {
        return this.getToken(DataflowParser.COMMA, i);
    }
};


OutputDefinitionContext.prototype.enterRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.enterOutputDefinition(this);
	}
};

OutputDefinitionContext.prototype.exitRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.exitOutputDefinition(this);
	}
};

OutputDefinitionContext.prototype.accept = function(visitor) {
    if ( visitor instanceof DataflowParserVisitor ) {
        return visitor.visitOutputDefinition(this);
    } else {
        return visitor.visitChildren(this);
    }
};




DataflowParser.OutputDefinitionContext = OutputDefinitionContext;

DataflowParser.prototype.outputDefinition = function() {

    var localctx = new OutputDefinitionContext(this, this._ctx, this.state);
    this.enterRule(localctx, 90, DataflowParser.RULE_outputDefinition);
    var _la = 0; // Token type
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 516;
        this.match(DataflowParser.OUTPUT);
        this.state = 517;
        this.match(DataflowParser.OPEN_PAREN);
        this.state = 521;
        this._errHandler.sync(this);
        var la_ = this._interp.adaptivePredict(this._input,43,this._ctx);
        if(la_===1) {
            this.state = 518;
            this.groupName();
            this.state = 519;
            this.match(DataflowParser.COMMA);

        }
        this.state = 523;
        this.columnDefinition();
        this.state = 528;
        this._errHandler.sync(this);
        _la = this._input.LA(1);
        while(_la===DataflowParser.COMMA) {
            this.state = 524;
            this.match(DataflowParser.COMMA);
            this.state = 525;
            this.columnDefinition();
            this.state = 530;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
        }
        this.state = 531;
        this.match(DataflowParser.CLOSE_PAREN);
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};


function OutputTransformedContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = DataflowParser.RULE_outputTransformed;
    return this;
}

OutputTransformedContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
OutputTransformedContext.prototype.constructor = OutputTransformedContext;

OutputTransformedContext.prototype.transformed = function() {
    return this.getTypedRuleContext(TransformedContext,0);
};

OutputTransformedContext.prototype.OPEN_STRUCT = function() {
    return this.getToken(DataflowParser.OPEN_STRUCT, 0);
};

OutputTransformedContext.prototype.groupName = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(GroupNameContext);
    } else {
        return this.getTypedRuleContext(GroupNameContext,i);
    }
};

OutputTransformedContext.prototype.CLOSE_PAREN = function() {
    return this.getToken(DataflowParser.CLOSE_PAREN, 0);
};

OutputTransformedContext.prototype.COMMA = function(i) {
	if(i===undefined) {
		i = null;
	}
    if(i===null) {
        return this.getTokens(DataflowParser.COMMA);
    } else {
        return this.getToken(DataflowParser.COMMA, i);
    }
};


OutputTransformedContext.prototype.enterRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.enterOutputTransformed(this);
	}
};

OutputTransformedContext.prototype.exitRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.exitOutputTransformed(this);
	}
};

OutputTransformedContext.prototype.accept = function(visitor) {
    if ( visitor instanceof DataflowParserVisitor ) {
        return visitor.visitOutputTransformed(this);
    } else {
        return visitor.visitChildren(this);
    }
};




DataflowParser.OutputTransformedContext = OutputTransformedContext;

DataflowParser.prototype.outputTransformed = function() {

    var localctx = new OutputTransformedContext(this, this._ctx, this.state);
    this.enterRule(localctx, 92, DataflowParser.RULE_outputTransformed);
    var _la = 0; // Token type
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 533;
        this.transformed();
        this.state = 545;
        this._errHandler.sync(this);
        _la = this._input.LA(1);
        if(_la===DataflowParser.OPEN_STRUCT) {
            this.state = 534;
            this.match(DataflowParser.OPEN_STRUCT);
            this.state = 535;
            this.groupName();
            this.state = 540;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            while(_la===DataflowParser.COMMA) {
                this.state = 536;
                this.match(DataflowParser.COMMA);
                this.state = 537;
                this.groupName();
                this.state = 542;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
            }
            this.state = 543;
            this.match(DataflowParser.CLOSE_PAREN);
        }

    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};


function FlowStatementContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = DataflowParser.RULE_flowStatement;
    return this;
}

FlowStatementContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
FlowStatementContext.prototype.constructor = FlowStatementContext;

FlowStatementContext.prototype.transformation = function() {
    return this.getTypedRuleContext(TransformationContext,0);
};

FlowStatementContext.prototype.FLOW = function() {
    return this.getToken(DataflowParser.FLOW, 0);
};

FlowStatementContext.prototype.outputTransformed = function() {
    return this.getTypedRuleContext(OutputTransformedContext,0);
};

FlowStatementContext.prototype.inputTransformedList = function() {
    return this.getTypedRuleContext(InputTransformedListContext,0);
};

FlowStatementContext.prototype.enterRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.enterFlowStatement(this);
	}
};

FlowStatementContext.prototype.exitRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.exitFlowStatement(this);
	}
};

FlowStatementContext.prototype.accept = function(visitor) {
    if ( visitor instanceof DataflowParserVisitor ) {
        return visitor.visitFlowStatement(this);
    } else {
        return visitor.visitChildren(this);
    }
};




DataflowParser.FlowStatementContext = FlowStatementContext;

DataflowParser.prototype.flowStatement = function() {

    var localctx = new FlowStatementContext(this, this._ctx, this.state);
    this.enterRule(localctx, 94, DataflowParser.RULE_flowStatement);
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 548;
        this._errHandler.sync(this);
        var la_ = this._interp.adaptivePredict(this._input,47,this._ctx);
        if(la_===1) {
            this.state = 547;
            this.inputTransformedList();

        }
        this.state = 550;
        this.transformation();
        this.state = 551;
        this.match(DataflowParser.FLOW);
        this.state = 552;
        this.outputTransformed();
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};


function SimpleContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = DataflowParser.RULE_simple;
    return this;
}

SimpleContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
SimpleContext.prototype.constructor = SimpleContext;


 
SimpleContext.prototype.copyFrom = function(ctx) {
    antlr4.ParserRuleContext.prototype.copyFrom.call(this, ctx);
};


function FractionalTypeContext(parser, ctx) {
	SimpleContext.call(this, parser);
    SimpleContext.prototype.copyFrom.call(this, ctx);
    return this;
}

FractionalTypeContext.prototype = Object.create(SimpleContext.prototype);
FractionalTypeContext.prototype.constructor = FractionalTypeContext;

DataflowParser.FractionalTypeContext = FractionalTypeContext;

FractionalTypeContext.prototype.FRACTIONAL = function() {
    return this.getToken(DataflowParser.FRACTIONAL, 0);
};
FractionalTypeContext.prototype.enterRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.enterFractionalType(this);
	}
};

FractionalTypeContext.prototype.exitRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.exitFractionalType(this);
	}
};

FractionalTypeContext.prototype.accept = function(visitor) {
    if ( visitor instanceof DataflowParserVisitor ) {
        return visitor.visitFractionalType(this);
    } else {
        return visitor.visitChildren(this);
    }
};


function LongTypeContext(parser, ctx) {
	SimpleContext.call(this, parser);
    SimpleContext.prototype.copyFrom.call(this, ctx);
    return this;
}

LongTypeContext.prototype = Object.create(SimpleContext.prototype);
LongTypeContext.prototype.constructor = LongTypeContext;

DataflowParser.LongTypeContext = LongTypeContext;

LongTypeContext.prototype.LONG = function() {
    return this.getToken(DataflowParser.LONG, 0);
};
LongTypeContext.prototype.enterRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.enterLongType(this);
	}
};

LongTypeContext.prototype.exitRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.exitLongType(this);
	}
};

LongTypeContext.prototype.accept = function(visitor) {
    if ( visitor instanceof DataflowParserVisitor ) {
        return visitor.visitLongType(this);
    } else {
        return visitor.visitChildren(this);
    }
};


function BinaryTypeContext(parser, ctx) {
	SimpleContext.call(this, parser);
    SimpleContext.prototype.copyFrom.call(this, ctx);
    return this;
}

BinaryTypeContext.prototype = Object.create(SimpleContext.prototype);
BinaryTypeContext.prototype.constructor = BinaryTypeContext;

DataflowParser.BinaryTypeContext = BinaryTypeContext;

BinaryTypeContext.prototype.BINARY = function() {
    return this.getToken(DataflowParser.BINARY, 0);
};
BinaryTypeContext.prototype.enterRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.enterBinaryType(this);
	}
};

BinaryTypeContext.prototype.exitRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.exitBinaryType(this);
	}
};

BinaryTypeContext.prototype.accept = function(visitor) {
    if ( visitor instanceof DataflowParserVisitor ) {
        return visitor.visitBinaryType(this);
    } else {
        return visitor.visitChildren(this);
    }
};


function StringTypeContext(parser, ctx) {
	SimpleContext.call(this, parser);
    SimpleContext.prototype.copyFrom.call(this, ctx);
    return this;
}

StringTypeContext.prototype = Object.create(SimpleContext.prototype);
StringTypeContext.prototype.constructor = StringTypeContext;

DataflowParser.StringTypeContext = StringTypeContext;

StringTypeContext.prototype.STRING = function() {
    return this.getToken(DataflowParser.STRING, 0);
};
StringTypeContext.prototype.enterRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.enterStringType(this);
	}
};

StringTypeContext.prototype.exitRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.exitStringType(this);
	}
};

StringTypeContext.prototype.accept = function(visitor) {
    if ( visitor instanceof DataflowParserVisitor ) {
        return visitor.visitStringType(this);
    } else {
        return visitor.visitChildren(this);
    }
};


function ShortTypeContext(parser, ctx) {
	SimpleContext.call(this, parser);
    SimpleContext.prototype.copyFrom.call(this, ctx);
    return this;
}

ShortTypeContext.prototype = Object.create(SimpleContext.prototype);
ShortTypeContext.prototype.constructor = ShortTypeContext;

DataflowParser.ShortTypeContext = ShortTypeContext;

ShortTypeContext.prototype.SHORT = function() {
    return this.getToken(DataflowParser.SHORT, 0);
};
ShortTypeContext.prototype.enterRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.enterShortType(this);
	}
};

ShortTypeContext.prototype.exitRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.exitShortType(this);
	}
};

ShortTypeContext.prototype.accept = function(visitor) {
    if ( visitor instanceof DataflowParserVisitor ) {
        return visitor.visitShortType(this);
    } else {
        return visitor.visitChildren(this);
    }
};


function BooleanTypeContext(parser, ctx) {
	SimpleContext.call(this, parser);
    SimpleContext.prototype.copyFrom.call(this, ctx);
    return this;
}

BooleanTypeContext.prototype = Object.create(SimpleContext.prototype);
BooleanTypeContext.prototype.constructor = BooleanTypeContext;

DataflowParser.BooleanTypeContext = BooleanTypeContext;

BooleanTypeContext.prototype.BOOLEAN = function() {
    return this.getToken(DataflowParser.BOOLEAN, 0);
};
BooleanTypeContext.prototype.enterRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.enterBooleanType(this);
	}
};

BooleanTypeContext.prototype.exitRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.exitBooleanType(this);
	}
};

BooleanTypeContext.prototype.accept = function(visitor) {
    if ( visitor instanceof DataflowParserVisitor ) {
        return visitor.visitBooleanType(this);
    } else {
        return visitor.visitChildren(this);
    }
};


function ByteTypeContext(parser, ctx) {
	SimpleContext.call(this, parser);
    SimpleContext.prototype.copyFrom.call(this, ctx);
    return this;
}

ByteTypeContext.prototype = Object.create(SimpleContext.prototype);
ByteTypeContext.prototype.constructor = ByteTypeContext;

DataflowParser.ByteTypeContext = ByteTypeContext;

ByteTypeContext.prototype.BYTE = function() {
    return this.getToken(DataflowParser.BYTE, 0);
};
ByteTypeContext.prototype.enterRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.enterByteType(this);
	}
};

ByteTypeContext.prototype.exitRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.exitByteType(this);
	}
};

ByteTypeContext.prototype.accept = function(visitor) {
    if ( visitor instanceof DataflowParserVisitor ) {
        return visitor.visitByteType(this);
    } else {
        return visitor.visitChildren(this);
    }
};


function FloatTypeContext(parser, ctx) {
	SimpleContext.call(this, parser);
    SimpleContext.prototype.copyFrom.call(this, ctx);
    return this;
}

FloatTypeContext.prototype = Object.create(SimpleContext.prototype);
FloatTypeContext.prototype.constructor = FloatTypeContext;

DataflowParser.FloatTypeContext = FloatTypeContext;

FloatTypeContext.prototype.FLOAT = function() {
    return this.getToken(DataflowParser.FLOAT, 0);
};
FloatTypeContext.prototype.enterRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.enterFloatType(this);
	}
};

FloatTypeContext.prototype.exitRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.exitFloatType(this);
	}
};

FloatTypeContext.prototype.accept = function(visitor) {
    if ( visitor instanceof DataflowParserVisitor ) {
        return visitor.visitFloatType(this);
    } else {
        return visitor.visitChildren(this);
    }
};


function IntegerTypeContext(parser, ctx) {
	SimpleContext.call(this, parser);
    SimpleContext.prototype.copyFrom.call(this, ctx);
    return this;
}

IntegerTypeContext.prototype = Object.create(SimpleContext.prototype);
IntegerTypeContext.prototype.constructor = IntegerTypeContext;

DataflowParser.IntegerTypeContext = IntegerTypeContext;

IntegerTypeContext.prototype.INTEGER = function() {
    return this.getToken(DataflowParser.INTEGER, 0);
};
IntegerTypeContext.prototype.enterRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.enterIntegerType(this);
	}
};

IntegerTypeContext.prototype.exitRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.exitIntegerType(this);
	}
};

IntegerTypeContext.prototype.accept = function(visitor) {
    if ( visitor instanceof DataflowParserVisitor ) {
        return visitor.visitIntegerType(this);
    } else {
        return visitor.visitChildren(this);
    }
};


function NumberTypeContext(parser, ctx) {
	SimpleContext.call(this, parser);
    SimpleContext.prototype.copyFrom.call(this, ctx);
    return this;
}

NumberTypeContext.prototype = Object.create(SimpleContext.prototype);
NumberTypeContext.prototype.constructor = NumberTypeContext;

DataflowParser.NumberTypeContext = NumberTypeContext;

NumberTypeContext.prototype.NUMBER = function() {
    return this.getToken(DataflowParser.NUMBER, 0);
};
NumberTypeContext.prototype.enterRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.enterNumberType(this);
	}
};

NumberTypeContext.prototype.exitRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.exitNumberType(this);
	}
};

NumberTypeContext.prototype.accept = function(visitor) {
    if ( visitor instanceof DataflowParserVisitor ) {
        return visitor.visitNumberType(this);
    } else {
        return visitor.visitChildren(this);
    }
};


function IntegralTypeContext(parser, ctx) {
	SimpleContext.call(this, parser);
    SimpleContext.prototype.copyFrom.call(this, ctx);
    return this;
}

IntegralTypeContext.prototype = Object.create(SimpleContext.prototype);
IntegralTypeContext.prototype.constructor = IntegralTypeContext;

DataflowParser.IntegralTypeContext = IntegralTypeContext;

IntegralTypeContext.prototype.INTEGRAL = function() {
    return this.getToken(DataflowParser.INTEGRAL, 0);
};
IntegralTypeContext.prototype.enterRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.enterIntegralType(this);
	}
};

IntegralTypeContext.prototype.exitRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.exitIntegralType(this);
	}
};

IntegralTypeContext.prototype.accept = function(visitor) {
    if ( visitor instanceof DataflowParserVisitor ) {
        return visitor.visitIntegralType(this);
    } else {
        return visitor.visitChildren(this);
    }
};


function DoubleTypeContext(parser, ctx) {
	SimpleContext.call(this, parser);
    SimpleContext.prototype.copyFrom.call(this, ctx);
    return this;
}

DoubleTypeContext.prototype = Object.create(SimpleContext.prototype);
DoubleTypeContext.prototype.constructor = DoubleTypeContext;

DataflowParser.DoubleTypeContext = DoubleTypeContext;

DoubleTypeContext.prototype.DOUBLE = function() {
    return this.getToken(DataflowParser.DOUBLE, 0);
};
DoubleTypeContext.prototype.enterRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.enterDoubleType(this);
	}
};

DoubleTypeContext.prototype.exitRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.exitDoubleType(this);
	}
};

DoubleTypeContext.prototype.accept = function(visitor) {
    if ( visitor instanceof DataflowParserVisitor ) {
        return visitor.visitDoubleType(this);
    } else {
        return visitor.visitChildren(this);
    }
};


function TimestampTypeContext(parser, ctx) {
	SimpleContext.call(this, parser);
    SimpleContext.prototype.copyFrom.call(this, ctx);
    return this;
}

TimestampTypeContext.prototype = Object.create(SimpleContext.prototype);
TimestampTypeContext.prototype.constructor = TimestampTypeContext;

DataflowParser.TimestampTypeContext = TimestampTypeContext;

TimestampTypeContext.prototype.TIMESTAMP = function() {
    return this.getToken(DataflowParser.TIMESTAMP, 0);
};
TimestampTypeContext.prototype.enterRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.enterTimestampType(this);
	}
};

TimestampTypeContext.prototype.exitRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.exitTimestampType(this);
	}
};

TimestampTypeContext.prototype.accept = function(visitor) {
    if ( visitor instanceof DataflowParserVisitor ) {
        return visitor.visitTimestampType(this);
    } else {
        return visitor.visitChildren(this);
    }
};


function DecimalTypeContext(parser, ctx) {
	SimpleContext.call(this, parser);
    this.precision = null; // Index_literalContext;
    this.scale = null; // Index_literalContext;
    SimpleContext.prototype.copyFrom.call(this, ctx);
    return this;
}

DecimalTypeContext.prototype = Object.create(SimpleContext.prototype);
DecimalTypeContext.prototype.constructor = DecimalTypeContext;

DataflowParser.DecimalTypeContext = DecimalTypeContext;

DecimalTypeContext.prototype.DECIMAL = function() {
    return this.getToken(DataflowParser.DECIMAL, 0);
};

DecimalTypeContext.prototype.OPEN_PAREN = function() {
    return this.getToken(DataflowParser.OPEN_PAREN, 0);
};

DecimalTypeContext.prototype.COMMA = function() {
    return this.getToken(DataflowParser.COMMA, 0);
};

DecimalTypeContext.prototype.CLOSE_PAREN = function() {
    return this.getToken(DataflowParser.CLOSE_PAREN, 0);
};

DecimalTypeContext.prototype.index_literal = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(Index_literalContext);
    } else {
        return this.getTypedRuleContext(Index_literalContext,i);
    }
};
DecimalTypeContext.prototype.enterRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.enterDecimalType(this);
	}
};

DecimalTypeContext.prototype.exitRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.exitDecimalType(this);
	}
};

DecimalTypeContext.prototype.accept = function(visitor) {
    if ( visitor instanceof DataflowParserVisitor ) {
        return visitor.visitDecimalType(this);
    } else {
        return visitor.visitChildren(this);
    }
};


function DateTypeContext(parser, ctx) {
	SimpleContext.call(this, parser);
    SimpleContext.prototype.copyFrom.call(this, ctx);
    return this;
}

DateTypeContext.prototype = Object.create(SimpleContext.prototype);
DateTypeContext.prototype.constructor = DateTypeContext;

DataflowParser.DateTypeContext = DateTypeContext;

DateTypeContext.prototype.DATE = function() {
    return this.getToken(DataflowParser.DATE, 0);
};
DateTypeContext.prototype.enterRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.enterDateType(this);
	}
};

DateTypeContext.prototype.exitRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.exitDateType(this);
	}
};

DateTypeContext.prototype.accept = function(visitor) {
    if ( visitor instanceof DataflowParserVisitor ) {
        return visitor.visitDateType(this);
    } else {
        return visitor.visitChildren(this);
    }
};


function AnyTypeContext(parser, ctx) {
	SimpleContext.call(this, parser);
    SimpleContext.prototype.copyFrom.call(this, ctx);
    return this;
}

AnyTypeContext.prototype = Object.create(SimpleContext.prototype);
AnyTypeContext.prototype.constructor = AnyTypeContext;

DataflowParser.AnyTypeContext = AnyTypeContext;

AnyTypeContext.prototype.ANY_SIMPLE = function() {
    return this.getToken(DataflowParser.ANY_SIMPLE, 0);
};
AnyTypeContext.prototype.enterRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.enterAnyType(this);
	}
};

AnyTypeContext.prototype.exitRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.exitAnyType(this);
	}
};

AnyTypeContext.prototype.accept = function(visitor) {
    if ( visitor instanceof DataflowParserVisitor ) {
        return visitor.visitAnyType(this);
    } else {
        return visitor.visitChildren(this);
    }
};



DataflowParser.SimpleContext = SimpleContext;

DataflowParser.prototype.simple = function() {

    var localctx = new SimpleContext(this, this._ctx, this.state);
    this.enterRule(localctx, 96, DataflowParser.RULE_simple);
    try {
        this.state = 576;
        this._errHandler.sync(this);
        switch(this._input.LA(1)) {
        case DataflowParser.INTEGER:
            localctx = new IntegerTypeContext(this, localctx);
            this.enterOuterAlt(localctx, 1);
            this.state = 554;
            this.match(DataflowParser.INTEGER);
            break;
        case DataflowParser.SHORT:
            localctx = new ShortTypeContext(this, localctx);
            this.enterOuterAlt(localctx, 2);
            this.state = 555;
            this.match(DataflowParser.SHORT);
            break;
        case DataflowParser.LONG:
            localctx = new LongTypeContext(this, localctx);
            this.enterOuterAlt(localctx, 3);
            this.state = 556;
            this.match(DataflowParser.LONG);
            break;
        case DataflowParser.DOUBLE:
            localctx = new DoubleTypeContext(this, localctx);
            this.enterOuterAlt(localctx, 4);
            this.state = 557;
            this.match(DataflowParser.DOUBLE);
            break;
        case DataflowParser.FLOAT:
            localctx = new FloatTypeContext(this, localctx);
            this.enterOuterAlt(localctx, 5);
            this.state = 558;
            this.match(DataflowParser.FLOAT);
            break;
        case DataflowParser.BOOLEAN:
            localctx = new BooleanTypeContext(this, localctx);
            this.enterOuterAlt(localctx, 6);
            this.state = 559;
            this.match(DataflowParser.BOOLEAN);
            break;
        case DataflowParser.STRING:
            localctx = new StringTypeContext(this, localctx);
            this.enterOuterAlt(localctx, 7);
            this.state = 560;
            this.match(DataflowParser.STRING);
            break;
        case DataflowParser.DATE:
            localctx = new DateTypeContext(this, localctx);
            this.enterOuterAlt(localctx, 8);
            this.state = 561;
            this.match(DataflowParser.DATE);
            break;
        case DataflowParser.BYTE:
            localctx = new ByteTypeContext(this, localctx);
            this.enterOuterAlt(localctx, 9);
            this.state = 562;
            this.match(DataflowParser.BYTE);
            break;
        case DataflowParser.BINARY:
            localctx = new BinaryTypeContext(this, localctx);
            this.enterOuterAlt(localctx, 10);
            this.state = 563;
            this.match(DataflowParser.BINARY);
            break;
        case DataflowParser.TIMESTAMP:
            localctx = new TimestampTypeContext(this, localctx);
            this.enterOuterAlt(localctx, 11);
            this.state = 564;
            this.match(DataflowParser.TIMESTAMP);
            break;
        case DataflowParser.DECIMAL:
            localctx = new DecimalTypeContext(this, localctx);
            this.enterOuterAlt(localctx, 12);
            this.state = 565;
            this.match(DataflowParser.DECIMAL);
            this.state = 566;
            this.match(DataflowParser.OPEN_PAREN);
            this.state = 567;
            localctx.precision = this.index_literal();
            this.state = 568;
            this.match(DataflowParser.COMMA);
            this.state = 569;
            localctx.scale = this.index_literal();
            this.state = 570;
            this.match(DataflowParser.CLOSE_PAREN);
            break;
        case DataflowParser.INTEGRAL:
            localctx = new IntegralTypeContext(this, localctx);
            this.enterOuterAlt(localctx, 13);
            this.state = 572;
            this.match(DataflowParser.INTEGRAL);
            break;
        case DataflowParser.FRACTIONAL:
            localctx = new FractionalTypeContext(this, localctx);
            this.enterOuterAlt(localctx, 14);
            this.state = 573;
            this.match(DataflowParser.FRACTIONAL);
            break;
        case DataflowParser.NUMBER:
            localctx = new NumberTypeContext(this, localctx);
            this.enterOuterAlt(localctx, 15);
            this.state = 574;
            this.match(DataflowParser.NUMBER);
            break;
        case DataflowParser.ANY_SIMPLE:
            localctx = new AnyTypeContext(this, localctx);
            this.enterOuterAlt(localctx, 16);
            this.state = 575;
            this.match(DataflowParser.ANY_SIMPLE);
            break;
        default:
            throw new antlr4.error.NoViableAltException(this);
        }
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};


function ComplexContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = DataflowParser.RULE_complex;
    return this;
}

ComplexContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
ComplexContext.prototype.constructor = ComplexContext;

ComplexContext.prototype.OPEN_PAREN = function() {
    return this.getToken(DataflowParser.OPEN_PAREN, 0);
};

ComplexContext.prototype.columnDefinition = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(ColumnDefinitionContext);
    } else {
        return this.getTypedRuleContext(ColumnDefinitionContext,i);
    }
};

ComplexContext.prototype.CLOSE_PAREN = function() {
    return this.getToken(DataflowParser.CLOSE_PAREN, 0);
};

ComplexContext.prototype.COMMA = function(i) {
	if(i===undefined) {
		i = null;
	}
    if(i===null) {
        return this.getTokens(DataflowParser.COMMA);
    } else {
        return this.getToken(DataflowParser.COMMA, i);
    }
};


ComplexContext.prototype.enterRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.enterComplex(this);
	}
};

ComplexContext.prototype.exitRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.exitComplex(this);
	}
};

ComplexContext.prototype.accept = function(visitor) {
    if ( visitor instanceof DataflowParserVisitor ) {
        return visitor.visitComplex(this);
    } else {
        return visitor.visitChildren(this);
    }
};




DataflowParser.ComplexContext = ComplexContext;

DataflowParser.prototype.complex = function() {

    var localctx = new ComplexContext(this, this._ctx, this.state);
    this.enterRule(localctx, 98, DataflowParser.RULE_complex);
    var _la = 0; // Token type
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 578;
        this.match(DataflowParser.OPEN_PAREN);
        this.state = 579;
        this.columnDefinition();
        this.state = 584;
        this._errHandler.sync(this);
        _la = this._input.LA(1);
        while(_la===DataflowParser.COMMA) {
            this.state = 580;
            this.match(DataflowParser.COMMA);
            this.state = 581;
            this.columnDefinition();
            this.state = 586;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
        }
        this.state = 587;
        this.match(DataflowParser.CLOSE_PAREN);
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};


function DatatypeContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = DataflowParser.RULE_datatype;
    return this;
}

DatatypeContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
DatatypeContext.prototype.constructor = DatatypeContext;


 
DatatypeContext.prototype.copyFrom = function(ctx) {
    antlr4.ParserRuleContext.prototype.copyFrom.call(this, ctx);
};

function ArrayTypeContext(parser, ctx) {
	DatatypeContext.call(this, parser);
    DatatypeContext.prototype.copyFrom.call(this, ctx);
    return this;
}

ArrayTypeContext.prototype = Object.create(DatatypeContext.prototype);
ArrayTypeContext.prototype.constructor = ArrayTypeContext;

DataflowParser.ArrayTypeContext = ArrayTypeContext;

ArrayTypeContext.prototype.datatype = function() {
    return this.getTypedRuleContext(DatatypeContext,0);
};

ArrayTypeContext.prototype.OPEN_CLOSE_SQ = function() {
    return this.getToken(DataflowParser.OPEN_CLOSE_SQ, 0);
};
ArrayTypeContext.prototype.enterRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.enterArrayType(this);
	}
};

ArrayTypeContext.prototype.exitRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.exitArrayType(this);
	}
};

ArrayTypeContext.prototype.accept = function(visitor) {
    if ( visitor instanceof DataflowParserVisitor ) {
        return visitor.visitArrayType(this);
    } else {
        return visitor.visitChildren(this);
    }
};


function SimpleTypeContext(parser, ctx) {
	DatatypeContext.call(this, parser);
    DatatypeContext.prototype.copyFrom.call(this, ctx);
    return this;
}

SimpleTypeContext.prototype = Object.create(DatatypeContext.prototype);
SimpleTypeContext.prototype.constructor = SimpleTypeContext;

DataflowParser.SimpleTypeContext = SimpleTypeContext;

SimpleTypeContext.prototype.simple = function() {
    return this.getTypedRuleContext(SimpleContext,0);
};
SimpleTypeContext.prototype.enterRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.enterSimpleType(this);
	}
};

SimpleTypeContext.prototype.exitRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.exitSimpleType(this);
	}
};

SimpleTypeContext.prototype.accept = function(visitor) {
    if ( visitor instanceof DataflowParserVisitor ) {
        return visitor.visitSimpleType(this);
    } else {
        return visitor.visitChildren(this);
    }
};


function ComplexTypeContext(parser, ctx) {
	DatatypeContext.call(this, parser);
    DatatypeContext.prototype.copyFrom.call(this, ctx);
    return this;
}

ComplexTypeContext.prototype = Object.create(DatatypeContext.prototype);
ComplexTypeContext.prototype.constructor = ComplexTypeContext;

DataflowParser.ComplexTypeContext = ComplexTypeContext;

ComplexTypeContext.prototype.complex = function() {
    return this.getTypedRuleContext(ComplexContext,0);
};
ComplexTypeContext.prototype.enterRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.enterComplexType(this);
	}
};

ComplexTypeContext.prototype.exitRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.exitComplexType(this);
	}
};

ComplexTypeContext.prototype.accept = function(visitor) {
    if ( visitor instanceof DataflowParserVisitor ) {
        return visitor.visitComplexType(this);
    } else {
        return visitor.visitChildren(this);
    }
};


function MapTypeContext(parser, ctx) {
	DatatypeContext.call(this, parser);
    this.mapKey = null; // DatatypeContext;
    this.mapValue = null; // DatatypeContext;
    DatatypeContext.prototype.copyFrom.call(this, ctx);
    return this;
}

MapTypeContext.prototype = Object.create(DatatypeContext.prototype);
MapTypeContext.prototype.constructor = MapTypeContext;

DataflowParser.MapTypeContext = MapTypeContext;

MapTypeContext.prototype.OPEN_SQ = function() {
    return this.getToken(DataflowParser.OPEN_SQ, 0);
};

MapTypeContext.prototype.COMMA = function() {
    return this.getToken(DataflowParser.COMMA, 0);
};

MapTypeContext.prototype.CLOSE_SQ = function() {
    return this.getToken(DataflowParser.CLOSE_SQ, 0);
};

MapTypeContext.prototype.datatype = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(DatatypeContext);
    } else {
        return this.getTypedRuleContext(DatatypeContext,i);
    }
};
MapTypeContext.prototype.enterRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.enterMapType(this);
	}
};

MapTypeContext.prototype.exitRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.exitMapType(this);
	}
};

MapTypeContext.prototype.accept = function(visitor) {
    if ( visitor instanceof DataflowParserVisitor ) {
        return visitor.visitMapType(this);
    } else {
        return visitor.visitChildren(this);
    }
};



DataflowParser.prototype.datatype = function(_p) {
	if(_p===undefined) {
	    _p = 0;
	}
    var _parentctx = this._ctx;
    var _parentState = this.state;
    var localctx = new DatatypeContext(this, this._ctx, _parentState);
    var _prevctx = localctx;
    var _startState = 100;
    this.enterRecursionRule(localctx, 100, DataflowParser.RULE_datatype, _p);
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 598;
        this._errHandler.sync(this);
        switch(this._input.LA(1)) {
        case DataflowParser.OPEN_SQ:
            localctx = new MapTypeContext(this, localctx);
            this._ctx = localctx;
            _prevctx = localctx;

            this.state = 590;
            this.match(DataflowParser.OPEN_SQ);
            this.state = 591;
            localctx.mapKey = this.datatype(0);
            this.state = 592;
            this.match(DataflowParser.COMMA);
            this.state = 593;
            localctx.mapValue = this.datatype(0);
            this.state = 594;
            this.match(DataflowParser.CLOSE_SQ);
            break;
        case DataflowParser.INTEGER:
        case DataflowParser.SHORT:
        case DataflowParser.LONG:
        case DataflowParser.DOUBLE:
        case DataflowParser.FLOAT:
        case DataflowParser.DECIMAL:
        case DataflowParser.BOOLEAN:
        case DataflowParser.STRING:
        case DataflowParser.TIMESTAMP:
        case DataflowParser.DATE:
        case DataflowParser.BYTE:
        case DataflowParser.BINARY:
        case DataflowParser.INTEGRAL:
        case DataflowParser.NUMBER:
        case DataflowParser.FRACTIONAL:
        case DataflowParser.ANY_SIMPLE:
            localctx = new SimpleTypeContext(this, localctx);
            this._ctx = localctx;
            _prevctx = localctx;
            this.state = 596;
            this.simple();
            break;
        case DataflowParser.OPEN_PAREN:
            localctx = new ComplexTypeContext(this, localctx);
            this._ctx = localctx;
            _prevctx = localctx;
            this.state = 597;
            this.complex();
            break;
        default:
            throw new antlr4.error.NoViableAltException(this);
        }
        this._ctx.stop = this._input.LT(-1);
        this.state = 604;
        this._errHandler.sync(this);
        var _alt = this._interp.adaptivePredict(this._input,51,this._ctx)
        while(_alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER) {
            if(_alt===1) {
                if(this._parseListeners!==null) {
                    this.triggerExitRuleEvent();
                }
                _prevctx = localctx;
                localctx = new ArrayTypeContext(this, new DatatypeContext(this, _parentctx, _parentState));
                this.pushNewRecursionContext(localctx, _startState, DataflowParser.RULE_datatype);
                this.state = 600;
                if (!( this.precpred(this._ctx, 4))) {
                    throw new antlr4.error.FailedPredicateException(this, "this.precpred(this._ctx, 4)");
                }
                this.state = 601;
                this.match(DataflowParser.OPEN_CLOSE_SQ); 
            }
            this.state = 606;
            this._errHandler.sync(this);
            _alt = this._interp.adaptivePredict(this._input,51,this._ctx);
        }

    } catch( error) {
        if(error instanceof antlr4.error.RecognitionException) {
	        localctx.exception = error;
	        this._errHandler.reportError(this, error);
	        this._errHandler.recover(this, error);
	    } else {
	    	throw error;
	    }
    } finally {
        this.unrollRecursionContexts(_parentctx)
    }
    return localctx;
};


function ParameterDefinitionContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = DataflowParser.RULE_parameterDefinition;
    return this;
}

ParameterDefinitionContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
ParameterDefinitionContext.prototype.constructor = ParameterDefinitionContext;

ParameterDefinitionContext.prototype.parameter = function() {
    return this.getTypedRuleContext(ParameterContext,0);
};

ParameterDefinitionContext.prototype.AS = function() {
    return this.getToken(DataflowParser.AS, 0);
};

ParameterDefinitionContext.prototype.datatype = function() {
    return this.getTypedRuleContext(DatatypeContext,0);
};

ParameterDefinitionContext.prototype.expression = function() {
    return this.getTypedRuleContext(ExpressionContext,0);
};

ParameterDefinitionContext.prototype.enterRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.enterParameterDefinition(this);
	}
};

ParameterDefinitionContext.prototype.exitRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.exitParameterDefinition(this);
	}
};

ParameterDefinitionContext.prototype.accept = function(visitor) {
    if ( visitor instanceof DataflowParserVisitor ) {
        return visitor.visitParameterDefinition(this);
    } else {
        return visitor.visitChildren(this);
    }
};




DataflowParser.ParameterDefinitionContext = ParameterDefinitionContext;

DataflowParser.prototype.parameterDefinition = function() {

    var localctx = new ParameterDefinitionContext(this, this._ctx, this.state);
    this.enterRule(localctx, 102, DataflowParser.RULE_parameterDefinition);
    var _la = 0; // Token type
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 607;
        this.parameter();
        this.state = 608;
        this.match(DataflowParser.AS);
        this.state = 609;
        this.datatype(0);
        this.state = 611;
        this._errHandler.sync(this);
        _la = this._input.LA(1);
        if((((_la) & ~0x1f) == 0 && ((1 << _la) & ((1 << DataflowParser.DECIMAL_LITERAL) | (1 << DataflowParser.HEX_LITERAL) | (1 << DataflowParser.OCT_LITERAL) | (1 << DataflowParser.BINARY_LITERAL) | (1 << DataflowParser.MINUS) | (1 << DataflowParser.NOT) | (1 << DataflowParser.DOLLAR) | (1 << DataflowParser.TILDA) | (1 << DataflowParser.COLON) | (1 << DataflowParser.OPEN_PAREN))) !== 0) || ((((_la - 33)) & ~0x1f) == 0 && ((1 << (_la - 33)) & ((1 << (DataflowParser.HASH - 33)) | (1 << (DataflowParser.OPEN_SQ - 33)) | (1 << (DataflowParser.OPEN_STRUCT - 33)) | (1 << (DataflowParser.OPEN_CLOSE_SQ - 33)) | (1 << (DataflowParser.FLOAT_LITERAL - 33)) | (1 << (DataflowParser.HEX_FLOAT_LITERAL - 33)) | (1 << (DataflowParser.STRING_LITERAL - 33)) | (1 << (DataflowParser.REGEX_LITERAL - 33)) | (1 << (DataflowParser.PARAMETERS - 33)) | (1 << (DataflowParser.FUNCTIONS - 33)) | (1 << (DataflowParser.AS - 33)) | (1 << (DataflowParser.INPUT - 33)) | (1 << (DataflowParser.OUTPUT - 33)) | (1 << (DataflowParser.CONSTANT - 33)) | (1 << (DataflowParser.EXPRESSION - 33)) | (1 << (DataflowParser.INTEGER - 33)) | (1 << (DataflowParser.SHORT - 33)) | (1 << (DataflowParser.LONG - 33)) | (1 << (DataflowParser.DOUBLE - 33)) | (1 << (DataflowParser.FLOAT - 33)) | (1 << (DataflowParser.DECIMAL - 33)))) !== 0) || ((((_la - 65)) & ~0x1f) == 0 && ((1 << (_la - 65)) & ((1 << (DataflowParser.BOOLEAN - 65)) | (1 << (DataflowParser.TIMESTAMP - 65)) | (1 << (DataflowParser.DATE - 65)) | (1 << (DataflowParser.BYTE - 65)) | (1 << (DataflowParser.BINARY - 65)) | (1 << (DataflowParser.INTEGRAL - 65)) | (1 << (DataflowParser.NUMBER - 65)) | (1 << (DataflowParser.FRACTIONAL - 65)) | (1 << (DataflowParser.ANY_SIMPLE - 65)) | (1 << (DataflowParser.IDENTIFIER - 65)) | (1 << (DataflowParser.ANY_IDENTIFIER - 65)) | (1 << (DataflowParser.META_MATCH - 65)) | (1 << (DataflowParser.META_VARIABLE - 65)) | (1 << (DataflowParser.META_POS - 65)) | (1 << (DataflowParser.OPEN_INTERPOLATE - 65)) | (1 << (DataflowParser.COMMENT - 65)) | (1 << (DataflowParser.ANNOTATION_META_HEAD - 65)) | (1 << (DataflowParser.ANNOTATION_GROUP - 65)))) !== 0)) {
            this.state = 610;
            this.expression(0);
        }

    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};


function DataFormatContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = DataflowParser.RULE_dataFormat;
    return this;
}

DataFormatContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
DataFormatContext.prototype.constructor = DataFormatContext;


 
DataFormatContext.prototype.copyFrom = function(ctx) {
    antlr4.ParserRuleContext.prototype.copyFrom.call(this, ctx);
};


function OneFormatContext(parser, ctx) {
	DataFormatContext.call(this, parser);
    DataFormatContext.prototype.copyFrom.call(this, ctx);
    return this;
}

OneFormatContext.prototype = Object.create(DataFormatContext.prototype);
OneFormatContext.prototype.constructor = OneFormatContext;

DataflowParser.OneFormatContext = OneFormatContext;

OneFormatContext.prototype.format_literal = function() {
    return this.getTypedRuleContext(Format_literalContext,0);
};
OneFormatContext.prototype.enterRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.enterOneFormat(this);
	}
};

OneFormatContext.prototype.exitRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.exitOneFormat(this);
	}
};

OneFormatContext.prototype.accept = function(visitor) {
    if ( visitor instanceof DataflowParserVisitor ) {
        return visitor.visitOneFormat(this);
    } else {
        return visitor.visitChildren(this);
    }
};


function ManyFormatsContext(parser, ctx) {
	DataFormatContext.call(this, parser);
    DataFormatContext.prototype.copyFrom.call(this, ctx);
    return this;
}

ManyFormatsContext.prototype = Object.create(DataFormatContext.prototype);
ManyFormatsContext.prototype.constructor = ManyFormatsContext;

DataflowParser.ManyFormatsContext = ManyFormatsContext;

ManyFormatsContext.prototype.OPEN_SQ = function() {
    return this.getToken(DataflowParser.OPEN_SQ, 0);
};

ManyFormatsContext.prototype.format_literal = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(Format_literalContext);
    } else {
        return this.getTypedRuleContext(Format_literalContext,i);
    }
};

ManyFormatsContext.prototype.CLOSE_SQ = function() {
    return this.getToken(DataflowParser.CLOSE_SQ, 0);
};

ManyFormatsContext.prototype.COMMA = function(i) {
	if(i===undefined) {
		i = null;
	}
    if(i===null) {
        return this.getTokens(DataflowParser.COMMA);
    } else {
        return this.getToken(DataflowParser.COMMA, i);
    }
};

ManyFormatsContext.prototype.enterRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.enterManyFormats(this);
	}
};

ManyFormatsContext.prototype.exitRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.exitManyFormats(this);
	}
};

ManyFormatsContext.prototype.accept = function(visitor) {
    if ( visitor instanceof DataflowParserVisitor ) {
        return visitor.visitManyFormats(this);
    } else {
        return visitor.visitChildren(this);
    }
};



DataflowParser.DataFormatContext = DataFormatContext;

DataflowParser.prototype.dataFormat = function() {

    var localctx = new DataFormatContext(this, this._ctx, this.state);
    this.enterRule(localctx, 104, DataflowParser.RULE_dataFormat);
    var _la = 0; // Token type
    try {
        this.state = 625;
        this._errHandler.sync(this);
        switch(this._input.LA(1)) {
        case DataflowParser.STRING_LITERAL:
            localctx = new OneFormatContext(this, localctx);
            this.enterOuterAlt(localctx, 1);
            this.state = 613;
            this.format_literal();
            break;
        case DataflowParser.OPEN_SQ:
            localctx = new ManyFormatsContext(this, localctx);
            this.enterOuterAlt(localctx, 2);
            this.state = 614;
            this.match(DataflowParser.OPEN_SQ);
            this.state = 615;
            this.format_literal();
            this.state = 620;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            while(_la===DataflowParser.COMMA) {
                this.state = 616;
                this.match(DataflowParser.COMMA);
                this.state = 617;
                this.format_literal();
                this.state = 622;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
            }
            this.state = 623;
            this.match(DataflowParser.CLOSE_SQ);
            break;
        default:
            throw new antlr4.error.NoViableAltException(this);
        }
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};


function InlineDatatypeContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = DataflowParser.RULE_inlineDatatype;
    return this;
}

InlineDatatypeContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
InlineDatatypeContext.prototype.constructor = InlineDatatypeContext;

InlineDatatypeContext.prototype.datatype = function() {
    return this.getTypedRuleContext(DatatypeContext,0);
};

InlineDatatypeContext.prototype.dataFormat = function() {
    return this.getTypedRuleContext(DataFormatContext,0);
};

InlineDatatypeContext.prototype.enterRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.enterInlineDatatype(this);
	}
};

InlineDatatypeContext.prototype.exitRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.exitInlineDatatype(this);
	}
};

InlineDatatypeContext.prototype.accept = function(visitor) {
    if ( visitor instanceof DataflowParserVisitor ) {
        return visitor.visitInlineDatatype(this);
    } else {
        return visitor.visitChildren(this);
    }
};




DataflowParser.InlineDatatypeContext = InlineDatatypeContext;

DataflowParser.prototype.inlineDatatype = function() {

    var localctx = new InlineDatatypeContext(this, this._ctx, this.state);
    this.enterRule(localctx, 106, DataflowParser.RULE_inlineDatatype);
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 627;
        this.datatype(0);
        this.state = 629;
        this._errHandler.sync(this);
        var la_ = this._interp.adaptivePredict(this._input,55,this._ctx);
        if(la_===1) {
            this.state = 628;
            this.dataFormat();

        }
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};


function ExternalDatatypeContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = DataflowParser.RULE_externalDatatype;
    return this;
}

ExternalDatatypeContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
ExternalDatatypeContext.prototype.constructor = ExternalDatatypeContext;

ExternalDatatypeContext.prototype.OPEN_TYPEOF = function() {
    return this.getToken(DataflowParser.OPEN_TYPEOF, 0);
};

ExternalDatatypeContext.prototype.expression = function() {
    return this.getTypedRuleContext(ExpressionContext,0);
};

ExternalDatatypeContext.prototype.CLOSE_PAREN = function() {
    return this.getToken(DataflowParser.CLOSE_PAREN, 0);
};

ExternalDatatypeContext.prototype.enterRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.enterExternalDatatype(this);
	}
};

ExternalDatatypeContext.prototype.exitRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.exitExternalDatatype(this);
	}
};

ExternalDatatypeContext.prototype.accept = function(visitor) {
    if ( visitor instanceof DataflowParserVisitor ) {
        return visitor.visitExternalDatatype(this);
    } else {
        return visitor.visitChildren(this);
    }
};




DataflowParser.ExternalDatatypeContext = ExternalDatatypeContext;

DataflowParser.prototype.externalDatatype = function() {

    var localctx = new ExternalDatatypeContext(this, this._ctx, this.state);
    this.enterRule(localctx, 108, DataflowParser.RULE_externalDatatype);
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 631;
        this.match(DataflowParser.OPEN_TYPEOF);
        this.state = 632;
        this.expression(0);
        this.state = 633;
        this.match(DataflowParser.CLOSE_PAREN);
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};


function ColumnDefinitionContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = DataflowParser.RULE_columnDefinition;
    return this;
}

ColumnDefinitionContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
ColumnDefinitionContext.prototype.constructor = ColumnDefinitionContext;

ColumnDefinitionContext.prototype.columnIdentifier = function() {
    return this.getTypedRuleContext(ColumnIdentifierContext,0);
};

ColumnDefinitionContext.prototype.AS = function() {
    return this.getToken(DataflowParser.AS, 0);
};

ColumnDefinitionContext.prototype.inlineDatatype = function() {
    return this.getTypedRuleContext(InlineDatatypeContext,0);
};

ColumnDefinitionContext.prototype.externalDatatype = function() {
    return this.getTypedRuleContext(ExternalDatatypeContext,0);
};

ColumnDefinitionContext.prototype.enterRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.enterColumnDefinition(this);
	}
};

ColumnDefinitionContext.prototype.exitRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.exitColumnDefinition(this);
	}
};

ColumnDefinitionContext.prototype.accept = function(visitor) {
    if ( visitor instanceof DataflowParserVisitor ) {
        return visitor.visitColumnDefinition(this);
    } else {
        return visitor.visitChildren(this);
    }
};




DataflowParser.ColumnDefinitionContext = ColumnDefinitionContext;

DataflowParser.prototype.columnDefinition = function() {

    var localctx = new ColumnDefinitionContext(this, this._ctx, this.state);
    this.enterRule(localctx, 110, DataflowParser.RULE_columnDefinition);
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 635;
        this.columnIdentifier();
        this.state = 636;
        this.match(DataflowParser.AS);
        this.state = 639;
        this._errHandler.sync(this);
        switch(this._input.LA(1)) {
        case DataflowParser.OPEN_PAREN:
        case DataflowParser.OPEN_SQ:
        case DataflowParser.INTEGER:
        case DataflowParser.SHORT:
        case DataflowParser.LONG:
        case DataflowParser.DOUBLE:
        case DataflowParser.FLOAT:
        case DataflowParser.DECIMAL:
        case DataflowParser.BOOLEAN:
        case DataflowParser.STRING:
        case DataflowParser.TIMESTAMP:
        case DataflowParser.DATE:
        case DataflowParser.BYTE:
        case DataflowParser.BINARY:
        case DataflowParser.INTEGRAL:
        case DataflowParser.NUMBER:
        case DataflowParser.FRACTIONAL:
        case DataflowParser.ANY_SIMPLE:
            this.state = 637;
            this.inlineDatatype();
            break;
        case DataflowParser.OPEN_TYPEOF:
            this.state = 638;
            this.externalDatatype();
            break;
        default:
            throw new antlr4.error.NoViableAltException(this);
        }
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};


function ParametersContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = DataflowParser.RULE_parameters;
    return this;
}

ParametersContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
ParametersContext.prototype.constructor = ParametersContext;

ParametersContext.prototype.PARAMETERS = function() {
    return this.getToken(DataflowParser.PARAMETERS, 0);
};

ParametersContext.prototype.OPEN_CURLY = function() {
    return this.getToken(DataflowParser.OPEN_CURLY, 0);
};

ParametersContext.prototype.parameterDefinition = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(ParameterDefinitionContext);
    } else {
        return this.getTypedRuleContext(ParameterDefinitionContext,i);
    }
};

ParametersContext.prototype.CLOSE_CURLY = function() {
    return this.getToken(DataflowParser.CLOSE_CURLY, 0);
};

ParametersContext.prototype.COMMA = function(i) {
	if(i===undefined) {
		i = null;
	}
    if(i===null) {
        return this.getTokens(DataflowParser.COMMA);
    } else {
        return this.getToken(DataflowParser.COMMA, i);
    }
};


ParametersContext.prototype.enterRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.enterParameters(this);
	}
};

ParametersContext.prototype.exitRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.exitParameters(this);
	}
};

ParametersContext.prototype.accept = function(visitor) {
    if ( visitor instanceof DataflowParserVisitor ) {
        return visitor.visitParameters(this);
    } else {
        return visitor.visitChildren(this);
    }
};




DataflowParser.ParametersContext = ParametersContext;

DataflowParser.prototype.parameters = function() {

    var localctx = new ParametersContext(this, this._ctx, this.state);
    this.enterRule(localctx, 112, DataflowParser.RULE_parameters);
    var _la = 0; // Token type
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 641;
        this.match(DataflowParser.PARAMETERS);
        this.state = 642;
        this.match(DataflowParser.OPEN_CURLY);
        this.state = 643;
        this.parameterDefinition();
        this.state = 648;
        this._errHandler.sync(this);
        _la = this._input.LA(1);
        while(_la===DataflowParser.COMMA) {
            this.state = 644;
            this.match(DataflowParser.COMMA);
            this.state = 645;
            this.parameterDefinition();
            this.state = 650;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
        }
        this.state = 651;
        this.match(DataflowParser.CLOSE_CURLY);
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};


function FunctionDefinitionContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = DataflowParser.RULE_functionDefinition;
    this.fnName = null; // BasicNameContext
    this.ret = null; // DatatypeContext
    return this;
}

FunctionDefinitionContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
FunctionDefinitionContext.prototype.constructor = FunctionDefinitionContext;

FunctionDefinitionContext.prototype.OPEN_PAREN = function() {
    return this.getToken(DataflowParser.OPEN_PAREN, 0);
};

FunctionDefinitionContext.prototype.CLOSE_PAREN = function() {
    return this.getToken(DataflowParser.CLOSE_PAREN, 0);
};

FunctionDefinitionContext.prototype.AS = function() {
    return this.getToken(DataflowParser.AS, 0);
};

FunctionDefinitionContext.prototype.basicName = function() {
    return this.getTypedRuleContext(BasicNameContext,0);
};

FunctionDefinitionContext.prototype.datatype = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(DatatypeContext);
    } else {
        return this.getTypedRuleContext(DatatypeContext,i);
    }
};

FunctionDefinitionContext.prototype.extension_literal = function() {
    return this.getTypedRuleContext(Extension_literalContext,0);
};

FunctionDefinitionContext.prototype.ASSIGN = function() {
    return this.getToken(DataflowParser.ASSIGN, 0);
};

FunctionDefinitionContext.prototype.expression = function() {
    return this.getTypedRuleContext(ExpressionContext,0);
};

FunctionDefinitionContext.prototype.COMMA = function(i) {
	if(i===undefined) {
		i = null;
	}
    if(i===null) {
        return this.getTokens(DataflowParser.COMMA);
    } else {
        return this.getToken(DataflowParser.COMMA, i);
    }
};


FunctionDefinitionContext.prototype.enterRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.enterFunctionDefinition(this);
	}
};

FunctionDefinitionContext.prototype.exitRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.exitFunctionDefinition(this);
	}
};

FunctionDefinitionContext.prototype.accept = function(visitor) {
    if ( visitor instanceof DataflowParserVisitor ) {
        return visitor.visitFunctionDefinition(this);
    } else {
        return visitor.visitChildren(this);
    }
};




DataflowParser.FunctionDefinitionContext = FunctionDefinitionContext;

DataflowParser.prototype.functionDefinition = function() {

    var localctx = new FunctionDefinitionContext(this, this._ctx, this.state);
    this.enterRule(localctx, 114, DataflowParser.RULE_functionDefinition);
    var _la = 0; // Token type
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 653;
        localctx.fnName = this.basicName();
        this.state = 654;
        this.match(DataflowParser.OPEN_PAREN);
        this.state = 663;
        this._errHandler.sync(this);
        _la = this._input.LA(1);
        if(((((_la - 31)) & ~0x1f) == 0 && ((1 << (_la - 31)) & ((1 << (DataflowParser.OPEN_PAREN - 31)) | (1 << (DataflowParser.OPEN_SQ - 31)) | (1 << (DataflowParser.INTEGER - 31)) | (1 << (DataflowParser.SHORT - 31)) | (1 << (DataflowParser.LONG - 31)) | (1 << (DataflowParser.DOUBLE - 31)))) !== 0) || ((((_la - 63)) & ~0x1f) == 0 && ((1 << (_la - 63)) & ((1 << (DataflowParser.FLOAT - 63)) | (1 << (DataflowParser.DECIMAL - 63)) | (1 << (DataflowParser.BOOLEAN - 63)) | (1 << (DataflowParser.STRING - 63)) | (1 << (DataflowParser.TIMESTAMP - 63)) | (1 << (DataflowParser.DATE - 63)) | (1 << (DataflowParser.BYTE - 63)) | (1 << (DataflowParser.BINARY - 63)) | (1 << (DataflowParser.INTEGRAL - 63)) | (1 << (DataflowParser.NUMBER - 63)) | (1 << (DataflowParser.FRACTIONAL - 63)) | (1 << (DataflowParser.ANY_SIMPLE - 63)))) !== 0)) {
            this.state = 655;
            this.datatype(0);
            this.state = 660;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            while(_la===DataflowParser.COMMA) {
                this.state = 656;
                this.match(DataflowParser.COMMA);
                this.state = 657;
                this.datatype(0);
                this.state = 662;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
            }
        }

        this.state = 665;
        this.match(DataflowParser.CLOSE_PAREN);
        this.state = 666;
        this.match(DataflowParser.AS);
        this.state = 667;
        localctx.ret = this.datatype(0);
        this.state = 671;
        this._errHandler.sync(this);
        switch(this._input.LA(1)) {
        case DataflowParser.ASSIGN:
            this.state = 668;
            this.match(DataflowParser.ASSIGN);
            this.state = 669;
            this.expression(0);
            break;
        case DataflowParser.STRING_LITERAL:
            this.state = 670;
            this.extension_literal();
            break;
        default:
            throw new antlr4.error.NoViableAltException(this);
        }
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};


function FunctionsContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = DataflowParser.RULE_functions;
    return this;
}

FunctionsContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
FunctionsContext.prototype.constructor = FunctionsContext;

FunctionsContext.prototype.FUNCTIONS = function() {
    return this.getToken(DataflowParser.FUNCTIONS, 0);
};

FunctionsContext.prototype.OPEN_CURLY = function() {
    return this.getToken(DataflowParser.OPEN_CURLY, 0);
};

FunctionsContext.prototype.functionDefinition = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(FunctionDefinitionContext);
    } else {
        return this.getTypedRuleContext(FunctionDefinitionContext,i);
    }
};

FunctionsContext.prototype.CLOSE_CURLY = function() {
    return this.getToken(DataflowParser.CLOSE_CURLY, 0);
};

FunctionsContext.prototype.COMMA = function(i) {
	if(i===undefined) {
		i = null;
	}
    if(i===null) {
        return this.getTokens(DataflowParser.COMMA);
    } else {
        return this.getToken(DataflowParser.COMMA, i);
    }
};


FunctionsContext.prototype.enterRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.enterFunctions(this);
	}
};

FunctionsContext.prototype.exitRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.exitFunctions(this);
	}
};

FunctionsContext.prototype.accept = function(visitor) {
    if ( visitor instanceof DataflowParserVisitor ) {
        return visitor.visitFunctions(this);
    } else {
        return visitor.visitChildren(this);
    }
};




DataflowParser.FunctionsContext = FunctionsContext;

DataflowParser.prototype.functions = function() {

    var localctx = new FunctionsContext(this, this._ctx, this.state);
    this.enterRule(localctx, 116, DataflowParser.RULE_functions);
    var _la = 0; // Token type
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 673;
        this.match(DataflowParser.FUNCTIONS);
        this.state = 674;
        this.match(DataflowParser.OPEN_CURLY);
        this.state = 675;
        this.functionDefinition();
        this.state = 680;
        this._errHandler.sync(this);
        _la = this._input.LA(1);
        while(_la===DataflowParser.COMMA) {
            this.state = 676;
            this.match(DataflowParser.COMMA);
            this.state = 677;
            this.functionDefinition();
            this.state = 682;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
        }
        this.state = 683;
        this.match(DataflowParser.CLOSE_CURLY);
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};


function DataflowContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = DataflowParser.RULE_dataflow;
    return this;
}

DataflowContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
DataflowContext.prototype.constructor = DataflowContext;

DataflowContext.prototype.functions = function() {
    return this.getTypedRuleContext(FunctionsContext,0);
};

DataflowContext.prototype.parameters = function() {
    return this.getTypedRuleContext(ParametersContext,0);
};

DataflowContext.prototype.flowStatement = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(FlowStatementContext);
    } else {
        return this.getTypedRuleContext(FlowStatementContext,i);
    }
};

DataflowContext.prototype.enterRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.enterDataflow(this);
	}
};

DataflowContext.prototype.exitRule = function(listener) {
    if(listener instanceof DataflowParserListener ) {
        listener.exitDataflow(this);
	}
};

DataflowContext.prototype.accept = function(visitor) {
    if ( visitor instanceof DataflowParserVisitor ) {
        return visitor.visitDataflow(this);
    } else {
        return visitor.visitChildren(this);
    }
};




DataflowParser.DataflowContext = DataflowContext;

DataflowParser.prototype.dataflow = function() {

    var localctx = new DataflowContext(this, this._ctx, this.state);
    this.enterRule(localctx, 118, DataflowParser.RULE_dataflow);
    var _la = 0; // Token type
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 686;
        this._errHandler.sync(this);
        var la_ = this._interp.adaptivePredict(this._input,62,this._ctx);
        if(la_===1) {
            this.state = 685;
            this.functions();

        }
        this.state = 689;
        this._errHandler.sync(this);
        var la_ = this._interp.adaptivePredict(this._input,63,this._ctx);
        if(la_===1) {
            this.state = 688;
            this.parameters();

        }
        this.state = 694;
        this._errHandler.sync(this);
        _la = this._input.LA(1);
        while(((((_la - 52)) & ~0x1f) == 0 && ((1 << (_la - 52)) & ((1 << (DataflowParser.PARAMETERS - 52)) | (1 << (DataflowParser.FUNCTIONS - 52)) | (1 << (DataflowParser.AS - 52)) | (1 << (DataflowParser.INPUT - 52)) | (1 << (DataflowParser.OUTPUT - 52)) | (1 << (DataflowParser.CONSTANT - 52)) | (1 << (DataflowParser.EXPRESSION - 52)) | (1 << (DataflowParser.INTEGER - 52)) | (1 << (DataflowParser.SHORT - 52)) | (1 << (DataflowParser.LONG - 52)) | (1 << (DataflowParser.DOUBLE - 52)) | (1 << (DataflowParser.FLOAT - 52)) | (1 << (DataflowParser.DECIMAL - 52)) | (1 << (DataflowParser.BOOLEAN - 52)) | (1 << (DataflowParser.TIMESTAMP - 52)) | (1 << (DataflowParser.DATE - 52)) | (1 << (DataflowParser.BYTE - 52)) | (1 << (DataflowParser.BINARY - 52)) | (1 << (DataflowParser.INTEGRAL - 52)) | (1 << (DataflowParser.NUMBER - 52)) | (1 << (DataflowParser.FRACTIONAL - 52)) | (1 << (DataflowParser.ANY_SIMPLE - 52)) | (1 << (DataflowParser.IDENTIFIER - 52)))) !== 0) || _la===DataflowParser.ANNOTATION_META_HEAD || _la===DataflowParser.ANNOTATION_GROUP) {
            this.state = 691;
            this.flowStatement();
            this.state = 696;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
        }
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};


DataflowParser.prototype.sempred = function(localctx, ruleIndex, predIndex) {
	switch(ruleIndex) {
	case 28:
			return this.expression_sempred(localctx, predIndex);
	case 50:
			return this.datatype_sempred(localctx, predIndex);
    default:
        throw "No predicate with index:" + ruleIndex;
   }
};

DataflowParser.prototype.expression_sempred = function(localctx, predIndex) {
	switch(predIndex) {
		case 0:
			return this.precpred(this._ctx, 26);
		case 1:
			return this.precpred(this._ctx, 25);
		case 2:
			return this.precpred(this._ctx, 24);
		case 3:
			return this.precpred(this._ctx, 23);
		case 4:
			return this.precpred(this._ctx, 22);
		case 5:
			return this.precpred(this._ctx, 21);
		case 6:
			return this.precpred(this._ctx, 20);
		case 7:
			return this.precpred(this._ctx, 31);
		case 8:
			return this.precpred(this._ctx, 30);
		case 9:
			return this.precpred(this._ctx, 27);
		case 10:
			return this.precpred(this._ctx, 1);
		default:
			throw "No predicate with index:" + predIndex;
	}
};

DataflowParser.prototype.datatype_sempred = function(localctx, predIndex) {
	switch(predIndex) {
		case 11:
			return this.precpred(this._ctx, 4);
		default:
			throw "No predicate with index:" + predIndex;
	}
};


exports.DataflowParser = DataflowParser;
